(function () {
  'use strict';

  var pages = [
      'ui.router',
      'InovaceClientApp.pages.auth',
      'InovaceClientApp.pages.main',
  ];

  angular.module('InovaceClientApp.pages', pages)
      .config(['$urlRouterProvider', '$httpProvider', '$stateProvider', routeConfig])
      .run(['$state', '$transitions', '$rootScope', 'authService', 'toastr', onRun]);

  /** @ngInject */
  function routeConfig($urlRouterProvider, $httpProvider, $stateProvider) {
    $urlRouterProvider.otherwise('/dashboard');
    $httpProvider.interceptors.push('httpInterceptor');
  }
  //
  function onRun($state, $transitions, $rootScope, authService, toastr) {

      $transitions.onBefore({
          to: function (state) {
              return state.name != 'login';
          }
      }, function (trans) {
          // console.log("trans.to : " + JSON.stringify(trans.to().title));
          $rootScope.title = trans.to().title;
          if (!authService.isAuthenticated()) {
              return $state.target("login");
          } else {
              if(!$rootScope.loggedInUser){
                  $rootScope.loggedInUser = authService.getLoggedInUser();
              }
              if(trans.to().generalUserPermitted && trans.to().generalUserPermitted===true) return true;
              // if( !authService.isAdmin() ) return $state.target("dashboard");
          }
      });

      $rootScope.$on('unauthorized', function(){
          console.log("unauthorized event");
          authService.clearSession();
          $state.transitionTo('login');
          toastr.error('Your session has expired! Please sign in again!','Session Expired!', {
              "autoDismiss": false,
              "positionClass": "toast-top-right",
              "type": "error",
              "timeOut": "5000",
              "extendedTimeOut": "2000",
              "allowHtml": false,
              "closeButton": false,
              "tapToDismiss": true,
              "progressBar": false,
              "newestOnTop": true,
              "maxOpened": 0,
              "preventDuplicates": false,
              "preventOpenDuplicates": false
          });
      });
      $rootScope.$on('server-down', function(){
          console.log("server down event");
          authService.clearSession();
          $state.transitionTo('login');
          toastr.error('Please try again later!','Server problem!', {
              "autoDismiss": false,
              "positionClass": "toast-top-right",
              "type": "error",
              "timeOut": "5000",
              "extendedTimeOut": "2000",
              "allowHtml": false,
              "closeButton": false,
              "tapToDismiss": true,
              "progressBar": false,
              "newestOnTop": true,
              "maxOpened": 0,
              "preventDuplicates": false,
              "preventOpenDuplicates": false
          });
      });
      $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
          console.log("state change error event");
          // this is required if you want to prevent the $UrlRouter reverting the URL to the previous valid location
          event.preventDefault();
          toastr.error('Please try again later!','Server problem!', {
              "autoDismiss": false,
              "positionClass": "toast-top-right",
              "type": "error",
              "timeOut": "5000",
              "extendedTimeOut": "2000",
              "allowHtml": false,
              "closeButton": false,
              "tapToDismiss": true,
              "progressBar": false,
              "newestOnTop": true,
              "maxOpened": 0,
              "preventDuplicates": false,
              "preventOpenDuplicates": false
          });
          $state.go('dashboard');
      });


  //
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

(function(){
    'use strict';

    var authStateModules = [
        'ui.router',
        'InovaceClientApp.pages.auth.login',
        'InovaceClientApp.pages.auth.logout'
    ];

    angular.module('InovaceClientApp.pages.auth', authStateModules)
        .config(['$stateProvider' , function ($stateProvider) {
            $stateProvider
                /* public template*/
                .state('public', {
                    url : "",
                    views : {
                        'root' : {
                            templateUrl : 'app/pages/auth/auth.html'
                        }
                    },
                    abstract : true
                })
        }]);
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main', [
        'ui.router',
        'InovaceClientApp.pages.main.dashboard',
        'InovaceClientApp.pages.main.school',
        'InovaceClientApp.pages.main.student',
        'InovaceClientApp.pages.main.teacher',
        'InovaceClientApp.pages.main.leave',
        'InovaceClientApp.pages.main.academics',
        'InovaceClientApp.pages.main.holidays',
        'InovaceClientApp.pages.main.notice',
        'InovaceClientApp.pages.main.educationOffice'
    ]).config(['$stateProvider', 'baSidebarServiceProvider', function ($stateProvider, baSidebarServiceProvider) {
        $stateProvider
        /* public template*/
            .state('app', {
                url: '',
                views : {
                    'root' : {
                        templateUrl: 'app/pages/main/main.html',
                        controller : 'MainCtrl'
                    }
                },
                abstract : true
            });
        baSidebarServiceProvider.addStaticItem({
            title: 'My Profile',
            icon : 'ion-person',
            order: 160,
            stateRef: 'profile'
        });

    }]);
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

(function(){
    'use strict';

    angular.module('InovaceClientApp.pages.auth.login', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('login', {
                url : '/login',
                parent : 'public',
                views : {
                    'pub@public' : {
                        templateUrl : 'app/pages/auth/login/login.html',
                        controller : 'LoginCtrl'
                    }
                },
                title : 'Login',
                generalUserPermitted : true,
            });
    }
})();
(function(){
    'use strict';

    angular.module('InovaceClientApp.pages.auth.logout', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('logout', {
                url: '/logout',
                parent : 'public',
                views : {
                    'pub@public' : {
                        template : '<head><title>Logout - Inovace Attendance Panel</title></head>',
                        controller : 'LogoutCtrl'
                    }
                },
                title: 'Logout',
                generalUserPermitted : true,
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.academics',[
            'InovaceClientApp.pages.main.academics.shift',
            'InovaceClientApp.pages.main.academics.section',
            'InovaceClientApp.pages.main.academics.class'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('academics', {
                url: '/academics',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="academics" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'ACADEMICS',
                /*sidebarMeta: {
                    icon : 'ion-settings',
                    order: 30
                }*/
            });
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('InovaceClientApp.pages.main.dashboard', ['ui.select', 'easypiechart', 'ui.carousel' ])
      .config(['$stateProvider' , routeConfig]);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
            url: '/dashboard',
            parent : 'app',
            views : {
                'app' : {
                    templateUrl: 'app/pages/main/dashboard/dashboard.html',
                    controller : 'DashboardCtrl',
                    controllerAs : 'vm'
                }
            },
            title: 'DASHBOARD',
            sidebarMeta: {
                icon: 'ion-speedometer',
                order: 15
            }
        });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.educationOffice', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('createEducationOffice', {
                url: '/education-office/create',
                parent : 'app',
                parentTitle: 'Education Office',
                parentLink: '/education-office',
                title: 'addEducationOffice',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/educationOffice/create/createEducationOffice.html',
                        controller: 'CreateEducationOfficeCtrl',
                        controllerAs: "vm"
                    }
                }
            });
        $stateProvider
            .state('editEducationOffice', {
                url: '/education-office/:educationOfficeId',
                parent : 'app',
                params:{educationOfficeId:null},
                parentTitle: 'Education Office',
                parentLink: '/education-office',
                title: 'editEducationOffice',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/educationOffice/edit/editEducationOffice.html',
                        controller: 'EditEducationOfficeCtrl',
                        controllerAs: "vm"
                    }
                }
            });
        $stateProvider
            .state('educationOffice', {
                url: '/education-office',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/educationOffice/educationOffice.html',
                        controller : 'EducationOfficeCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'EDUCATIONOFFICE',
                sidebarMeta: {
                    icon: 'ion-ios-home-outline',
                    order: 25
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave', [
        'InovaceClientApp.pages.main.leave.applyLeave',
        'InovaceClientApp.pages.main.leave.leaveList'
    ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('leave', {
                url: '/leave',
                abstract : true,
                parent : 'app',
                views : {
                    'app' : {
                        template: '<div ui-view="leave" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                title: 'teacherslLeave',
                sidebarMeta: {
                    icon: 'ion-ios-briefcase-outline',
                    order: 40
                }
            });
    }

})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.holidays',['ngAnimate','toastr','ui.bootstrap', 'ui.bootstrap.tpls','mwl.calendar'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('holidays', {
                url: '/holidays',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/holidays/holidays.html',
                        controller : 'HolidayCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'schoolHolidays',
                sidebarMeta: {
                    icon:'ion-android-calendar',
                    order: 50
                }
            });
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.notice', ['ui.select', 'easypiechart', 'ui.carousel','ngFileUpload', 'ngImgCrop' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('notice', {
                url: '/notice',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/notice/notice.html',
                        controller : 'NoticeCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'notice',
                /*sidebarMeta: {
                    icon: 'ion-clipboard',
                    order: 45
                }*/
            });
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.school', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('createSchool', {
                url: '/school/create',
                parent : 'app',
                parentTitle: 'School',
                parentLink: '/school',
                title: 'addSchool',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/school/create/createSchool.html',
                        controller: 'CreateSchoolCtrl',
                        controllerAs: "vm"
                    }
                }
            });
        $stateProvider
            .state('editSchool', {
                url: '/school/:schoolId',
                parent : 'app',
                params:{schoolId:null},
                parentTitle: 'School',
                parentLink: '/school',
                title: 'editSchool',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/school/edit/editSchool.html',
                        controller: 'EditSchoolCtrl',
                        controllerAs: "vm"
                    }
                }
            });
        $stateProvider
            .state('school', {
                url: '/school',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/school/school.html',
                        controller : 'SchoolCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'SCHOOL',
                sidebarMeta: {
                    icon: 'ion-home',
                    order: 25
                }
            });
    }

})();

/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student', [
        'InovaceClientApp.pages.main.student.studentList',
        'InovaceClientApp.pages.main.student.createStudent',
        'InovaceClientApp.pages.main.student.editStudent',
        'InovaceClientApp.pages.main.student.studentDailyAttendance',
        'InovaceClientApp.pages.main.student.studentMonthlyAttendance'
    ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('student', {
                url: '/student',
                abstract : true,
                parent : 'app',
                views : {
                    'app' : {
                        template: '<div ui-view="student" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                title: 'STUDENTS',
                /*sidebarMeta: {
                    icon: 'ion-android-contact',
                    order: 35
                }*/
            });
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher', [
        'InovaceClientApp.pages.main.teacher.createTeacher',
        'InovaceClientApp.pages.main.teacher.teacherList',
        'InovaceClientApp.pages.main.teacher.editTeacher',
        'InovaceClientApp.pages.main.teacher.teacherDailyAttendance',
        'InovaceClientApp.pages.main.teacher.teacherMonthlyAttendance',
        'InovaceClientApp.pages.main.teacher.batchCreateTeachers'

    ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('teacher', {
                url: '/teacher',
                abstract : true,
                parent : 'app',
                views : {
                    'app' : {
                        template: '<div ui-view="teacher" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                title: 'TEACHERS',
                sidebarMeta: {
                    icon: 'ion-person',
                    order: 40
                }
            });
    }

})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.academics.class',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('academics.class', {
                url: '/class',
                views : {
                    'academics' : {
                        templateUrl:'app/pages/main/academics/class/class.html',
                        controller : 'ClassCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'class',
                sidebarMeta: {
                    icon: 'ion-ios-ionic-outline',
                    order: 35
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.academics.section',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('academics.section', {
                url: '/section',
                views : {
                    'academics' : {
                        templateUrl:'app/pages/main/academics/section/section.html',
                        controller : 'SectionCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'SECTION',
                sidebarMeta: {
                    icon: 'ion-ios-pie-outline',
                    order: 33
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.academics.shift',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('academics.shift', {
                url: '/shift',
                views : {
                    'academics' : {
                        templateUrl:'app/pages/main/academics/shift/shift.html',
                        controller : 'ShiftCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'SHIFT',
                sidebarMeta: {
                    icon: 'ion-ios-time-outline',
                    order: 30
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.applyLeave', ['ui.select', 'daterangepicker' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('leave.applyLeave', {
                url: '/apply',
                views : {
                    'leave' : {
                        templateUrl:'app/pages/main/leave/apply/applyLeave.html',
                        controller : 'ApplyLeaveCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: "addLeave",
                sidebarMeta: {
                    icon: 'ion-ios-medkit-outline',
                    order: 41
                }
            });
    }

})();

/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leaveList', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('leave.leaveList', {
                url: '/list',
                views : {
                    'leave' : {
                        templateUrl:'app/pages/main/leave/list/leaveList.html',
                        controller : 'LeaveListCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'teachersLeaveList',
                sidebarMeta: {
                    icon: 'ion-android-options',
                    order: 42
                }
            });
    }

})();
/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.createStudent', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('student.createStudent', {
                url: '/create',
                views : {
                    'student' : {
                        templateUrl:'app/pages/main/student/create/createStudent.html',
                        controller : 'CreateStudentCtrl',
                        controllerAs : 'vm'
                    }
                },
                parentState:'student.studentList',
                title: 'ADMISSION',
                parentTitle:'',
                sidebarMeta: {
                    icon: 'ion-ios-personadd-outline',
                    order: 36
                }
            });
    }

})();
/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.studentDailyAttendance', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('student.dailyAttendance', {
                url: '/dailyAttendance',
                views : {
                    'student' : {
                        templateUrl:'app/pages/main/student/dailyAttendance/studentDailyAttendance.html',
                        controller : 'StudentDailyAttendanceCtrl',
                        controllerAs : 'vm'
                    }
                },
                parentTitle: 'Student',
                parentState: 'student.studentList',
                title: 'dailyAttendance',
                sidebarMeta: {
                    icon: 'ion-ios-list-outline',
                    order: 38
                }
            });
    }

})();
/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.studentList', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('student.studentList', {
                url: '/list',
                views : {
                    'student' : {
                        templateUrl:'app/pages/main/student/list/studentList.html',
                        controller : 'StudentListCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'allStudents',
                sidebarMeta: {
                    icon: 'ion-ios-people-outline',
                    order: 37
                }
            });

    }

})();
/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.editStudent', ['ui.select','ngFileUpload', 'ngImgCrop' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('student.editStudent', {
                url: '/:studentId',
                // params:{studentId:null},
                views : {
                    'student' : {
                        templateUrl: 'app/pages/main/student/edit/editStudent.html',
                        controller: 'EditStudentCtrl',
                        controllerAs: "vm"
                    }
                },
                parentState:'student.studentList',
                title: 'Edit Student',
                parentTitle: 'Student',
                parentLink: '/student/list',
            });
    }

})();
/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.studentMonthlyAttendance', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('student.monthlyAttendance', {
                url: '/monthlyAttendance',
                views : {
                    'student' : {
                        templateUrl:'app/pages/main/student/monthlyAttendance/studentMonthlyAttendance.html',
                        controller : 'StudentMonthlyAttendanceCtrl',
                        controllerAs : 'vm'
                    }
                },
                parentTitle: 'Student',
                parentState: 'student.studentList',
                title: 'monthlyAttendance',
                sidebarMeta: {
                    icon: 'ion-ios-paper-outline',
                    order: 38
                }
            });
    }

})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.teacher.batchCreateTeachers',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('teacher.batchCreateTeachers', {
                url: '/batchCreateTeachers',
                views : {
                    'teacher' : {
                        templateUrl:'app/pages/main/teacher/batchCreate/batchCreateTeachers.html',
                        controller : 'BatchTeachersCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Batch Create',
                sidebarMeta: {
                    icon: 'ion-ios-folder-outline',
                    order: 78
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.createTeacher', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('teacher.createTeacher', {
                url: '/create',
                views : {
                    'teacher' : {
                        templateUrl:'app/pages/main/teacher/create/createTeacher.html',
                        controller : 'CreateTeacherCtrl',
                        controllerAs : 'vm'
                    }
                },
                parentTitle: 'Teacher',
                parentLink: '/teacher/list',
                title: 'JOIN',
                sidebarMeta: {
                    icon: 'ion-ios-personadd-outline',
                    order: 41
                }
            });
    }

})();
/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.teacherDailyAttendance', ['ui.select'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('teacher.dailyAttendance', {
                url: '/dailyAttendance',
                views : {
                    'teacher' : {
                        templateUrl:'app/pages/main/teacher/dailyAttendance/teacherDailyAttendance.html',
                        controller : 'TeacherDailyAttendanceCtrl',
                        controllerAs : 'vm'
                    }
                },
                params: {
                    schoolId: null
                },
                parentTitle: 'Teacher',
                parentState: 'teacher.teacherList',
                title: 'dailyAttendance',
                sidebarMeta: {
                    icon: 'ion-ios-list-outline',
                    order: 45
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.editTeacher', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('teacher.editTeacher', {
                url: '/:teacherId',
                params:{teacherId:null},
                views : {
                    'teacher' : {
                        templateUrl: 'app/pages/main/teacher/edit/editTeacher.html',
                        controller: 'EditTeacherCtrl',
                        controllerAs: "vm"
                    }
                },
                parentTitle: 'Teacher',
                parentLink: '/teacher/list',
                title: 'editTeacher'
            });
    }

})();
/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.teacherList', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('teacher.teacherList', {
                url: '/list',
                views : {
                    'teacher' : {
                        templateUrl:'app/pages/main/teacher/list/teacherList.html',
                        controller : 'TeacherListCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'allTeachers',
                sidebarMeta: {
                    icon: 'ion-ios-people-outline',
                    order: 42
                }
            });
    }

})();
/**
 * @author k.m.sagar
 * created on 10.02.2019
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.teacherMonthlyAttendance', ['ui.select', 'easypiechart', 'ui.carousel' ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('teacher.monthlyAttendance', {
                url: '/monthlyAttendance',
                views : {
                    'teacher' : {
                        templateUrl:'app/pages/main/teacher/monthlyAttendance/teacherMonthlyAttendance.html',
                        controller : 'TeacherMonthlyAttendanceCtrl',
                        controllerAs : 'vm'
                    }
                },
                parentTitle: 'Teacher',
                parentState: 'teacher.teacherList',
                title: 'monthlyAttendance',
                sidebarMeta: {
                    icon: 'ion-ios-paper-outline',
                    order: 50
                }
            });
    }

})();
'use strict';

var app = angular.module('InovaceClientApp', [
    'pascalprecht.translate',
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'angular-progress-button-styles',
    'ngBootstrap',
    'ui.bootstrap.datetimepicker',
    'BlurAdmin.theme',
    'InovaceClientApp.pages',
    'xeditable',

]);

app.config(['$locationProvider', function ($locationProvider) {
    // enable html5Mode for pushstate ('#'-less URLs)
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
}]);


app.config(['$translateProvider','ENGLISH','BANGLA', function ($translateProvider,englishJson,banglaJson) {
    // add translation table
    $translateProvider.translations('en', englishJson).preferredLanguage('en');
    $translateProvider.translations('bn', banglaJson);
}]);
(function(){
    app.constant('BANGLA', {
        DASHBOARD:'ড্যাশবোর্ড',
        SCHOOL:'বিদ্যালয়',
        SHIFT:'শিফ্ট',
        ACADEMICS:'শ্রেণিসঙ্ক্রান্ত',
        SECTION:'শাখা',
        STUDENTS:'শিক্ষার্থী',
        ADMISSION:'ভর্তি',
        TEACHERS:"শিক্ষক",
        JOIN:'যোগদান',
        HEADLINE : 'বাল',
        EDUCATIONOFFICE : 'শিক্ষা অফিস',
        runningSections:'বর্তমান ক্লাসসমূহ',
        attendanceChart:'উপস্থিতির চার্ট',
        attendanceFeed : 'পর্যায়ক্রমিক উপস্থিতি',
        sl:'SL',
        class:'শ্রেণি',
        total:'মোট',
        totalStudents:'মোট শিক্ষার্থী',
        present:'উপস্থিত',
        absent:'অনুপস্থিত',
        late:'বিলম্বে',
        name:'নাম',
        schoolName:'বিদ্যালয়ের নাম',
        schoolAdminEmail:'বিদ্যালয়ের অ্যাডমিন ইমেল',
        schoolAdminPassword:'বিদ্যালয়ের অ্যাডমিন পাসওয়ার্ড',
        addSchool:'বিদ্যালয় যুক্ত করুন',
        addNewSchool:'নতুন বিদ্যালয় যুক্ত করুন',
        editSchool:'বিদ্যালয় সম্পাদনা',
        editSchoolInfo:'বিদ্যালয়ের তথ্য সম্পাদনা',
        totalStudents:'মোট ছাত্র',
        totalTeachers:'মোট শিক্ষক',
        educationOfficeName: 'শিক্ষা অফিসের নাম',
        educationOfficeAdminEmail:'শিক্ষা অফিসের অ্যাডমিন ইমেল',
        educationOfficeAdminPassword:'শিক্ষা অফিসের অ্যাডমিন পাসওয়ার্ড',
        addEducationOffice:'শিক্ষা অফিস যুক্ত করুন',
        addNewEducationOffice:'নতুন শিক্ষা অফিস যুক্ত করুন',
        editEducationOffice:'শিক্ষা অফিস সম্পাদনা',
        superiorEducationOffice:'ঊর্ধ্বতন শিক্ষা অফিস',
        subordinateEducationOffice:'অধস্তন শিক্ষা অফিস',
        address:'ঠিকানা',
        website:'ওয়েবসাইট',
        district:'জেলা',
        subDistrict:'উপজেলা',
        deviceFirstDisplayText:'যন্ত্রে প্রদর্শিত প্রথম টেক্সট',
        deviceSecondDisplayText:'যন্ত্রে প্রদর্শিত দ্বিতীয় টেক্সট',
        shift:'শিফ্ট',
        shiftFrom:'শুরু',
        shiftTo:'শেষ',
        allShifts:'সকল শিফ্ট',
        status:'অবস্থা',
        active:'সক্রিয়',
        inactive:'নিষ্ক্রিয়',
        selectImage:'ছবি নির্বাচন করুন',
        upload:'আপলোড',
        create:'তৈরী করুন',
        update:'আপডেট  করুন',
        actions:'অপশন',
        allSections:'সকল শাখা',
        createClass:'শ্রেণি তৈরি করুন',
        allClasses:'সকল শ্রেণি',
        configureClass : 'শ্রেণির সমন্বয় তৈরি করুন',
        configuredClasses : 'শ্রেণি সমন্বয়',
        delete:'মুছে ফেলুন',
        studentAdmission:'শিক্ষার্থী ভর্তি',
        studentsPicture:"শিক্ষার্থীর ছবি",
        studentsName:"শিক্ষার্থীর নাম",
        studentProvidedInformation:'শিক্ষার্থী প্রদত্ত তথ্য',
        schoolProvidedInformation:'বিদ্যালয় প্রদত্ত তথ্য',
        gender:'লিঙ্গ',
        religion:'ধর্ম',
        bloodGroup:'রক্তের গ্রুপ',
        dateOfBirth:'জন্মতারিখ',
        birthCertificate:'জন্মসনদ',
        fathersName:"পিতার নাম",
        mothersName:"মাতার নাম",
        guardiansName:"অভিভাবক এর নাম",
        contactNumber:'মোবাইল নম্বর',
        presentAddress:'বর্তমান ঠিকানা',
        permanentAddress:'স্থায়ী ঠিকানা',
        presentSubDistrict:'বর্তমান উপজেলা',
        presentDistrict:'বর্তমান জেলা',
        permanentDistrict:'স্থায়ী জেলা',
        permanentSubDistrict:'স্থায়ী উপজেলা',
        classAllocation:'শ্রেণি ও শাখা',
        year:'বর্ষ',
        rollNumber:'ক্রমিক নং',
        rfid:'RFID',
        allStudents:'সকল শিক্ষার্থী',
        allTeachers:'সকল শিক্ষক',
        picture:'ছবি',
        dailyAttendance:'দৈনিক উপস্থিতি',
        studentDailyAttendance:'শিক্ষার্থীদের দৈনিক উপস্থিতি',
        entryTime:'প্রবেশ',
        exitTime:'বাহির',
        totalHours:'মোট উপস্থিতির সময়',
        studentsInformation:"শিক্ষার্থীর তথ্য",
        monthlyAttendance:'মাসিক উপস্থিতি',
        studentsMonthlyAttendance:"শিক্ষার্থীদের মাসিক উপস্থিতি",
        summary:'সারাংশ',
        section:'শাখা',
        schoolHolidays:'বিদ্যালয়ের ছুটিসমূহ',
        holidayList:'ছুটির তালিকা',
        holidaysInCalendar:'ক্যালেন্ডারে ছুটিসমূহ',
        addNewHoliday:'নতুন ছুটির দিন যোগ করুন',
        title:'শিরনাম',
        date:'তারিখ',
        notice:'নোটিশ',
        createNotice:'নোটিশ তৈরি করুন',
        latestNotice:'সর্বশেষ নোটিশ',
        noticeTitle:'নোটিশের নাম',
        noticeDescription:'নোটিশের বিবরণ',
        publishDate:'প্রকাশের সময়',
        noticeImage:'নোটিশের ছবি',
        uploadStudentImage:'শিক্ষার্থীর ছবি আপলোড করুন',
        uploadNoticeImage:'নোটিশের ছবি আপলোড করুন',
        noticeFiles:'নোটিশের ফাইল',
        downloadLink:'ডাউনলোড করুন',
        teachersInformation:"শিক্ষকের তথ্য",
        teachersMonthlyAttendance:'শিক্ষকদের মাসিক উপস্থিতি',
        teachersDailyAttendance:'শিক্ষকদের দৈনিক উপস্থিতি',
        teacherJoining:'শিক্ষকের যোগদান',
        teachersPicture:"শিক্ষকের ছবি",
        teachersProvidedInformation:'শিক্ষকের প্রদত্ত তথ্য',
        qualificationsAndExperience:'যোগ্যতা এবং অভিজ্ঞতা',
        teachersName:"শিক্ষকের নাম",
        teachersEmail:"শিক্ষকের ইমেইল",
        teachersQualification:"শিক্ষকের যোগ্যতা",
        teachersExperience:"শিক্ষকের অভিজ্ঞতা",
        dateOfJoining:'যোগদানের তারিখ',
        designation:'উপাধি',
        editTeacher:'শিক্ষক সম্পাদনা',
        editTeacherInfo:'শিক্ষক তথ্য সম্পাদনা করুন',
        uploadTeacherImage:'শিক্ষকের ছবি আপলোড করুন',
        allTeachersList:'সকল শিক্ষক তালিকা',
        teacherslLeave:'শিক্ষকদের ছুটি',
        addLeave:"ছুটি যুক্ত করুন",
        addTeachersLeave:"শিক্ষকের ছুটি যুক্ত করুন",
        selectTeacher:"শিক্ষক নির্বাচন করুন",
        description:'বিবরণ',
        teachersLeaveList:"শিক্ষকদের ছুটিসমূহ",
        allLeaveList:'সকল ছুটির তালিকা',
        leaveDescription:'ছুটির বিবরণ',
        startDate:'শুরুর তারিখ',
        endDate:'শেষ তারিখ',
        dateLabel: 'তারিখ',
        monthLabel: 'মাস',
        monthName: 'মাসের নাম',
        affiliatedEducationOffice: 'অধিভুক্ত শিক্ষা অফিস'
    });
}).call(this);
(function(){
    // var apiLink = 'http://localserver.inovacetech.com:90/inovace-client/api/v1';
    // var apiLink = 'http://dev.client.inovacetech.com/inovace-client/api/v1';
    var apiLink = 'https://school.inovacetech.com/inovace-school/api/v1';
    // var apiLink = 'http://172.104.163.127:1990/inovace-school/api/v1';
    //var apiLink = 'http://192.168.1.145:1990/inovace-school/api/v1';
    // var apiLink = 'http://localhost:1990/inovace-school/api/v1';
    // var apiLink = 'http://128.199.255.103:1990/inovace-client/api/v1';
    // var apiLink = 'http://127.0.0.1:1990/inovace-school/api/v1';

    // var env = window.location.hostname.split('.')[0];
    // if(env){
    //     if(env === 'testschool'){
    //         apiLink = 'http://testschool.inovacetech.com/inovace-school/api/v1';
    //     } else if (env === 'www' || env === 'school'){
    //         apiLink = 'http://school.inovacetech.com/inovace-school/api/v1';
    //     } else {
    //         apiLink = 'http://127.0.0.1:1990/inovace-school/api/v1';
    //     }
    // }
    app.constant('API',{
            auth : {
                'signin' : apiLink + '/auth/signin',
                'signout' : apiLink + '/auth/signout'
            },
            school : {
                'getAll' : apiLink+'/school/',
                'dashboard' : apiLink +'/school/dashboard/',
                'batchCreate' : apiLink + '/school/batch-create/',
                'getAllResellers' : apiLink + '/school/resellers/',
                'getAllUnderAnEducationOffice' : apiLink+'/school/subordinate/education-office',
                'dashboardForEducationOffice' : apiLink + '/school/dashboard/education-office/'
            },
            student : {
                'getAll' : apiLink+'/student/',
                'getAStudent' : apiLink+'/student/',
                'uploadPicture' : apiLink+'/student/upload-picture/'
            },
            teacher : {
                'getAll' : apiLink+'/teacher/',
                'getATeacher' : apiLink+'/teacher/',
                'batchCreate' : apiLink + '/teacher/batch-create/',
                'delete' : apiLink + '/teacher/'
            },
            class : {
                'getAll' : apiLink + '/class/',
                'delete' : apiLink + '/class/delete/'
            },
            section : {
                'getAll' : apiLink + '/section/',
                'delete' : apiLink + '/section/delete/'
            },
            shift : {
                'getAll' : apiLink + '/shift/',
                'delete' : apiLink + '/shift/delete/'
            },
            institutionType:{
                'getAll' : apiLink + '/institution-type/'
            },
            assoc : {
                'getAll' : apiLink +'/class-section-shift-association/',
                'delete' : apiLink + '/class-section-shift-association/delete/'
            },
            holiday: {
                'all' : apiLink + '/holiday/',
                'create': apiLink + '/holiday/'
            },
            designation: {
                'all' : apiLink + '/designation/'
            },
            notice: {
                'getAll' : apiLink + '/notice/',
                'create': apiLink + '/notice/',
                'delete' : apiLink + '/notice/delete/'
            },
            attendance: {
                'all' : apiLink + '/attendance/',
                'getAttendanceFeed' : apiLink + '/attendance/attendance-feed/',
                'getStudents' : apiLink + '/attendance/students/',
                'getTeachers' : apiLink + '/attendance/teachers',
                'getTeacherAttendance' : apiLink + '/attendance/teacher-attendance-report'
            },
            scheduledEmployeeCreateRequest : {
                'getAll' : apiLink + '/scheduled-teacher-create-requests/',
                'retry'  : apiLink + '/scheduled-teacher-create-requests/' + 'retry/'
            },
            scheduledSchoolCreateRequest : {
                'getAll' : apiLink + '/scheduled-school-create-requests/',
                'retry'  : apiLink + '/scheduled-school-create-requests/' + 'retry/'
            },
            leave: {
                'apply' : apiLink + '/leave/apply/',
                'getAll' : apiLink + '/leave/',
                'delete' : apiLink + '/leave/',
            },
            educationOffice: {
                'getAll' : apiLink + '/education-office/',
                'getAllForDropDown' : apiLink + '/education-office/drop-down',
                'create' : apiLink + '/education-office/create',
                'update' : apiLink + '/education-office/update/',
                'getAllSubordinateClusters' : apiLink + '/education-office/subordinate-clusters/'
            },
            officeHierarchy: {
                'getAll' : apiLink + '/office-hierarchy/'
            }
    });

    app.constant('aclLevel',{
        value:'office'
    });

    app.constant('CONSTANT',{
        apiLink : 'http://127.0.0.1:1990/inovace-client/api/v1'
    });

    app.constant('TIME_IN_MILLISECOND', {
        'ONE_SECOND' : 1000,
        'ONE_MINUTE' : 60 * 1000,
        'ONE_HOUR' : 60 * 60 * 1000,
        'ONE_DAY' : 24 * 60 * 60 * 1000,
        'SEVEN_DAYS' : 7 * 24 * 60 * 60 * 1000
    });

    app.constant('_', window._);

    app.constant('RESPONSE_CODE',{
        success: 200,
        notFound: 404,
        error: 500
    });
    app.constant('PRINTMEDIABOOTSTRAP',
        {link:"https://s3-ap-southeast-1.amazonaws.com/inovace-client-panel-required-files/bootstrap-without-print-media.css"});

    app.constant('GENDER',[
        "Male",
        "Female",
        "Other"
    ]);
    app.constant('RELIGION',[
        "Islam",
        "Hinduism",
        "Buddhism",
        "Christianity",
        "Other"
    ]);
    app.constant('BLOOD_GROUP',[
        "A+",
        "A-",
        "B+",
        "B-",
        "AB+",
        "AB-",
        "O+",
        "O-"
    ]);
    app.constant('DISTRICT',[
        "Bagerhat",
        "Bandarban",
        "Barguna",
        "Barisal",
        "Bhola",
        "Bogra",
        "Brahmanbaria",
        "Chandpur",
        "Chapai Nawabganj",
        "Chittagong",
        "Chuadanga",
        "Comilla",
        "Cox's Bazar",
        "Dhaka",
        "Dinajpur",
        "Faridpur",
        "Feni",
        "Gaibandha",
        "Gazipur",
        "Gopalganj",
        "Habiganj",
        "Jamalpur",
        "Jessore",
        "Jhalokati",
        "Jhenaidah",
        "Joypurhat",
        "Khagrachhari",
        "Khulna",
        "Kishoreganj",
        "Kurigram",
        "Kushtia",
        "Lakshmipur",
        "Lalmonirhat",
        "Madaripur",
        "Magura",
        "Manikganj",
        "Meherpur",
        "Moulvibazar",
        "Munshiganj",
        "Mymensingh",
        "Naogaon",
        "Narail",
        "Narayanganj",
        "Narsingdi",
        "Natore",
        "Netrokona",
        "Nilphamari",
        "Noakhali",
        "Pabna",
        "Panchagarh",
        "Patuakhali",
        "Pirojpur",
        "Rajbari",
        "Rajshahi",
        "Rangamati",
        "Rangpur",
        "Satkhira",
        "Shariatpur",
        "Sherpur",
        "Sirajganj",
        "Sunamganj",
        "Sylhet",
        "Tangail",
        "Thakurgaon"
    ]);
    app.constant('SUBDISTRICT',[
        "Abhaynagar",
        "Adamdighi",
        "Aditmari",
        "Agailjhara",
        "Ajmiriganj",
        "Akhaura",
        "Akkelpur",
        "Alamdanga",
        "Alfadanga",
        "Ali Kadam",
        "Amtali",
        "Anwara",
        "Araihazar",
        "Ashuganj",
        "Assasuni",
        "Atgharia",
        "Atpara",
        "Atrai",
        "Atwari",
        "Austagram",
        "Babuganj",
        "Badalgachhi",
        "Badarganj",
        "Bagaichhari",
        "Bagatipara",
        "Bagerhat Sadar",
        "Bagha",
        "Bagherpara",
        "Bagmara",
        "Bahubal",
        "Bajitpur",
        "Bakerganj",
        "Baksiganj",
        "Balaganj",
        "Baliadangi",
        "Baliakandi",
        "Bamna",
        "Banaripara",
        "Bancharampur",
        "Bandar",
        "Bandar",
        "Bandarban Sadar",
        "Baniyachong",
        "Banshkhali",
        "Baraigram",
        "Barguna Sadar",
        "Barhatta",
        "Barishal Sadar",
        "Barkal",
        "Barlekha",
        "Barura",
        "Basail",
        "Batiaghata",
        "Bauphal",
        "Beanibazar",
        "Begumganj",
        "Belabo",
        "Belaichhari",
        "Belkuchi",
        "Bera",
        "Betagi",
        "Bhairab",
        "Bhaluka",
        "Bhandaria",
        "Bhanga",
        "Bhangura",
        "Bhedarganj",
        "Bheramara",
        "Bhola Sadar",
        "Bholahat",
        "Bhuapur",
        "Bhujpur",
        "Bhurungamari",
        "Bijoynagar",
        "Biral",
        "Birampur",
        "Birganj",
        "Bishwamvarpur",
        "Bishwanath",
        "Boalkhali",
        "Boalmari",
        "Bochaganj",
        "Boda",
        "Bogura Sadar",
        "Brahmanbaria Sadar",
        "Brahmanpara",
        "Burhanuddin",
        "Burichang",
        "Chakaria",
        "Chandanaish",
        "Chandgaon",
        "Chandina",
        "Chandpur Sadar",
        "Char Fasson",
        "Char Rajibpur",
        "Charbhadrasan",
        "Charghat",
        "Chatkhil",
        "Chatmohar",
        "Chauddagram",
        "Chaugachha",
        "Chauhali",
        "Chhagalnaiya",
        "Chhatak",
        "Chilmari",
        "Chirirbandar",
        "Chitalmari",
        "Chuadanga Sadar",
        "Chunarughat",
        "Companiganj",
        "Companigonj",
        "Cox's Bazar Sadar",
        "Cumilla Adarsha Sadar",
        "Cumilla Sadar Dakshin",
        "Dacope",
        "Daganbhuiyan",
        "Dakshin Sunamganj",
        "Dakshin Surma",
        "Damudya",
        "Damurhuda",
        "Dashmina",
        "Daudkandi",
        "Daulatkhan",
        "Daulatpur",
        "Daulatpur",
        "Daulatpur",
        "Debhata",
        "Debidwar",
        "Debiganj",
        "Delduar",
        "Derai",
        "Dewanganj",
        "Dhamoirhat",
        "Dhamrai",
        "Dhanbari",
        "Dharamapasha",
        "Dhobaura",
        "Dhunat",
        "Dhupchanchia",
        "Dighalia",
        "Dighinala",
        "Dimla",
        "Dinajpur Sadar",
        "Dohar",
        "Domar",
        "Double Mooring",
        "Dowarabazar",
        "Dumki",
        "Dumuria",
        "Durgapur",
        "Durgapur",
        "Fakirhat",
        "Faridganj",
        "Faridpur Sadar",
        "Faridpur",
        "Fatikchhari",
        "Fenchuganj",
        "Feni Sadar",
        "Fulbaria",
        "Fulgazi",
        "Gabtali",
        "Gaffargaon",
        "Gaibandha Sadar",
        "Galachipa",
        "Gangachhara",
        "Gangni",
        "Gauripur",
        "Gaurnadi",
        "Gazaria",
        "Gazipur Sadar",
        "Ghatail",
        "Ghior",
        "Ghoraghat",
        "Goalandaghat",
        "Gobindaganj",
        "Godagari",
        "Golapganj",
        "Gomastapur",
        "Gopalganj Sadar",
        "Gopalpur",
        "Gosairhat",
        "Gowainghat",
        "Gurudaspur",
        "Habiganj Sadar",
        "Haimchar",
        "Hakimpur",
        "Haluaghat",
        "Harinakunda",
        "Harintana",
        "Haripur",
        "Harirampur",
        "Hathazari",
        "Hatibandha",
        "Hatiya",
        "Haziganj",
        "Hizla",
        "Homna",
        "Hossainpur",
        "Indurkani",
        "Ishwardi",
        "Ishwarganj",
        "Islampur",
        "Itna",
        "Jagannathpur",
        "Jaintiapur",
        "Jaldhaka",
        "Jamalganj",
        "Jamalpur Sadar",
        "Jashore Sadar",
        "Jhalokati Sadar",
        "Jhenaidah Sadar",
        "Jhenaigati",
        "Jhikargachha",
        "Jibannagar",
        "Joypurhat Sadar",
        "Juraichhari",
        "Juri",
        "Kabirhat",
        "Kachua",
        "Kachua",
        "Kahaloo",
        "Kaharole",
        "Kalai",
        "Kalapara",
        "Kalaroa",
        "Kalia",
        "Kaliakair",
        "Kaliganj",
        "Kaliganj",
        "Kaliganj",
        "Kaliganj",
        "Kalihati",
        "Kalkini",
        "Kalmakanda",
        "Kalukhali",
        "Kamalganj",
        "Kamalnagar",
        "Kamarkhanda",
        "Kanaighat",
        "Kapasia",
        "Kaptai",
        "Karimganj",
        "Karnaphuli",
        "Kasba",
        "Kashiani",
        "Kathalia",
        "Katiadi",
        "Kaunia",
        "Kawkhali (Betbunia)",
        "Kawkhali",
        "Kazipur",
        "Kendua",
        "Keraniganj",
        "Keshabpur",
        "Khagrachhari",
        "Khaliajuri",
        "Khalishpur",
        "Khan Jahan Ali",
        "Khansama",
        "Khetlal",
        "Khoksa",
        "Kishoreganj Sadar",
        "Kishoreganj",
        "Kotalipara",
        "Kotchandpur",
        "Kotwali",
        "Koyra",
        "Kulaura",
        "Kuliarchar",
        "Kumarkhali",
        "Kurigram Sadar",
        "Kushtia Sadar",
        "Kutubdia",
        "Lakhai",
        "Laksam",
        "Lakshmichhari",
        "Lakshmipur Sadar",
        "Lalmai",
        "Lalmohan",
        "Lalmonirhat Sadar",
        "Lalpur",
        "Lama",
        "Langadu",
        "Lohagara",
        "Lohagara",
        "Lohajang",
        "Madan",
        "Madarganj",
        "Madaripur Sadar",
        "Madhabpur",
        "Madhukhali",
        "Madhupur",
        "Magura Sadar",
        "Mahalchhari",
        "Maheshkhali",
        "Maheshpur",
        "Manda",
        "Manikchhari",
        "Manikgonj Sadar",
        "Manirampur",
        "Manpura",
        "Mathbaria",
        "Matiranga",
        "Matlab Dakshin",
        "Matlab Uttar",
        "Meghna",
        "Mehendiganj",
        "Meherpur Sadar",
        "Melandaha",
        "Mirpur",
        "Mirsharai",
        "Mirzaganj",
        "Mirzapur",
        "Mithamain",
        "Mithapukur",
        "Mohadevpur",
        "Mohammadpur",
        "Mohanganj",
        "Mohanpur",
        "Mollahat",
        "Mongla",
        "Monohardi",
        "Monohargonj",
        "Morrelganj",
        "Moulvibazar Sadar",
        "Mujibnagar",
        "Muksudpur",
        "Muktagachha",
        "Muladi",
        "Munshiganj Sadar",
        "Muradnagar",
        "Mymensingh Sadar",
        "Nabiganj",
        "Nabinagar",
        "Nachole",
        "Nagarkanda",
        "Nagarpur",
        "Nageshwari",
        "Naikhongchhari",
        "Nakla",
        "Nalchity",
        "Naldanga",
        "Nalitabari",
        "Nandail",
        "Nandigram",
        "Nangalkot",
        "Naniyachar",
        "Naogaon Sadar",
        "Naragati",
        "Narail Sadar",
        "Narayanganj Sadar",
        "Naria",
        "Narsingdi Sadar",
        "Nasirnagar",
        "Natore Sadar",
        "Nawabganj Sadar",
        "Nawabganj",
        "Nawabganj",
        "Nazirpur",
        "Nesarabad (Swarupkati)",
        "Netrokona Sadar",
        "Niamatpur",
        "Nikli",
        "Nilphamari Sadar",
        "Noakhali Sadar",
        "Osmani Nagar",
        "Paba",
        "Pabna Sadar",
        "Pahartali",
        "Paikgachha",
        "Pakundia",
        "Palash",
        "Palashbari",
        "Panchagarh Sadar",
        "Panchbibi",
        "Panchhari",
        "Panchlaish",
        "Pangsha",
        "Parbatipur",
        "Parshuram",
        "Patgram",
        "Patharghata",
        "Patiya",
        "Patnitala",
        "Patuakhali Sadar",
        "Pekua",
        "Phulbari",
        "Phulbari",
        "Phulchhari",
        "Phulpur",
        "Phultala",
        "Pirgachha",
        "Pirganj",
        "Pirganj",
        "Pirojpur Sadar",
        "Porsha",
        "Purbadhala",
        "Puthia",
        "Raiganj",
        "Raipur",
        "Raipura",
        "Rajapur",
        "Rajarhat",
        "Rajasthali",
        "Rajbari Sadar",
        "Rajnagar",
        "Rajoir",
        "Ramganj",
        "Ramgarh",
        "Ramgati",
        "Rampal",
        "Ramu",
        "Rangabali",
        "Rangamati Sadar",
        "Rangpur Sadar",
        "Rangunia",
        "Raninagar",
        "Ranisankail",
        "Raomari",
        "Raozan",
        "Rowangchhari",
        "Ruma",
        "Rupganj",
        "Rupsha",
        "Sadarpur",
        "Sadullapur",
        "Saidpur",
        "Sakhipur",
        "Saltha",
        "Sandwip",
        "Santhia",
        "Sapahar",
        "Sarail",
        "Sarankhola",
        "Sariakandi",
        "Sarishabari",
        "Satkania",
        "Satkhira Sadar",
        "Saturia",
        "Savar",
        "Sayestaganj",
        "Senbagh",
        "Shahjadpur",
        "Shahrasti",
        "Shailkupa",
        "Shajahanpur",
        "Shakhipur",
        "Shalikha",
        "Shariatpur Sadar",
        "Sharsha",
        "Sherpur Sadar",
        "Sherpur",
        "Shibchar",
        "Shibganj",
        "Shibganj",
        "Shibpur",
        "Shivalaya",
        "Shyamnagar",
        "Singair",
        "Singra",
        "Sirajdikhan",
        "Sirajganj Sadar",
        "Sitakunda",
        "Sonadanga",
        "Sonagazi",
        "Sonaimuri",
        "Sonargaon",
        "Sonatola",
        "Sreebardi",
        "Sreemangal",
        "Sreenagar",
        "Sreepur",
        "Sreepur",
        "Subarnachar",
        "Sughatta",
        "Sujanagar",
        "Sullah",
        "Sunamganj Sadar",
        "Sundarganj",
        "Sylhet Sadar",
        "Tahirpur",
        "Tala",
        "Taltali",
        "Tangail Sadar",
        "Tanore",
        "Tara Khanda",
        "Taraganj",
        "Tarail",
        "Tarash",
        "Tazumuddin",
        "Tejgaon Circle",
        "Teknaf",
        "Terokhada",
        "Tetulia",
        "Thakurgaon Sadar",
        "Thanchi",
        "Titas",
        "Tongibari",
        "Trishal",
        "Tungipara",
        "Ukhia",
        "Ulipur",
        "Ullahpara",
        "Wazirpur",
        "Zajira",
        "Zakiganj"
    ]);
}).call(this);

(function(){
    app.constant('ENGLISH', {
        DASHBOARD:'Dashboard',
        SCHOOL:'School',
        SHIFT:'Shift',
        ACADEMICS:'Academics',
        SECTION:'Section',
        STUDENTS:'Students',
        ADMISSION:'Admission',
        TEACHERS:"Teachers",
        JOIN:"Joining",
        HEADLINE: 'What an awesome module!',
        EDUCATIONOFFICE : "Education Office",
        runningSections:'Running Sections',
        attendanceChart:'Attendance Chart',
        attendanceFeed : 'Attendance Feed',
        sl:'SL',
        class:'Class',
        total:'Total',
        totalStudents:'Total Students',
        present:'Present',
        absent:'Absent',
        late:'Late',
        name:'Name',
        schoolName:'School Name',
        schoolAdminEmail:'School Admin Email',
        schoolAdminPassword:'School Admin Password',
        addSchool:'Add School',
        addNewSchool:'Add New School',
        editSchool:'Edit School',
        editSchoolInfo:'Edit School Information',
        totalStudents:'Total Students',
        totalTeachers:'Total Teachers',
        educationOfficeName: 'Education Office Name',
        educationOfficeAdminEmail:'Education Office Admin Email',
        educationOfficeAdminPassword:'Education Office Admin Password',
        addEducationOffice:'Add Education Office',
        addNewEducationOffice:'Add New Education Office',
        editEducationOffice:'Edit Education Office',
        superiorEducationOffice:'Superior Education Office',
        subordinateEducationOffice:'Subordinate Education Office',
        address:'Address',
        website:'Website',
        district:'District',
        subDistrict:'Upazila',
        deviceFirstDisplayText:'Device First Display Text',
        deviceSecondDisplayText:'Device Second Display Text',
        shift:'Shift',
        shiftFrom:'From',
        shiftTo:'To',
        allShifts:'Shifts',
        status:'Status',
        active:'Active',
        inactive:'Inactive',
        selectImage:'Select Image',
        upload:'Upload',
        create:'Create',
        update:'Update',
        actions:'Action',
        allSections:'Sections',
        createClass:'Create Class',
        allClasses:'Classes',
        configureClass : 'Configure Class',
        configuredClasses : 'Configured Classes',
        delete:'Delete',
        studentAdmission:'Student Admission',
        studentsPicture:"Student's Picture",
        studentsName:"Student's Name",
        studentProvidedInformation:'Student Provided Information',
        schoolProvidedInformation:'School Provided Information',
        gender:'Gender',
        religion:'Religion',
        bloodGroup:'Blood Group',
        dateOfBirth:'Date of Birth',
        birthCertificate:'Birth Certificate',
        fathersName:"Father's Name",
        mothersName:"Mother's Name",
        guardiansName:"Guardian's Name",
        contactNumber:'Mobile Number',
        presentAddress:'Present Address',
        permanentAddress:'Permanent Address',
        presentSubDistrict:'Present Upazila',
        presentDistrict:'Present District',
        permanentDistrict:'Permanent District',
        permanentSubDistrict:'Permanent Upazila',
        classAllocation:'Class allocation',
        year:'Year',
        rollNumber:'Roll Number',
        rfid:'RFID',
        allStudents:'All Students',
        allTeachers:'All Teachers',
        picture:'Picture',
        dailyAttendance:'Daily Attendance',
        studentDailyAttendance:"Students' Daily Attendance",
        entryTime:'Entry Time',
        exitTime:'Exit Time',
        totalHours:'Total Hours',
        studentsInformation:"Student's Information",
        monthlyAttendance:'Monthly Attendance',
        studentsMonthlyAttendance:"Students' Monthly Attendance",
        summary:'Summary',
        section:'Section',
        schoolHolidays:'School Holidays',
        holidayList:'Holiday List',
        holidaysInCalendar:'Holidays in Calendar',
        addNewHoliday:'Add New Holiday',
        title:'Title',
        date:'Date',
        notice:'Notice',
        createNotice:'Create Notice',
        latestNotice:'Latest Notice',
        noticeTitle:'Notice Title',
        noticeDescription:'Notice Description',
        publishDate:'Publish Date',
        noticeImage:'Notice Image',
        uploadStudentImage: 'Upload Student Image',
        uploadNoticeImage:'Upload Notice Image',
        noticeFiles:'Notice Files',
        downloadLink:'Download Link',
        teachersInformation:"Teacher's Information",
        teachersMonthlyAttendance:'Teacher Monthly Attendance',
        teachersDailyAttendance:'Teacher Daily Attendance',
        teacherJoining:'Teacher Joining',
        teachersPicture:"Teacher's Picture",
        teachersProvidedInformation:'Teacher Provided Information',
        qualificationsAndExperience:'Qualifications and Experience',
        teachersName:"Teacher's Name",
        teachersEmail:"Teacher's Email",
        teachersQualification:"Teacher's Qualification",
        teachersExperience:"Teacher's Experience",
        dateOfJoining:'Date of Joining',
        designation:'Designation',
        editTeacher:'Edit Teacher',
        editTeacherInfo:'Edit Teacher Information',
        uploadTeacherImage: 'Upload Teacher Image',
        allTeachersList:'All Teachers List',
        teacherslLeave:"Teacher's Leave",
        addLeave:"Add Leave",
        addTeachersLeave:"Add Teacher's Leave",
        selectTeacher:"Select Teacher",
        description:'Description',
        teachersLeaveList:"Teacher's Leave List",
        allLeaveList:'All Leave List',
        leaveDescription:'Leave Description',
        startDate:'Start Date',
        endDate:'End Date',
        dateLabel: 'Date',
        monthLabel: 'Month',
        monthName: 'Month Name',
        affiliatedEducationOffice: 'Affiliated Education Office'
    });
}).call(this);

(function () {
    app.constant('timezones',[
        {"key":"-720", "value":"(GMT-12:00) International Date Line West"},
        {"key":"-660", "value":"(GMT-11:00) Midway Island, Samoa"},
        {"key":"-600", "value":"(GMT-10:00) Hawaii"},
        {"key":"-540", "value":"(GMT-09:00) Alaska"},
        {"key":"-480", "value":"(GMT-08:00) Pacific Time (US & Canada),Tijuana, Baja California"},
        {"key":"-420", "value":"(GMT-07:00) Arizona,Chihuahua, La Paz, Mazatlan,Mountain Time (US & Canada)"},
        {"key":"-360", "value":"(GMT-06:00) Central Time (US & Canada),Guadalajara, Mexico City, Monterrey,Saskatchewan"},
        {"key":"-300", "value":"(GMT-05:00) Eastern Time (US & Canada),Indiana (East),Bogota, Lima, Quito, Rio Branco"},
        {"key":"-240", "value":"(GMT-04:00) Atlantic Time (Canada),Caracas,La Paz,Manaus,Santiago"},
        {"key":"-210", "value":"(GMT-03:30) Newfoundland"},
        {"key":"-180", "value":"(GMT-03:00) Brasilia,Buenos Aires,Georgetown,Greenland,Montevideo"},
        {"key":"-120", "value":"(GMT-02:00) Mid-Atlantic"},
        {"key":"-60", "value":"(GMT-01:00) Azores,Cape Verde Is."},
        {"key":"0", "value":"(GMT+00:00) Greenwich Mean Time : Dublin,Edinburgh,Lisbon,London,Casablanca,Monrovia,Reykjavik"},
        {"key":"60", "value":"(GMT+01:00) Amsterdam,Berlin,Bern,Paris,Rome,Stockholm,Vienna,Belgrade,Budapest,Prague,West Central Africa,Zagreb"},
        {"key":"120", "value":"(GMT+02:00) Amman,Athens,Bucharest,Istanbul,Beirut,Cairo,Harare,Pretoria,Helsinki,Jerusalem,Minsk,Windhoek"},
        {"key":"180", "value":"(GMT+03:00) Kuwait,Riyadh,Baghdad,Moscow,St.Petersburg,Volgograd,Nairobi,Tbilisi"},
        {"key":"210", "value":"(GMT+03:30) Tehran"},
        {"key":"240", "value":"(GMT+04:00) Abu Dhabi,Muscat,Baku,Yerevan"},
        {"key":"270", "value":"(GMT+04:30) Kabul"},
        {"key":"300", "value":"(GMT+05:00) Yekaterinburg,Islamabad,Karachi,Tashkent"},
        {"key":"330", "value":"(GMT+05:30) Chennai,Kolkata,Mumbai,New Delhi,Sri Jayawardenapura"},
        {"key":"345", "value":"(GMT+05:45) Kathmandu"},
        {"key":"360", "value":"(GMT+06:00) Almaty,Novosibirsk,Astana,Dhaka"},
        {"key":"390", "value":"(GMT+06:30) Yangon (Rangoon)"},
        {"key":"420", "value":"(GMT+07:00) Bangkok,Hanoi,Jakarta,Krasnoyarsk"},
        {"key":"480", "value":"(GMT+08:00) Beijing, Chongqing,Hong Kong,Urumqi,Kuala Lumpur,Singapore,Irkutsk,Ulaan Bataar,Perth,Taipei"},
        {"key":"540", "value":"(GMT+09:00) Osaka,Sapporo,Tokyo,Seoul,Yakutsk"},
        {"key":"570", "value":"(GMT+09:30) Adelaide,Darwin"},
        {"key":"600", "value":"(GMT+10:00) Brisbane,Canberra,Melbourne,Sydney,Hobart,Guam,Port Moresby,Vladivostok"},
        {"key":"660", "value":"(GMT+11:00) Magadan, Solomon Is., New Caledonia"},
        {"key":"720", "value":"(GMT+12:00) Auckland,Wellington,Fiji,Kamchatka,Marshall Is."},
        {"key":"780", "value":"(GMT+13:00) Nuku'alofa"},
    ])
}).call(this);
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings,editableOptions) {
    editableOptions.theme='bs3';
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {

    'use strict';

    function scheduledSchoolCreateService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                                            message, authService) {

        var self = this;
        self.getAll = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.scheduledSchoolCreateRequest.getAll);
            $http.get(API.scheduledSchoolCreateRequest.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.scheduledSchoolCreateRequestList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.retry = function (requestId) {
            var defer = $q.defer();
            console.log("get request to url : " + API.scheduledSchoolCreateRequest.retry + requestId);
            $http.post(API.scheduledSchoolCreateRequest.retry + requestId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }
    }
    app.service('scheduledSchoolCreateService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', scheduledSchoolCreateService]);

})();

(function(){

    'use strict';


    function assocService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){
        var self = this;

        self.getAllAssocs = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.assoc.getAll);
            $http.get(API.assoc.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.cssAssocList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createAssoc = function (data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.assoc.getAll);
            $http.post(API.assoc.getAll,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.cssAssocList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deleteAssoc = function (id) {
            var defer = $q.defer();
            console.log("post request to url : " + API.assoc.delete+id);
            $http.post(API.assoc.delete+id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.cssAssocList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }
    app.service('assocService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', assocService]);

})();
(function(){

    'use strict';


    function attendanceService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, authService){
        var self = this;

        self.getTeacherAttendance = function (filterData) {
            var defer = $q.defer();
            var urlParams = "?from="+filterData.from+"&to="+filterData.to+buildURLFromArray("schoolId", filterData.schoolIdList);
            if(filterData.teacherName!=null) urlParams += "&teacherName=" +  filterData.teacherName;
            console.log("get request to url : " + API.attendance.getTeachers+urlParams);
            $http.get(API.attendance.getTeachers+urlParams)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getStudentAttendances = function (filterData) {
            var defer = $q.defer();
            var urlParams = "?from="+filterData.from+"&to="+filterData.to+"&schoolId="+filterData.schoolId;
            if(filterData.studentName!=null) urlParams += "&studentName=" +  filterData.studentName;
            if(filterData.classId!=null) urlParams += "&classId=" +  filterData.classId;
            if(filterData.sectionId!=null) urlParams += "&sectionId=" +  filterData.sectionId;
            if(filterData.shiftId!=null) urlParams += "&shiftId=" +  filterData.shiftId;
            console.log("get request to url : " + API.attendance.getStudents+urlParams);
            $http.get(API.attendance.getStudents+urlParams)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAttendanceById = function (attendanceId) {
            var defer = $q.defer();
            console.log("get request to url : " + API.attendance.getAll+attendanceId);
            $http.get(API.attendance.getAll+attendanceId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.attendance);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getExcelUrl = function (from, to, schoolIdList, name) {
            name = name == null? '' : name;
            return API.attendance.getTeacherAttendance + '?from=' + from.valueOf() + '&to=' + to.valueOf() + buildURLFromArray("schoolId", schoolIdList) + '&name=' + name +'&token='+authService.getLoggedInToken();
        };

        function buildURLFromArray(key, valueArray) {
            if(!key || !valueArray || valueArray.length < 1) return "";
            var url = "&"+key+"=";
            if(valueArray.constructor === Array){
                url = url + valueArray.join(",");
            } else{
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

    }
    app.service('attendanceService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', 'authService',attendanceService]);

})();

(function(){

    'use strict';

    function authService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        function loginHandler(data, headers){
            self.setLoggedInToken(headers('token'));
            self.setRefreshToken(headers('refresh-token'));
            self.setUserInfo(data.employee);
            // $rootScope.$on('connect-socket');
        }

        self.fakeLogin = function () {
            self.setLoggedInToken("very nice token");
            console.log("logged in ");
        };

        self.login = function(data){
            $window.localStorage.setItem('language','bn');
            var defer = $q.defer();
            // console.log("posting " + JSON.stringify(data) + " to url : " + API.auth.signin);
            $http.post(API.auth.signin, data)
                .success(function(data, status, headers, config){
                    // console.log("Login Response from server : Data : " + JSON.stringify(data) + ", status : " + status + ", headers : " + JSON.stringify(headers));
                    if(status === RESPONSE_CODE.success){
                        loginHandler(data, headers);
                        $state.go('dashboard');
                    }
                    else {
                        defer.reject(data.message ? data.message : "");
                    }
                })
                .error(function(data, status, headers, config){
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        // console.log("Login Response from server : Data : " + JSON.stringify(data) + ", status : " + status + ", headers : " + JSON.stringify(headers));
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        // self.loginWithLinkedIn = function(provider){
        //
        //     var defer = $q.defer();
        //     $auth.authenticate(provider).then(function(userData){
        //         loginHandler(userData.data.data);
        //         $state.go('home');
        //     });
        //     return defer.promise;
        // };

        self.logout = function(){
            $http.post(API.auth.signout, {}).then(function(){
                self.clearSession();
                $state.go('login');
            }, function () {
                self.clearSession();
                $state.go('login');
            });
        };


        self.setUserInfo = function(userInfo){
            $rootScope.loggedInUser = userInfo;
            //console.log(JSON.stringify(userInfo));
            $window.localStorage.setItem('language','bn')
            $window.localStorage.setItem('userInfo', JSON.stringify(userInfo)) ;
        };


        self.isAdmin = function(){
            return self && self.getLoggedInUser() && self.getLoggedInUser().isAdmin && self.getLoggedInUser().isAdmin === true;
        };

        self.isEducationOfficeAdmin = function(){
            return self && self.getLoggedInUser() && self.getLoggedInUser().isEducationOfficeAdmin && self.getLoggedInUser().isEducationOfficeAdmin === true;
        };

        self.setLoggedInToken= function(token){
            $window.localStorage.setItem('token', token);
        };

        self.setRefreshToken= function(token){
            $window.localStorage.setItem('refresh-token', token);
        };

        self.getLoggedInId = function(){
            return self.getAllInformation().id;
        };

        self.getLoggedInToken = function(){
            return $window.localStorage.getItem('token');
        };

        self.getRefreshToken = function(){
            return $window.localStorage.getItem('refresh-token');
        };

        self.getLoggedInUser = function(){
            return self.getAllInformation();
        };

        self.getProjectName = function () {
            return JSON.parse($window.localStorage.getItem('userInfo')).name;
        };

        self.getAllInformation = function(){
            return JSON.parse($window.localStorage.getItem('userInfo')) || {};
        };

        self.isAuthenticated = function(){
            return  !!$window.localStorage.getItem('token');
        };

        self.clearSession = function(){
            $window.localStorage.clear();
        };



    }
    app.service('authService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', authService]);

})();
(function(){

    'use strict';


    function classService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){
        var self = this;

        self.getAllClasses = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.class.getAll);
            $http.get(API.class.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.classList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateClass = function (id,data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.class.getAll+id);
            $http.post(API.class.getAll+id,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.classList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createClass = function (data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.class.getAll);
            $http.post(API.class.getAll,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.classList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deleteClass = function (id) {
            var defer = $q.defer();
            console.log("post request to url : " + API.class.delete+id);
            $http.post(API.class.delete+id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.classList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }
    app.service('classService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', classService]);

})();
(function(){

    'use strict';

    function designationService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllDesignations = function() {
            var defer = $q.defer();
            console.log("get request to url : " + API.designation.all);
            $http.get(API.designation.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.designationList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }
    app.service('designationService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', designationService]);

})();
(function () {

    'use strict';

    function educationOfficeService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){
        var self = this;

        self.getAllEducationOffices = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.educationOffice.getAll);
            $http.get(API.educationOffice.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationOfficeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllEducationOfficesForDropDown = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.educationOffice.getAllForDropDown);
            $http.get(API.educationOffice.getAllForDropDown)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationOfficeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createEducationOffice = function (data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.educationOffice.create);
            $http.post(API.educationOffice.create,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationOfficeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllOfficeHierarchies = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.officeHierarchy.getAll);
            $http.get(API.officeHierarchy.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.officeHierarchyList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getEducationOfficeById = function (educationOfficeId) {
            var defer = $q.defer();
            console.log("get request to url : " + API.educationOffice.getAll + educationOfficeId);
            $http.get(API.educationOffice.getAll + educationOfficeId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationOffice);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message);
                });

            return defer.promise;
        };

        self.updateEducationOffice = function (educationOfficeId, data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.educationOffice.update + educationOfficeId);
            $http.post(API.educationOffice.update + educationOfficeId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationOfficeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message);
                });

            return defer.promise;
        }

        self.getAllSubordinateClusters = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.educationOffice.getAllSubordinateClusters);
            $http.get(API.educationOffice.getAllSubordinateClusters)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationOfficeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
    }

    app.service('educationOfficeService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', educationOfficeService]);
})();
(function(){

    'use strict';

    function holidayService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllHolidays = function() {
            var defer = $q.defer();
            console.log("get request to url : " + API.holiday.all);
            $http.get(API.holiday.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.holidayList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createHoliday=function (data) {
            var defer = $q.defer();
            console.log("POST request to url : " + API.holiday);
            $http.post(API.holiday.create,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.holiday);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateHoliday=function (holidayId,data) {
            var defer = $q.defer();
            console.log("POST request to url : " + API.holiday.create);
            $http.post(API.holiday.create+holidayId,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.holiday);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


    }
    app.service('holidayService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', holidayService]);

})();
(function(){

    'use strict';

    function leaveService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllLeaves = function (searchString) {
            searchString = searchString == null? "" : searchString;
            var defer = $q.defer();
            console.log("get request to url : " + API.leave.getAll + "?name=" + searchString);
            $http.get(API.leave.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leaveResponseList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.applyForLeave = function (data) {
            var defer = $q.defer();
            var postUrl = API.leave.apply + data.teacherId;
            $http.post(postUrl,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deleteLeave = function (leaveId) {
            var defer = $q.defer();
            var url = API.leave.delete + leaveId + "/delete";
            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leaveResponseList);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }
    app.service('leaveService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', leaveService]);

})();

(function(){

    'use strict';


    function noticeService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){
        var self = this;

        self.getAllNotices = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.notice.getAll);
            $http.get(API.notice.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.noticeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getNoticeById = function (noticeId) {
            var defer = $q.defer();
            console.log("get request to url : " + API.notice.getAll+noticeId);
            $http.get(API.notice.getAll+noticeId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.notice);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createNotice = function (data) {
            var defer = $q.defer();
            console.log("get request to url : " + API.notice.create);
            $http.post(API.notice.getAll,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.editNotice = function (noticeId,data) {
            var defer = $q.defer();
            console.log("get request to url : " + API.notice.getAll+noticeId);
            $http.post(API.notice.getAll+noticeId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }
        self.uploadNoticeImage = function (data) {
            var defer = $q.defer();
            console.log("get request to url : " + API.student.uploadPicture);
            $http.post(API.student.uploadPicture,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.deleteNotice = function (id) {
            var defer = $q.defer();
            console.log("post request to url : " + API.notice.delete+id);
            $http.post(API.notice.delete+id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.noticeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }
    app.service('noticeService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', noticeService]);

})();
(function () {

    'use strict';

    function scheduledEmployeeCreateService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                             message, authService) {

        var self = this;
        self.getAll = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.scheduledEmployeeCreateRequest.getAll);
            $http.get(API.scheduledEmployeeCreateRequest.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.scheduledTeacherCreateRequestList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.retry = function (requestId) {
            var defer = $q.defer();
            console.log("get request to url : " + API.scheduledEmployeeCreateRequest.retry + requestId);
            $http.post(API.scheduledEmployeeCreateRequest.retry + requestId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }
    }
    app.service('scheduledEmployeeCreateService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', scheduledEmployeeCreateService]);

})();

(function(){

    'use strict';


    function schoolService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){
        var self = this;

        self.getDashboardData = function (schoolId) {
            var defer = $q.defer();
            console.log("get request to url : " + API.school.dashboard+schoolId);
            $http.get(API.school.dashboard+schoolId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.dashboardDataResponseList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getDashboardDataForEducationOffice = function(){
            var defer = $q.defer();
            console.log("get request to url : " + API.school.dashboardForEducationOffice);
            $http.get(API.school.dashboardForEducationOffice)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.dashboardDataResponseList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllSchools = function (searchString) {
            searchString = searchString == null? "" : searchString;
            var defer = $q.defer();
            console.log("get request to url : " + API.school.getAll + "?keyword=" + searchString);
            $http.get(API.school.getAll + "?keyword=" + searchString)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.schoolList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getSchoolById = function (schoolId) {
            var defer = $q.defer();
            console.log("get request to url : " + API.school.getAll + schoolId);
            $http.get(API.school.getAll + schoolId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.school);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllSchoolsUnderAnEducationOffice = function (educationOfficeId) {
            var defer = $q.defer();
            var urlParams = !educationOfficeId || educationOfficeId == null ? "" : "?educationOfficeId=" + educationOfficeId;
            console.log("get request to url : " + API.school.getAllUnderAnEducationOffice + urlParams);
            $http.get(API.school.getAllUnderAnEducationOffice + urlParams)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.schoolList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getFeedData = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.attendance.getAttendanceFeed);
            $http.get(API.attendance.getAttendanceFeed)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.feedEntryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllInstitutionTypes = function() {
            var defer = $q.defer();
            console.log("get request to url : " + API.institutionType.getAll);
            $http.get(API.institutionType.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createSchool = function (data) {
            var defer = $q.defer();
            console.log("get request to url : " + API.school.getAll);
            $http.post(API.school.getAll,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.editSchool = function (schoolId,data) {
            var defer = $q.defer();
            console.log("get request to url : " + API.school.getAll+schoolId);
            $http.post(API.school.getAll+schoolId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.batchCreate = function (excelFile) {
            var defer = $q.defer();
            var url = API.school.batchCreate;
            var formData = new FormData();
            formData.append("file", excelFile);
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData
            }).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response.message);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                console.error(JSON.stringify(data));
                defer.reject(data.message);
            });

            return defer.promise;
        };
        self.getAllReseller = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.school.getAllResellers);
            $http.get(API.school.getAllResellers)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.resellerList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
    }
    app.service('schoolService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', schoolService]);

})();

(function(){

    'use strict';


    function sectionService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){
        var self = this;

        self.getAllSections = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.section.getAll);
            $http.get(API.section.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.sectionList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateSection = function (id,data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.section.getAll+id);
            $http.post(API.section.getAll+id,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.sectionList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createSection = function (data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.section.getAll);
            $http.post(API.section.getAll,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.sectionList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deleteSection = function (id) {
            var defer = $q.defer();
            console.log("post request to url : " + API.section.delete+id);
            $http.post(API.section.delete+id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.sectionList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }
    app.service('sectionService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', sectionService]);

})();
(function(){

    'use strict';


    function shiftService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){
        var self = this;

        self.getAllShifts = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.shift.getAll);
            $http.get(API.shift.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shiftList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateShift = function (id,data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.shift.getAll+id);
            $http.post(API.shift.getAll+id,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shiftList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createShift = function (data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.shift.getAll);
            $http.post(API.shift.getAll,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shiftList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deleteShift = function (id) {
            var defer = $q.defer();
            console.log("post request to url : " + API.shift.delete+id);
            $http.post(API.shift.delete+id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shiftList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }
    app.service('shiftService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', shiftService]);

})();
(function(){

    'use strict';


    function studentService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){
        var self = this;

        self.getAllStudents = function () {
            var defer = $q.defer();
            console.log("get request to url : " + API.student.getAll);
            $http.get(API.student.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.studentResponseList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getStudentById = function (studentId) {
            var defer = $q.defer();
            console.log("get request to url : " + API.student.getAStudent+studentId);
            $http.get(API.student.getAStudent+studentId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createStudent = function (data) {
            var defer = $q.defer();
            console.log("get request to url : " + API.student.getAll);
            $http.post(API.student.getAll,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.editStudent = function (studentId,data) {
            var defer = $q.defer();
            console.log("get request to url : " + API.student.getAll+studentId);
            $http.post(API.student.getAll+studentId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

    }
    app.service('studentService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', studentService]);

})();
(function(){

    'use strict';


    function teacherService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){
        var self = this;

        self.getAllTeachers = function (filterData) {
            filterData.teacherName = filterData.teacherName == null? "" : filterData.teacherName;
            var defer = $q.defer();
            var urlParams = "?name=" + filterData.teacherName + buildURLFromArray("schoolId", filterData.schoolIdList);
            console.log("get request to url : " + API.teacher.getAll + urlParams);
            $http.get(API.teacher.getAll + urlParams)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.teacherList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getTeacherById = function (teacherId) {
            var defer = $q.defer();
            console.log("get request to url : " + API.teacher.getATeacher+teacherId);
            $http.get(API.teacher.getATeacher+teacherId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createTeacher = function (data) {
            var defer = $q.defer();
            console.log("get request to url : " + API.teacher.getAll);
            $http.post(API.teacher.getAll,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


        self.deleteTeacher = function (teacherId) {
            var defer = $q.defer();
            var url = API.teacher.delete + teacherId + "/delete";
            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.teacherList);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.editTeacher = function (teacherId,data) {
            var defer = $q.defer();
            console.log("get request to url : " + API.teacher.getAll+teacherId);
            $http.post(API.teacher.getAll+teacherId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.batchCreate = function (excelFile) {
            var defer = $q.defer();
            var url = API.teacher.batchCreate;
            var formData = new FormData();
            formData.append("file", excelFile);
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData
            }).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response.message);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                console.error(JSON.stringify(data));
                defer.reject(data.message);
            });

            return defer.promise;
        };

        function buildURLFromArray(key, valueArray) {
            if(!key || !valueArray || valueArray.length < 1) return "";
            var url = "&"+key+"=";
            if(valueArray.constructor === Array){
                url = url + valueArray.join(",");
            } else{
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

    }
    app.service('teacherService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', teacherService]);

})();

(function(){

    'use strict';

    function dateService(stringService){

        var self = this;

        self.getDateTime = function(date){

            if(!date) return stringService.EMPTY;
            return moment(new Date(date)).format('DD MMMM YYYY');
        };

        self.getDateTimeFromNow = function(date){

            if(!date) return stringService.EMPTY;
            return moment(new Date(date)).fromNow();
        };

    }

    app.service('dateService', ['stringService', dateService]);

})();
(function(){

    'use strict';

    function httpInterceptor($window, $q, $rootScope){
        this.request = function(config){
            var token = $window.localStorage.getItem('token');
            if (token){
                config.headers = config.headers || {};
                config.headers['token'] = token;
            }
            return config;
        };

        this.responseError = function(resp){
            console.log("response intercepted : " + resp.status);
            // resp.data will contain your response object from the server
            if(resp.status === 401){
                console.log("unauthorized event emitting now");
                $rootScope.$emit("unauthorized");
                return $q.reject(resp);
            } else if(resp.status === -1){
                console.error("Internal Screams! Server Down!");
                $rootScope.$emit("server-down");
                return $q.reject(resp);
            }
            return resp || $q.when(resp);
        }
    }
    app.service('httpInterceptor', ['$window', '$q', '$rootScope', httpInterceptor]);
})();

(function(){

    'use strict';

    function message($rootScope, toastr){

        var self = this;

        self.success = {
            CATEGORY_ADDED: {
                title:'Category Added',
                success: true
            },
            CATEGORY_DELETED: {
                title:'Category deleted',
                success: true
            },
            FRIEND_REQUEST_SENT:{
                title:'Friend request sent',
                success: true
            },
            POST_ADDED:{
                title:'New post added',
                success: true
            },
            SETTINGS_SAVED:{
                title:'Settings saved',
                success: true
            }
        };

        self.error = {
            GENERAL:{
                title:'Something went wrong',
                success: false
            }
        };

        self.info = {
            CATEGORY_DELETE_CONFIRMATION:{
                title: 'Are you sure to Delete this category?'
            }
        };

        $rootScope.$on('toast-message', function(event, message){
            if(message.success){
                toastr.success(message.title);
            }
            else toastr.error(message.title);
        });
    }

    app.service('message', ['$rootScope', 'toastr', message]);

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .controller('MainCtrl', ['$rootScope', '$scope', '$state', 'authService', 'toastr','$translate', MainCtrl]);


    /** @ngInject */
    function MainCtrl($rootScope, $scope, $state, authService, toastr,$translate) {
        $translate.use($rootScope.language);
    }


})();
(function(){

    'use strict';

    function utilService() {

        var self = this;

        var daysOfWeek = {
            0: "Sunday",
            1: "Monday",
            2: "Tuesday",
            3: "Wednesday",
            4: "Thursday",
            5: "Friday",
            6: "Saturday"
        };

        self.checkIfValidHoliday = function (startDate, endDate) {
            return moment(endDate).isSameOrAfter(moment(startDate).format("YYYY-MM-DD"));
        };

        self.checkIfDatesEmpty = function(startDate, endDate) {
            if (!startDate || !endDate)
                return true
            else
                return false;
        };

        self.isDateEmpty = function (date) {
            if(!date)
                return false;
            return true;
        };

        self.isTimeInCurrentYear = function (time) {
            return moment(time).year() === new moment().year();
        };

        self.isDateEmpty = function (date) {
            return date === null;
        };

        self.createInputModelFromString = function (string) {
            var multiSelectInputModel = [];
            for (var i = 0; i < 7; i++) {
                if (string.charAt(i) === '1') {
                    multiSelectInputModel.push({name: daysOfWeek[i], value: i, isSelected: true})
                }
                else {
                    multiSelectInputModel.push({name: daysOfWeek[i], value: i, isSelected: false})
                }
            }
            console.log(multiSelectInputModel);
            return multiSelectInputModel;
        };

        self.getFormattedString = function (multiSelectInputModel) {
            var stringToPost = '';
            for (var i = 0; i < 7; i++) {
                multiSelectInputModel[i].isSelected === true ? stringToPost += '1' : stringToPost += '0';
            }
            return stringToPost;
        };

        self.getDateObjectFromShiftTimeString = function (s) {
            return new moment(s, ["hh:mm a"]);
        };
    }
    app.service('utilService',[utilService]);

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
'use strict';

(function (angular) {
  // Create all modules and define dependencies to make sure they exist
  // and are loaded in the correct order to satisfy dependency injection
  // before all nested files are concatenated by Gulp

  // Config
  angular.module('ui.carousel.config', []).value('ui.carousel.config', {
    debug: true
  });

  // Modules
  angular.module('ui.carousel.providers', []);
  angular.module('ui.carousel.controllers', []);
  angular.module('ui.carousel.directives', []);
  angular.module('ui.carousel', ['ui.carousel.config', 'ui.carousel.directives', 'ui.carousel.controllers', 'ui.carousel.providers']);
})(angular);
'use strict';

/**
 * angular-ui-carousel
 * for example:
 * length = 8, show = 4, scroll = 3, current = 0
 *          ---------
 *          |       |
 *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
 *          |       |
 *          ---------
 * rectangle is visible for users
 */
angular.module('ui.carousel.controllers').controller('CarouselController', ['$scope', '$element', '$timeout', '$q', 'Carousel', '$window', function ($scope, $element, $timeout, $q, Carousel, $window) {
  var _this = this;

  /**
   * Initial carousel
   *
   * Mirgate to angularjs 1.6
   * @see https://docs.angularjs.org/guide/migration#commit-bcd0d4
   */
  this.$onInit = function () {
    _this.initOptions();
    _this.initRanges();
    _this.setProps();
    _this.setupInfinite();
  };

  /**
   * Init option based on directive config
   */
  this.initOptions = function () {
    _this.options = angular.extend({}, Carousel.getOptions());

    // TODO customize attribute from directive
    if (_this.initialSlide !== undefined) {
      _this.options.initialSlide = _this.initialSlide;
    }
    if (_this.fade !== undefined) {
      _this.options.fade = _this.fade;
    }
    if (_this.autoplay !== undefined) {
      _this.options.autoplay = _this.autoplay;
    }
    if (_this.autoplaySpeed !== undefined) {
      _this.options.autoplaySpeed = _this.autoplaySpeed;
    }
    if (_this.cssEase !== undefined) {
      _this.options.cssEase = _this.cssEase;
    }
    if (_this.speed !== undefined) {
      _this.options.speed = _this.speed;
    }
    if (_this.infinite !== undefined) {
      _this.options.infinite = _this.infinite;
    }
    if (_this.arrows !== undefined) {
      _this.options.arrows = _this.arrows;
    }
    if (_this.dots !== undefined) {
      _this.options.dots = _this.dots;
    }
    if (_this.visiblePrev !== undefined) {
      _this.options.visiblePrev = _this.visiblePrev;
    }
    if (_this.visibleNext !== undefined) {
      _this.options.visibleNext = _this.visibleNext;
    }

    // TODO write more options for fade mode
    // In fade mode we have to setting slides-to-show and slides-to-scroll
    // to 1 slide
    if (_this.options.fade) {
      _this.options.slidesToShow = 1;
      _this.options.slidesToScroll = 1;
    } else {
      if (_this.show) {
        _this.options.slidesToShow = _this.show;
      }
      if (_this.scroll) {
        _this.options.slidesToScroll = _this.scroll;
      }
    }
  };

  /**
   * init variables, slides, ..
   */
  this.initRanges = function () {
    if (!_this.slides) {
      _this.slides = [];
    }

    _this.isCarouselReady = false;
    _this.isTrackMoving = false;
    _this.track = $element.find('.track');
    _this.width = 1; // Fake width
    _this.currentSlide = _this.options.initialSlide;
    _this.trackStyle = {};
    _this.slideStyle = {};

    _this.isVisibleDots = false;
    _this.isVisiblePrev = _this.options.visiblePrev;
    _this.isVisibleNext = _this.options.visibleNext;

    _this.isClickablePrev = false;
    _this.isClickableNext = false;

    _this.animType = null;
    _this.transformType = null;
    _this.transitionType = null;
  };

  /**
   * Init UI and carousel track
   */
  this.initUI = function () {
    _this.width = $element[0].clientWidth;

    // Update track width first
    _this.initTrack();

    // Then item style
    $timeout(function () {
      _this.updateItemStyle();
    }, 200);
  };
  var next ;
  /**
   * update common style for each carousel item
   */
  this.updateItemStyle = function () {
    _this.itemWidth = _this.width / _this.options.slidesToShow;
    _this.slideStyle = {
      'width': _this.itemWidth + 'px'
    };
      console.log("updateItemStyle calling next from inside ui-carousel");
      next();
  };

  /**
   * init carousel track
   * also make Carousel is Ready
   */
  this.initTrack = function () {
    var itemWidth = _this.width / _this.options.slidesToShow;
    var trackWidth = itemWidth * _this.slidesInTrack.length;

    _this.trackStyle.width = trackWidth + 'px';

    _this.slideHandler(_this.currentSlide).finally(function () {
      _this.isCarouselReady = true;

      if (!_this.options.fade) {
        _this.refreshTrackStyle();
      }

      // onInit callback
      if (_this.onInit) {
        _this.onInit();
      }
    }).catch(function () {
      // Catch err
    });
  };

  /**
   * @see https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L680
   *
   * Sync slide to place it should be
   * for example:
   * - 9 total, 3 show, 3 scroll, current 1
   *   => next index = 3 (previous index counted = 0)
   *
   * and scroll to next page:
   * - 6 total, 1 show, 1 scroll, current 0 => next index = 1
   * - 9 total, 3 show, 3 scroll, current 1 => next index = 3
   * - 9 total, 3 show, 3 scroll, current 3 => next index = 6
   * - 9 total, 3 show, 3 scroll, current 8 => next index = 3
   * - 8 total, 4 show, 3 scroll, current 1 => next index = 4
   */
  this.next = function () {
    if (!_this.isClickableNext) {
      return false;
    }

    var indexOffset = _this.getIndexOffset();
    var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : indexOffset;

    _this.slideHandler(_this.currentSlide + slideOffset).catch(function () {
      // Catch err
    });
    $scope.$emit("next-carousel", _this.currentSlide);
  };

  next = this.next;

  /**
   * move to previous slide
   * same calculate with next
   * @see next function
   */
  this.prev = function () {
    if (!_this.isClickablePrev) {
      return false;
    }

    var indexOffset = _this.getIndexOffset();
    var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : _this.options.slidesToShow - indexOffset;

    _this.slideHandler(_this.currentSlide - slideOffset).catch(function () {
      // Catch err
    });
    $scope.$emit("prev-carousel", _this.currentSlide);
  };

  /**
   * Get index offset
   */
  this.getIndexOffset = function () {
    var scrollOffset = _this.slides.length % _this.options.slidesToScroll !== 0;
    var indexOffset = scrollOffset ? 0 : (_this.slides.length - _this.currentSlide) % _this.options.slidesToScroll;

    return indexOffset;
  };

  /**
   * move to page
   * @params int page
   * Page counter from 0 (start = 0)
   */
  this.movePage = function (page) {
    var target = _this.options.slidesToScroll * page;
    _this.slideHandler(target).catch(function () {
      // Catch err
    });
  };

  /**
   * hanlder carousel
   * @description move carousel to correct page
   *
   * @params int index
   */
  this.slideHandler = function (index) {
    // TODO prevent when slides not exists
    if (!_this.slides) {
      return $q.reject('Carousel not fully setup');
    }

    // TODO Prevent when track is moving
    if (_this.isTrackMoving) {
      return $q.reject('Track is moving');
    }

    var len = _this.slides.length;
    var show = _this.options.slidesToShow;

    if (len <= show) {
      _this.correctTrack();
      return $q.reject('Length of slides smaller than slides to show');
    }

    // We need target to destination
    // and a anim slide to translate track
    //
    // anim = animSlide (which we use to move)
    // target = targetSlide
    var anim = index;
    var target = null;

    if (anim < 0) {
      if (len % _this.options.slidesToScroll !== 0) {
        target = len - len % _this.options.slidesToScroll;
      } else {
        target = len + anim;
      }
    } else if (anim >= len) {
      if (len % _this.options.slidesToScroll !== 0) {
        target = 0;
      } else {
        target = anim - len;
      }
    } else {
      target = anim;
    }

    if (_this.onBeforeChange) {
      // @see https://docs.angularjs.org/guide/directive
      _this.onBeforeChange({ currentSlide: _this.currentSlide, target: target });
    }

    // Fade handler
    if (_this.options.fade) {
      _this.currentSlide = target;

      // XXX
      // afterChange method
      // fire after faded
      // Should be revised
      $timeout(function () {
        _this.autoplayTrack();

        if (_this.onAfterChange) {
          _this.onAfterChange({ currentSlide: _this.currentSlide });
        }
      }, _this.options.speed);
      return $q.when('Handler fade');
    }

    // No-fade handler
    var itemWidth = _this.width / _this.options.slidesToShow;
    var left = -1 * target * itemWidth;
    if (_this.options.infinite) {
      left = -1 * (anim + show) * itemWidth;
    }

    _this.isTrackMoving = true;
    return _this.moveTrack(left).then(function () {
      _this.isTrackMoving = false;
      _this.currentSlide = target;
      _this.autoplayTrack();

      if (target !== anim) {
        _this.correctTrack();
      }

      if (!_this.options.infinite) {
        if (_this.currentSlide === 0) {
          _this.isClickablePrev = false;
          _this.isClickableNext = true;
        } else if (_this.currentSlide === _this.slidesInTrack.length - _this.options.slidesToShow) {
          _this.isClickableNext = false;
          _this.isClickablePrev = true;
        } else {
          _this.isClickablePrev = true;
          _this.isClickableNext = true;
        }
      }

      // XXX
      // afterChange method
      // fire after 200ms wakeup and correct track
      // Should be revised
      $timeout(function () {
        if (_this.onAfterChange) {
          _this.onAfterChange({ currentSlide: _this.currentSlide });
        }
      }, 200);
    });
  };

  /**
   * moveTrack
   * move track to left position using css3 translate
   * for example left: -1000px
   */
  this.moveTrack = function (left) {
    var deferred = $q.defer();
    if (_this.options.vertical === false) {
      _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0px, 0px)';
    } else {
      _this.trackStyle[_this.animType] = 'translate3d(0px, ' + left + 'px, 0px)';
    }

    $timeout(function () {
      deferred.resolve('Track moved');
    }, _this.options.speed);

    return deferred.promise;
  };

  /**
   * correctTrack
   * @description correct track after move to animSlide we have to move track
   * to exactly its position
   */
  this.correctTrack = function () {
    if (_this.options.infinite) {
      (function () {
        var left = 0;
        if (_this.slides.length > _this.options.slidesToShow) {
          left = -1 * (_this.currentSlide + _this.options.slidesToShow) * _this.itemWidth;
        }

        // Move without anim
        _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + 0 + 'ms ' + _this.options.cssEase;

        _this.isTrackMoving = true;
        $timeout(function () {
          _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0, 0px)';

          // Revert animation
          $timeout(function () {
            _this.refreshTrackStyle();
            _this.isTrackMoving = false;
          }, 200);
        });
      })();
    }
  };

  /**
   * Refresh track style
   */
  this.refreshTrackStyle = function () {
    _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + _this.options.speed + 'ms ' + _this.options.cssEase;
  };

  /**
   * autoplay track
   * @description autoplay = true
   */
  this.autoplayTrack = function () {
    if (_this.options.autoplay) {
      if (_this.timeout) {
        $timeout.cancel(_this.timeout);
      }

      _this.timeout = $timeout(function () {
        _this.next();

        $timeout.cancel(_this.timeout);
        _this.timeout = null;
      }, _this.options.autoplaySpeed);
    }
  };

  this.getSlideStyle = function (index) {
    var style = _this.slideStyle;
    if (_this.options.fade) {
      var left = -1 * index * _this.itemWidth;
      var uniqueStyle = {
        position: 'relative',
        top: '0px',
        left: left + 'px',
        'z-index': index === _this.currentSlide ? 10 : 9,
        opacity: index === _this.currentSlide ? 1 : 0
      };

      if (index >= _this.currentSlide - 1 && index <= _this.currentSlide + 1) {
        uniqueStyle.transition = 'opacity 250ms linear';
      }

      style = angular.extend(style, uniqueStyle);
    }

    return style;
  };

  /**
   * setupInfinite
   * To make carouse infinite we need close number of slidesToShow elements to
   * previous elements and to after elements
   *
   * length = 8, show = 4, scroll = 3, current = 0
   *          ---------
   *          |       |
   *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
   *          |       |
   *          ---------
   */
  this.setupInfinite = function () {
    // Clone
    var len = _this.slides.length;
    var show = _this.options.slidesToShow;

    var tmpTrack = angular.copy(_this.slides);

    if (_this.options.infinite && _this.options.fade === false) {
      if (len > show) {
        var number = show;
        for (var i = 0; i < number; i++) {
          tmpTrack.push(angular.copy(_this.slides[i]));
        }
        for (var _i = len - 1; _i >= len - show; _i--) {
          tmpTrack.unshift(angular.copy(_this.slides[_i]));
        }
      }
    }

    _this.slidesInTrack = tmpTrack;
  };

  /**
   * get number of dosts
   *
   * @return Array
   */
  this.getDots = function () {
    if (!_this.slides) {
      return [];
    }

    var dots = Math.ceil(_this.slides.length / _this.options.slidesToScroll);

    var res = [];
    for (var i = 0; i < dots; i++) {
      res.push(i);
    }
    return res;
  };

  /**
   * set carousel property
   *
   * - animType
   * - transformType
   * - transitionType
   */
  this.setProps = function () {
    var bodyStyle = document.body.style;

    /* eslint-disable */
    if (bodyStyle.OTransform !== undefined) {
      _this.animType = 'OTransform';
      _this.transformType = '-o-transform';
      _this.transitionType = 'OTransition';
    }
    if (bodyStyle.MozTransform !== undefined) {
      _this.animType = 'MozTransform';
      _this.transformType = '-moz-transform';
      _this.transitionType = 'MozTransition';
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _this.animType = 'webkitTransform';
      _this.transformType = '-webkit-transform';
      _this.transitionType = 'webkitTransition';
    }
    if (bodyStyle.msTransform !== undefined) {
      _this.animType = 'msTransform';
      _this.transformType = '-ms-transform';
      _this.transitionType = 'msTransition';
    }
    if (bodyStyle.transform !== undefined && _this.animType !== false) {
      _this.animType = 'transform';
      _this.transformType = 'transform';
      _this.transitionType = 'transition';
    }
    /* eslint-enable */

    _this.transformsEnabled = true;
  };

  /**
   * Refresh carousel
   */
  this.refreshCarousel = function () {
    if (_this.slides && _this.slides.length && _this.slides.length > _this.options.slidesToShow) {
      _this.isVisibleDots = _this.slides && _this.slides.length && _this.slides.length < 10;
      _this.isVisiblePrev = true;
      _this.isVisibleNext = true;
      _this.isClickablePrev = true;
      _this.isClickableNext = true;
    } else {
      _this.isVisibleDots = false;
      _this.isVisiblePrev = _this.options.visiblePrev || false;
      _this.isVisibleNext = _this.options.visibleNext || false;
      _this.isClickablePrev = false;
      _this.isClickableNext = false;
    }

    // Re-init UI
    _this.initUI();
  };

  /**
   * refresh model
   */
  $scope.$watchCollection('ctrl.slides', function (slides) {
    if (!slides) {
      return;
    }

    // Init carousel
    if (_this.currentSlide > slides.length - 1) {
      _this.currentSlide = slides.length - 1;
    }

    _this.setupInfinite();
    _this.refreshCarousel();
  });

  $scope.$watch('ctrl.show', function (nVal, oVal) {
        if(nVal !== oVal) {
            _this.options.slidesToShow = nVal;

            if (_this.options.slidesToScroll > nVal) {
                _this.options.slidesToScroll = nVal;
            }

            _this.refreshCarousel();
        }
    });

  $scope.$watch('ctrl.autoplay', function (nVal, oVal) {
      if(nVal){
        _this.autoplayTrack();
      } else {
          $timeout.cancel(_this.timeout);
      }
    });

  /**
   * update when resize
   *
   * @see https://github.com/mihnsen/ui-carousel/issues/10
   * @author tarkant
   */
  // angular.element($window).on('resize', this.refreshCarousel);
  //   $scope.$on('$viewContentLoaded', function (event) {
  //     console.log("calling next from inside ui-carousel");
  //     this.next;
  //   });
  //   $window.onload(function () {
  //           console.log("calling next onload from inside ui-carousel");
  //           this.next;
  //   });

  /**
   * cleanup when done
   *
   * @see https://github.com/mihnsen/ui-carousel/issues/10
   * @author tarkant
   */
  $scope.$on('$destroy', function () {
    angular.element($window).off('resize');
  });

  // Prior to v1.5, we need to call `$onInit()` manually.
  // (Bindings will always be pre-assigned in these versions.)
  if (angular.version.major === 1 && angular.version.minor < 5) {
    this.$onInit();
  }
}]);
'use strict';

angular.module('ui.carousel.directives').directive('uiCarousel', ['$compile', '$templateCache', '$sce', function ($compile, $templateCache, $sce) {

  return { restrict: 'AE',
    bindToController: true,
    scope: {
      name: '=?',
      slides: '=',
      show: '=?slidesToShow',
      scroll: '=?slidesToScroll',
      classes: '@',
      fade: '=?',
      onChange: '=?',
      disableArrow: '=?',
      autoplay: '=',
      autoplaySpeed: '=?',
      cssEase: '=?',
      speed: '=?',
      infinite: '=?',
      arrows: '=?',
      dots: '=?',
      initialSlide: '=?',
      visibleNext: '=?',
      visiblePrev: '=?',

      // Method
      onBeforeChange: '&',
      onAfterChange: '&',
      onInit: '&'
    },
    link: function link($scope, el) {
      var template = angular.element($templateCache.get('ui-carousel/carousel.template.html'));

      // dynamic injections to override the inner layers' components
      var injectComponentMap = {
        'carousel-item': '.carousel-item',
        'carousel-prev': '.carousel-prev',
        'carousel-next': '.carousel-next'
      };

      var templateInstance = template.clone();
      angular.forEach(injectComponentMap, function (innerSelector, outerSelector) {
        var outerElement = el[0].querySelector(outerSelector);
        if (outerElement) {
          angular.element(templateInstance[0].querySelector(innerSelector)).html(outerElement.innerHTML);
        }
      });

      var compiledElement = $compile(templateInstance)($scope);
      el.addClass('ui-carousel').html('').append(compiledElement);
    },


    controller: 'CarouselController',
    controllerAs: 'ctrl'
  };
}]);
'use strict';

angular.module('ui.carousel.providers').provider('Carousel', function () {
  var _this = this;

  this.options = {
    // Init like Slick carousel
    // XXX Should be revised
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    cssEase: 'ease',
    dots: true,

    easing: 'linear',
    fade: false,
    infinite: true,
    initialSlide: 0,

    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,

    visiblePrev: false,
    visibleNext: false,

    // Not available right now
    draggable: true,

    lazyLoad: 'ondemand',

    swipe: true,
    swipeToSlide: false,
    touchMove: true,

    vertical: false,
    verticalSwiping: false
  };
  this.$get = [function () {
    return {
      setOptions: function setOptions(options) {
        _this.options = angular.extend(_this.options, options);
      },
      getOptions: function getOptions() {
        return _this.options;
      }
    };
  }];
});
'use strict';

(function (module) {
  try {
    module = angular.module('ui.carousel');
  } catch (e) {
    module = angular.module('ui.carousel', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('ui-carousel/carousel.template.html', '<div class="carousel-wrapper" ng-show="ctrl.isCarouselReady"><div class="track-wrapper"><div class="track" ng-style="ctrl.trackStyle"><div class="slide" ng-repeat="item in ctrl.slidesInTrack track by $index" ng-style="ctrl.getSlideStyle($index)"><div class="carousel-item"></div></div></div></div><div class="carousel-prev" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisiblePrev &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickablePrev}" ng-click="ctrl.prev()"><button class="carousel-btn"><i class="ui-icon-prev"></i></button></div><div class="carousel-next" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisibleNext &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickableNext}" ng-click="ctrl.next()"><button class="carousel-btn"><i class="ui-icon-next"></i></button></div><ul class="carousel-dots" ng-show="ctrl.isVisibleDots &amp;&amp; ctrl.options.dots"><li ng-repeat="dot in ctrl.getDots()" ng-class="{ \'carousel-active\': dot == ctrl.currentSlide/ctrl.options.slidesToScroll }" ng-click="ctrl.movePage(dot)"><button>{{ dot }}</button></li></ul></div>');
  }]);
})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.auth.login')
        .controller('LoginCtrl', ['$scope', '$state', 'authService', 'toastr', LoginCtrl]);

    /** @ngInject */
    function LoginCtrl($scope, $state, authService, toastr) {

        var fake = false;
        if(authService.isAuthenticated()) {
            $state.go('dashboard');
        }
        console.log("login page");

        $scope.login = function () {
            toastr.clear();
            authService
                .login($scope.loginData)
                .then(loginSuccess, loginFailed);
        };
        $state.go('dashboard');

        var loginFailed = function (message) { showErrorToast(message); };
        var loginSuccess = function () { showSuccessToast() };

        var showErrorToast = function (message) {
            toastr.error(message, 'Sign In Failed', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "error",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
        };

        var showSuccessToast = function(){
            toastr.success('Welcome to Inovace Client Panel!', 'Sign in success!', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "success",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            })
        };
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.auth.logout')
        .controller('LogoutCtrl', ['authService', LogoutCtrl]);

    /** @ngInject */
    function LogoutCtrl(authService) {
        console.log("logout page");
        authService.logout();
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('DashboardCtrl', [ 'authService','$state','schoolService','baConfig','$timeout','$scope',DashboardCtrl]);

    /** @ngInject */
    function DashboardCtrl(authService,$state,schoolService,baConfig,$timeout,$scope) {

        // ------ Bindable variables and methods ------//
        var vm = this;
        vm.dashboardData = [];
        vm.index = 0;
        vm.slidesToShow = 2;
        vm.slidesToScroll = 1;
        vm.feedData = [];
        vm.autoplay = true;
        vm.showDots = true;
        vm.showingSlide = 0;
        vm.dataLoaded = false;
        vm.feedDataLoaded = false;
        vm.isEducationOfficeAdmin = authService.isEducationOfficeAdmin();

        var labels = ["Late", "Absent", "On Time"];
        var colours = ['#e1be47', '#E65759', '#299d91'];
        var schoolId = authService.getLoggedInUser().schoolId;


        vm.labelsAndColors = [{
            colour: colours[0],
            label: labels[0]
        }, {
            colour: colours[1],
            label: labels[1]
        }, {
            colour: colours[2],
            label: labels[2]
        }];

        var options = {
            elements: {
                arc: {
                    borderWidth: 0
                }
            },
            legend: {
                display: false,
                position: 'bottom',
                labels: {
                    fontColor: baConfig.colors.defaultText
                }
            },
            'onClick' : function (evt, item) {
                var id = item[0]._chart.canvas.id.substring(9);
                if(id){
                    $state.go('teacher.dailyAttendance', { schoolId : id ? id : null } );
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            cutoutPercentage: 60
        };


        function init() {
            if(!vm.isEducationOfficeAdmin){
                schoolService.getDashboardData(schoolId).then(function (data) {
                    //console.log(JSON.stringify(data));
                    vm.dataLoaded = true;
                    for(var i = 0; i < data.length; i++){
                        data[i].colours = colours;
                        data[i].options = options;
                        data[i].options.titles = [];
                        data[i].options.titles[0]={
                            "text" : data[i].className ,
                            'size' : 15,
                            "bold" : false
                        };
                        data[i].labels = labels;
                        data[i].data = [data[i].late,(data[i].total-data[i].onTime-data[i].late),data[i].onTime];

                    }
                    $timeout(function () {
                        vm.dashboardData = data;
                        vm.slidesToShow = vm.dashboardData.length == 1 ? 1 : 2;
                    });
                },function (error) {
                    vm.dataLoaded = true;
                    console.log(error);
                });
            } else {
                schoolService.getDashboardDataForEducationOffice().then(function (data) {
                    //console.log(JSON.stringify(data));
                    vm.dataLoaded = true;
                    data = data.filter(function (item) {
                        return item.total > 0;
                    });
                    for(var i = 0; i < data.length; i++){
                        data[i].colours = colours;
                        data[i].options = options;
                        data[i].options.titles = [];
                        data[i].options.titles[0]={
                            "text" : data[i].className ,
                            'size' : 15,
                            "bold" : false
                        };
                        data[i].labels = labels;
                        data[i].data = [data[i].late,(data[i].total-data[i].onTime-data[i].late),data[i].onTime];
                    }
                    $timeout(function () {
                        vm.dashboardData = data;
                        vm.slidesToShow = vm.dashboardData.length == 1 ? 1 : 2;
                    });

                },function (error) {
                    vm.dataLoaded = true;
                    console.log(error);
                });
            }

            schoolService.getFeedData().then(function (feedData) {
                vm.feedData = feedData;
                vm.feedDataLoaded = true;
            },function (error) {
                console.log("Could not fetch attendance feed");
            });
            if(vm.dashboardData.length>20) vm.showDots = false;
        }

        init();

        $scope.$on("next-carousel", function (event, curSlide) {
            vm.showingSlide = curSlide+1;
        });
        $scope.$on("prev-carousel", function (event, curSlide) {
            vm.showingSlide = curSlide-1;
        });
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.educationOffice')
        .controller('EducationOfficeCtrl', ['educationOfficeService', 'authService','toastr', EducationOfficeCtrl]);


    function EducationOfficeCtrl (educationOfficeService, authService,toastr) {
        var vm = this;
        vm.educationOfficeList = [];
        vm.dataLoaded = false;
        vm.isAdmin = authService.isAdmin();
        vm.isEducationOfficeAdmin = authService.isEducationOfficeAdmin();
        function init() {
            educationOfficeService.getAllEducationOffices().then(function (data) {
                vm.educationOfficeList = data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get Education Offices");
            });
        }
        init();
    }


})();

(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.holidays')
        .controller('HolidayCtrl',['$scope','calendarConfig','holidayService','authService','toastr','$location','$anchorScroll','$timeout', HolidayCtrl]);

    function HolidayCtrl($scope,calendarConfig,holidayService,authService,toastr,$location,$anchorScroll,$timeout) {
        var vm = this;

        vm.offDaysString = null;
        vm.off = {} ;
        vm.off.offDaysArray = [];
        vm.calendarView = null;
        vm.viewDate = new Date();
        vm.newEventAdded = false;
        vm.events = [];
        vm.cellIsOpen = false;

        vm.cellModifier = cellModifier;
        vm.goToSection = goToSection;
        vm.toggle = toggle;
        vm.timespanClicked = timespanClicked;

        function init () {

            vm.calendarView = 'month';
            vm.offDaysString = !authService.getAllInformation().weeklyOffDaysPolicy? '0000000':authService.getAllInformation().weeklyOffDaysPolicy.offDays;
            if(!vm.offDaysString )
                vm.offDaysString = '0000000';
            createOffDaysArray();
            getStartDayOfWeek();
            holidayService.getAllHolidays().then(onHolidayFetchSuccess,onHolidayFetchFailure);
        }

        init();

        function createOffDaysArray  () {
            for (var i = 0; i < 7; i++) {
                if (vm.offDaysString.charAt(i) === '1') {
                    vm.off.offDaysArray.push(i);
                }
            }
        }

        function getStartDayOfWeek() {
            var startDayOfWeek = (vm.off.offDaysArray && Array.isArray(vm.off.offDaysArray) && vm.off.offDaysArray.length>0)
                ? ((vm.off.offDaysArray[vm.off.offDaysArray.length-1]+1)%7) : 0;
            moment.locale('en_gb', {
                week : {
                    dow : startDayOfWeek // Monday = 1 is the first day of the week
                }
            });
        }

        function cellModifier(cell) {
            cell.isWeekend = false;
            if(vm.off.offDaysArray.length > 0 && vm.off.offDaysArray.includes(cell.date.day()))
            {
                cell.isWeekend = true;
                cell.cssClass = 'weekly-off-day';
            }
        }

        function onHolidayFetchSuccess (data) {
            angular.forEach(data, function (value,key) {
                vm.events.push
                (
                    {
                        id:value.id,
                        title: value.description,
                        startsAt: new Date(value.holidayDate),
                        color: calendarConfig.colorTypes.info,
                        allDay:true
                    }
                );
            });
        }

        function onHolidayFetchFailure (error) {
            console.error("Fetching failed : " + error);
        }

        function goToSection  (data) {
            $timeout(function () {
                $location.hash(data)
                $anchorScroll();
            })
        }

        function toggle ($event, field, event) {
            $event.preventDefault();
            $event.stopPropagation();
            event[field] = !event[field];
        }

        function timespanClicked (date, cell) {
            if (vm.calendarView === 'month') {
                if ((vm.cellIsOpen && moment(date).startOf('day').isSame(moment(vm.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = date;
                }
            } else if (vm.calendarView === 'year') {
                if ((vm.cellIsOpen && moment(date).startOf('month').isSame(moment(vm.viewDate).startOf('month'))) || cell.events.length === 0) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = date;
                }
            }
        }

        //update local list on new holiday creation
        $scope.$on("calendar-holiday-created", function(event,data){
            formatEventAndAddToCalendar(data);
            toastr.success("Event successfully added");
        });

        function formatEventAndAddToCalendar (event) {
            var data = {
                id:event.id,
                title: event.description,
                startsAt: new Date(event.holidayDate),
                color: calendarConfig.colorTypes.info,
                allDay:true
            };
            vm.events.push(data);
        }

        //remove event from local on delete
        $scope.$on("calendar-holiday-deleted", function(event,index){
           vm.events.splice(index,1);
           toastr.success("Event deleted");
        });

        //update event on local on update
        $scope.$on('calendar-holiday-updated',function (event,data) {
            var holiday = {
                title: data.data.description,
                startsAt: new Date(data.data.holidayDate),
                color: calendarConfig.colorTypes.info,
                allDay:true
            };
            vm.events[data.index] = holiday;
            toastr.success("Holiday update successful");
        });
    }


})();

(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.holidays')
        .controller('HolidayTableCtrl',['$scope','holidayService','$uibModal', HolidayTableCtrl]);

    function HolidayTableCtrl($scope,holidayService,$uibModal) {
        var vm = this;

        vm.events = [];
        vm.eventToCreate = null;
        vm.eventToDelete = null;

        vm.openCreateModal = openCreateModal;
        vm.openDeleteModal = openDeleteModal;
        vm.openUpdateModal = openUpdateModal;
        
        function init() {
            holidayService.getAllHolidays().then(onHolidayFetchSuccess,onHolidayFetchFailure)
        }

        init();

        function onHolidayFetchSuccess (data) {
            vm.events = data;
        }

        function onHolidayFetchFailure (error) {
            console.error(error);
        }
        
        function openCreateModal () {
            $uibModal.open({
                templateUrl: 'app/pages/main/holidays/holidayModals/createHoliday.modal.html',
                controller: 'HolidayCreateModalCtrl',
                controllerAs: 'vm'
            }).result.then(function (data) {
                    vm.events.push(data);
                    $scope.$emit("calendar-holiday-created",data);
                });
        }

        function openDeleteModal(event,index)
        {
            $uibModal.open({
                templateUrl: 'app/pages/main/holidays/holidayModals/deleteHoliday.modal.html',
                controller: 'HolidayDeleteModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    holidayToDelete: function () { return event }
                }
            }).result.then(function (event) {
                vm.events.splice(index,1);
                $scope.$emit("calendar-holiday-deleted",{event:event,index:index});
            });
        }

        function openUpdateModal(event,index)
        {
            $uibModal.open({
                templateUrl: 'app/pages/main/holidays/holidayModals/updateHoliday.modal.html',
                controller: 'HolidayUpdateModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    holidayToUpdate: function () { return event; }
                }
            }).result.then(function (data) {
                vm.events[index] = data;
                console.log(data)
                $scope.$emit("calendar-holiday-updated",{data:data,index:index});
            });
        }

    }


})();
'use strict';
angular
    .module('mwl.calendar')
    .constant('calendarConfig', {
        allDateFormats: {
            angular: {
                date: {
                    hour: 'ha',
                    day: 'd MMM',
                    month: 'MMMM',
                    weekDay: 'EEEE',
                    time: 'HH:mm',
                    datetime: 'MMM d, h:mm a'
                },
                title: {
                    day: 'EEEE d MMMM, yyyy',
                    week: 'Week {week} of {year}',
                    month: 'MMMM yyyy',
                    year: 'yyyy'
                }
            },
            moment: {
                date: {
                    hour: 'ha',
                    day: 'D MMM',
                    month: 'MMMM',
                    weekDay: 'dddd',
                    time: 'hh:mm a',
                    datetime: 'MMM D, h:mm a'
                },
                title: {
                    day: 'dddd D MMMM, YYYY',
                    week: 'Week {week} of {year}',
                    month: 'MMMM YYYY',
                    year: 'YYYY'
                }
            }
        },
        get dateFormats() {
            return this.allDateFormats[this.dateFormatter].date;
        },
        get titleFormats() {
            return this.allDateFormats[this.dateFormatter].title;
        },
        dateFormatter: 'moment',
        showTimesOnWeekView: false,
        displayAllMonthEvents: false,
        i18nStrings: {
            weekNumber: 'Week {week}'
        },
        templates: {},
        colorTypes: {
            info: {
                primary: '#1e90ff',
                secondary: '#d1e8ff'
            },
            important: {
                primary: '#ad2121',
                secondary: '#fae3e3'
            },
            warning: {
                primary: '#e3bc08',
                secondary: '#fdf1ba'
            },
            inverse: {
                primary: '#1b1b1b',
                secondary: '#c1c1c1'
            },
            special: {
                primary: '#800080',
                secondary: '#ffe6ff'
            },
            success: {
                primary: '#006400',
                secondary: '#caffca'
            }
        }
    });
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.notice')
        .controller('NoticeCtrl', ['noticeService','authService','$scope','toastr', '$filter', '$uibModal', 'Upload', 'API', NoticeCtrl]);

    function NoticeCtrl (noticeService,authService,$scope,toastr,$filter,$uibModal,Upload,API) {
        var vm = this;
        vm.noticeList = [];
        vm.dataLoaded = false;
        vm.noticeId = null;
        vm.subject = null;
        vm.description = null;
        vm.publishDate = new Date();
        vm.imgDir = null;
        vm.fileDir = null;
        vm.schoolId = authService.getLoggedInUser().schoolId;
        vm.currentNoticePicURL = null;
        vm.defaultImage = null;
        vm.noImage = true;
        vm.isDataReady = null;
        vm.editMood = false;
        vm.showNoticeImageUploadModal = showNoticeImageUploadModal;
        vm.uploadNoticeImage = uploadNoticeImage;
        vm.createNotice = createNotice;
        vm.editNotice = editNotice;
        vm.updateNotice = updateNotice;
        vm.openDeleteModal = openDeleteModal;

        function init() {
            vm.currentNoticePicURL = $filter('appImage')('theme/no-image.jpg');
            noticeService.getAllNotices().then(function (data) {
                console.log(data);
                vm.noticeList = data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get Notices");
            })
        }
        $scope.publishDate = function() {
            $scope.publishDate.opened = true;
        };
        function showNoticeImageUploadModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/notice/noticeImageUploadModal/noticeImageUpload.modal.html',
                controller: 'NoticeImageUploadModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    currentNoticePicURL: function () {
                        return vm.currentNoticePicURL;
                    },
                    userId: function () {
                        return vm.userId;
                    }
                }
            }).result.then(function (noticeImage) {
                console.log(noticeImage);
                vm.currentNoticePicURL = noticeImage.url;
                vm.noPicture = false;
            }, function () {
                console.log("Notice image upload modal dismissed.");
            });
        }

        function createNotice() {
            if(vm.subject == null) return toastr.error("Notice Title cannot be empty");
            if(vm.description == null) return toastr.error("Notice Description cannot be empty");
            if(vm.publishDate == null) return toastr.error("Publish date cannot be empty");

            var data = {
                subject:vm.subject,
                description:vm.description,
                publishDate:vm.publishDate.getTime(),
                imgDir :vm.currentNoticePicURL,
                fileDir : vm.fileDir,
                type : "general",
                schoolId : vm.schoolId,
            }

            noticeService.createNotice(data).then(function (data) {
                toastr.success("Notice created");
                vm.noticeList = data.noticeList;
                vm.subject = null;
                vm.description = null;
                vm.publishDate = new Date();
                vm.imgDir = null;
                vm.fileDir = null;
                vm.currentNoticePicURL = $filter('appImage')('theme/no-image.jpg');
            },function (error) {
                toastr.error("Could not create notice");
            });
        }
        function editNotice(notice) {
            vm.noticeId = notice.id;
            vm.subject = notice.subject;
            vm.description = notice.description;
            vm.publishDate = notice.publishDate;
            vm.currentNoticePicURL = notice.imgDir;
            vm.editMood = true;
        }
        function updateNotice() {
            if(vm.subject == null) return toastr.error("Notice Title cannot be empty");
            if(vm.description == null) return toastr.error("Notice Description cannot be empty");
            if(vm.publishDate == null) return toastr.error("Publish date cannot be empty");

            var data = {
                subject:vm.subject,
                description:vm.description,
                publishDate:vm.publishDate.getTime(),
                imgDir :vm.currentNoticePicURL,
                fileDir : vm.fileDir,
            }

            noticeService.editNotice(vm.noticeId,data).then(function (data) {
                toastr.success("Notice updated");
                vm.noticeList = data.noticeList;
                vm.editMood = false;
                vm.noticeId = null;
                vm.subject = null;
                vm.description = null;
                vm.publishDate = new Date();
                vm.imgDir = null;
                vm.fileDir = null;
                vm.currentNoticePicURL = $filter('appImage')('theme/no-image.jpg');
            },function (error) {
                toastr.error("Could not update notice");
            });
        }
        function openDeleteModal(notice) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/notice/delete/delete.modal.html',
                size : 'md',
                controller : 'DeleteNoticeCtrl',
                controllerAs : 'vm',
                resolve:{
                    notice: function () {
                        return notice;
                    }
                }
            }).result.then(function (noticeList) {
                toastr.success("Notice deleted");
                vm.noticeList = noticeList;
            }, function () {
                console.error("Could not delete notice");
            });
        }
        function uploadNoticeImage(dataUrl, name) {
            console.log(dataUrl);
            Upload.upload({
                url: API.student.uploadPicture,
                data: {
                    file: Upload.dataUrltoBlob(dataUrl, name)
                }
            }).then(function (response) {
                if (response.status === 200) {
                    vm.imgDir = response.data.url;
                    toastr.success("Notice image uploaded.");
                } else {
                    toastr.error("Failed to upload notice image " + response.message);
                }

            }, function (response) {
                if (response.status > 0) {
                    toastr.error("Failed to upload notice image. " + response.message);
                }
            });
        }
        init();
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.school')
        .controller('SchoolCtrl', ['schoolService', 'authService','$q','toastr', SchoolCtrl]);


    function SchoolCtrl (schoolService, authService,$q,toastr) {
        var vm = this;
        vm.schoolList = [];
        vm.dataLoaded = false;
        vm.isAdmin = authService.isAdmin();
        vm.isEducationOfficeAdmin = authService.getLoggedInUser().isEducationOfficeAdmin;
        vm.searchString = '';

        vm.getAllSchools = getAllSchools;
        vm.clearFilter = clearFilter;

        function init() {
            $q.all([getAllSchools(vm.searchString)]).then(function () {
                console.log("All data loaded");
            })
        }
        init();

        function getAllSchools(searchString) {
            vm.dataLoaded = false;
            return schoolService.getAllSchools(searchString).then(function (data) {
                vm.schoolList = data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get Schools");
            });
        }
        function clearFilter() {
            vm.searchString = "";
            vm.dataLoaded = false;
            getAllSchools(vm.searchString);
        }
    }


})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];

        this.addStaticItem = function () {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        /** @ngInject */
        this.$get = function ($state, layoutSizes, $rootScope) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();

                this.getMenuItems = function () {
                    var states = defineMenuItemStates();
                    var menuItems = states.filter(function (item) {
                        return item.level == 0;
                    });

                    menuItems.forEach(function (item) {
                        var children = states.filter(function (child) {
                            return child.level == 1 && child.name.indexOf(item.name) === 0;
                        });
                        item.subMenu = children.length ? children : null;
                    });

                    // remove profile from menu if the logged in person is admin
                    //if($rootScope.loggedInUser.isAdmin && $rootScope.loggedInUser.isAdmin === true){
                        staticMenuItems.splice(staticMenuItems.findIndex(function (item) {
                            if(item.name === "profile") return true;
                        }));
                    //}

                    return menuItems.concat(staticMenuItems);
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function (isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function () {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function () {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function (item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates() {
                    return $state.get()
                        .filter(function (s) {
                            if($rootScope.loggedInUser.isEducationOfficeAdmin){
                                if(s.name === 'teacher.createTeacher' || s.name === 'teacher.batchCreateTeachers' || s.name === 'leave' || s.name === 'holidays'){
                                    return false;
                                }
                            } else if(!$rootScope.loggedInUser.isEducationOfficeAdmin && !$rootScope.loggedInUser.isAdmin){
                                if(s.name === 'educationOffice'){
                                    return false;
                                }
                            }
                            return s.sidebarMeta;
                        })
                        .map(function (s) {
                            var meta = s.sidebarMeta;
                            return {
                                name: s.name,
                                title: s.title,
                                level: (s.name.match(/\./g) || []).length,
                                order: meta.order,
                                icon: meta.icon,
                                stateRef: s.name,
                                code: (s.data!= null && s.data.code != null )? s.data.code : null
                            };
                        })
                        .sort(function (a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        };

    }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
          if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    //console.log(JSON.stringify($state.current));
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
          $scope.parentPageTitle = $state.current.parentTitle;
          $scope.parentPageLink = $state.current.parentLink;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
(function () {
  'use strict';
  angular
      .module('BlurAdmin.theme.components')
      .controller('PageTopController', ['$scope','$rootScope','authService','$translate','$window', PageTopController]);

  /** @ngInject */
  function PageTopController($scope,$rootScope,authService,$translate,$window) {
      $scope.projectName = authService.getProjectName();
      $scope.activeLanguage = $window.localStorage.getItem('language');
      $translate.use($window.localStorage.getItem('language'));

      $scope.changeToBangla = function () {
        $window.localStorage.setItem('language','bn');
        $translate.use('bn');
        $scope.activeLanguage = 'bn';
      };
      $scope.changeToEnglish = function () {
          $window.localStorage.setItem('language','en');
          $translate.use('en');
          $scope.activeLanguage = 'en';
      }
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', ['authService', pageTop]);

  /** @ngInject */
  function pageTop(authService) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'PageTopController'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.academics.class')
        .controller('ClassCtrl', ['$scope','classService','authService','$uibModal','toastr', ClassCtrl]);


    function ClassCtrl ($scope,classService,authService,$uibModal,toastr) {
        var vm = this;
        vm.classList = [];
        vm.dataLoaded = false;
        vm.name = null;
        vm.createClass = createClass;
        vm.editClass = editClass;
        vm.saveClass = saveClass;
        vm.openDeleteModal = openDeleteModal;

        function init() {
            classService.getAllClasses().then(function (data) {
                vm.classList = data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get Schools");
            })
        }

        init();

        function broadcastClassList(classList) {
            $scope.$broadcast('classList-updated',{classList:classList});
        }

        function editClass(index) {
            console.log("Edit mode on");
            vm.classList[index].textForm = null;
            vm.classList[index].editMode = vm.classList[index].editMode == null? true :!vm.classList[index].editMode;
        }

        function saveClass(classObject,name) {
            var data = {
                name:name
            };
            classService.updateClass(classObject.id,data).then(function (responseData) {
                vm.classList = responseData;
                broadcastClassList(responseData);
                toastr.success("Class update successful");
            },function (error) {
                toastr.error("Could not update class");
            });
        }

        function openDeleteModal(classObject) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/academics/class/delete/delete.modal.html',
                size : 'md',
                controller : 'DeleteClassCtrl',
                controllerAs : 'vm',
                resolve:{
                    classObject: function () {
                        return classObject;
                    }
                }
            }).result.then(function (classList) {
                toastr.success("Class deleted");
                broadcastClassList(classList);
                vm.classList = classList;
            }, function () {
                console.error("Could not delete class");
            });
        }

        function createClass() {
            var schoolId = authService.getLoggedInUser().schoolId;
            if(vm.name == null || vm.name=='')
                return toastr.error("Name cannot be empty");
            var data = {
                name:vm.name,
                schoolId:Number(schoolId),
            };
            classService.createClass(data).then(function (responseData) {
                toastr.success("Class creation successful");
                broadcastClassList(responseData);
                vm.classList = responseData;
                vm.name = null;
            },function (error) {
                toastr.error("Class creation failed");
            })
        }

    }


})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.academics.class')
        .controller('SectionCtrl', ['sectionService','authService','$uibModal','toastr', SectionCtrl]);


    function SectionCtrl (sectionService,authService,$uibModal,toastr) {
        var vm = this;
        vm.sectionList = [];
        vm.dataLoaded = false;
        vm.name = null;
        vm.createSection = createSection;
        vm.saveSection = saveSection;
        vm.openDeleteModal = openDeleteModal;

        function init() {
            sectionService.getAllSections().then(function (data) {
                vm.sectionList= data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get Schools");
            })
        }

        init();


        function saveSection(section,name) {
            var data = {
                name:name
            };
            sectionService.updateSection(section.id,data).then(function (responseData) {
                vm.sectionList = responseData;
                toastr.success("Section update successful");
            },function (error) {
                toastr.error("Could not update section");
            });
        }

        function openDeleteModal(section) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/academics/section/delete/delete.modal.html',
                size : 'md',
                controller : 'DeleteSectionCtrl',
                controllerAs : 'vm',
                resolve:{
                    section: function () {
                        return section;
                    }
                }
            }).result.then(function (sectionList) {
                toastr.success("Section deleted");
                vm.sectionList = sectionList;
            }, function () {
                console.error("Could not delete section");
            });
        }

        function createSection() {
            var schoolId = authService.getLoggedInUser().schoolId;
            if(vm.name == null || vm.name=='')
                return toastr.error("Name cannot be empty");
            var data = {
                name:vm.name,
                schoolId:Number(schoolId),
            };
            sectionService.createSection(data).then(function (responseData) {
                toastr.success("Section creation successful");
                vm.sectionList = responseData;
                vm.name = null;
            },function (error) {
                toastr.error("Section creation failed");
            })
        }

    }


})();
/*
 * Angular JS Multi Select
 * Creates a dropdown-like button with checkboxes.
 *
 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
 * Current version: 4.0.0
 *
 * Released under the MIT License
 * --------------------------------------------------------------------------------
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * --------------------------------------------------------------------------------
 */

'use strict'

angular.module('InovaceClientApp.pages.main').directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
    return {
        restrict:
            'AE',

        scope:
            {
                // models
                inputModel      : '=',
                outputModel     : '=',

                // settings based on attribute
                isDisabled      : '=',

                // callbacks
                onClear         : '&',
                onClose         : '&',
                onSearchChange  : '&',
                onItemClick     : '&',
                onOpen          : '&',
                onReset         : '&',
                onSelectAll     : '&',
                onSelectNone    : '&',

                // i18n
                translation     : '='
            },

        /*
         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
         */

        templateUrl:
            'isteven-multi-select.htm',

        link: function ( $scope, element, attrs ) {

            $scope.backUp           = [];
            $scope.varButtonLabel   = '';
            $scope.spacingProperty  = '';
            $scope.indexProperty    = '';
            $scope.orientationH     = false;
            $scope.orientationV     = true;
            $scope.filteredModel    = [];
            $scope.inputLabel       = { labelFilter: '' };
            $scope.tabIndex         = 0;
            $scope.lang             = {};
            $scope.helperStatus     = {
                all     : true,
                none    : true,
                reset   : true,
                filter  : true
            };

            var
                prevTabIndex        = 0,
                helperItems         = [],
                helperItemsLength   = 0,
                checkBoxLayer       = '',
                scrolled            = false,
                selectedItems       = [],
                formElements        = [],
                vMinSearchLength    = 0,
                clickedItem         = null

            // v3.0.0
            // clear button clicked
            $scope.clearClicked = function( e ) {
                $scope.inputLabel.labelFilter = '';
                $scope.updateFilter();
                $scope.select( 'clear', e );
            }

            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
            $scope.numberToArray = function( num ) {
                return new Array( num );
            }

            // Call this function when user type on the filter field
            $scope.searchChanged = function() {
                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
                    return false;
                }
                $scope.updateFilter();
            }

            $scope.updateFilter = function()
            {
                // we check by looping from end of input-model
                $scope.filteredModel = [];
                var i = 0;

                if ( typeof $scope.inputModel === 'undefined' ) {
                    return false;
                }

                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {

                    // if it's group end, we push it to filteredModel[];
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
                        $scope.filteredModel.push( $scope.inputModel[ i ] );
                    }

                    // if it's data
                    var gotData = false;
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {

                        // If we set the search-key attribute, we use this loop.
                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {

                            for (var key in $scope.inputModel[ i ]  ) {
                                if (
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0
                                    && attrs.searchProperty.indexOf( key ) > -1
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }
                        }
                        // if there's no search-key attribute, we use this one. Much better on performance.
                        else {
                            for ( var key in $scope.inputModel[ i ]  ) {
                                if (
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }
                        }

                        if ( gotData === true ) {
                            // push
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }

                    // if it's group start
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {

                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined'
                            && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
                            $scope.filteredModel.pop();
                        }
                        else {
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }
                }

                $scope.filteredModel.reverse();

                $timeout( function() {

                    $scope.getFormElements();

                    // Callback: on filter change
                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {

                        var filterObj = [];

                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' ) {
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {
                                    var tempObj = angular.copy( value );
                                    var index = filterObj.push( tempObj );
                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];
                                }
                            }
                        });

                        $scope.onSearchChange({
                            data:
                                {
                                    keyword: $scope.inputLabel.labelFilter,
                                    result: filterObj
                                }
                        });
                    }
                },0);
            };

            // List all the input elements. We need this for our keyboard navigation.
            // This function will be called everytime the filter is updated.
            // Depending on the size of filtered mode, might not good for performance, but oh well..
            $scope.getFormElements = function() {
                formElements = [];

                var
                    selectButtons   = [],
                    inputField      = [],
                    checkboxes      = [],
                    clearButton     = [];

                // If available, then get select all, select none, and reset buttons
                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.reset ) {
                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    // If available, then get the search box and the clear button
                    if ( $scope.helperStatus.filter ) {
                        // Get helper - search and clear button.
                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );
                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );
                    }
                }
                else {
                    if ( $scope.helperStatus.filter ) {
                        // Get helper - search and clear button.
                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );
                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    }
                }

                // Get checkboxes
                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
                }
                else {
                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
                }

                // Push them into global array formElements[]
                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }
            }

            // check if an item has attrs.groupProperty (be it true or false)
            $scope.isGroupMarker = function( item , type ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true;
                return false;
            }

            $scope.removeGroupEndMarker = function( item ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false;
                return true;
            }

            // call this function when an item is clicked
            $scope.syncItems = function( item, e, ng_repeat_index ) {

                e.preventDefault();
                e.stopPropagation();

                // if the directive is globaly disabled, do nothing
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {
                    return false;
                }

                // if item is disabled, do nothing
                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {
                    return false;
                }

                // if end group marker is clicked, do nothing
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
                    return false;
                }

                var index = $scope.filteredModel.indexOf( item );

                // if the start of group marker is clicked ( only for multiple selection! )
                // how it works:
                // - if, in a group, there are items which are not selected, then they all will be selected
                // - if, in a group, all items are selected, then they all will be de-selected
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {

                    // this is only for multiple selection, so if selection mode is single, do nothing
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        return false;
                    }

                    var i,j,k;
                    var startIndex = 0;
                    var endIndex = $scope.filteredModel.length - 1;
                    var tempArr = [];

                    // nest level is to mark the depth of the group.
                    // when you get into a group (start group marker), nestLevel++
                    // when you exit a group (end group marker), nextLevel--
                    var nestLevel = 0;

                    // we loop throughout the filtered model (not whole model)
                    for( i = index ; i < $scope.filteredModel.length ; i++) {

                        // this break will be executed when we're done processing each group
                        if ( nestLevel === 0 && i > index )
                        {
                            break;
                        }

                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {

                            // To cater multi level grouping
                            if ( tempArr.length === 0 ) {
                                startIndex = i + 1;
                            }
                            nestLevel = nestLevel + 1;
                        }

                        // if group end
                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {

                            nestLevel = nestLevel - 1;

                            // cek if all are ticked or not
                            if ( tempArr.length > 0 && nestLevel === 0 ) {

                                var allTicked = true;

                                endIndex = i;

                                for ( j = 0; j < tempArr.length ; j++ ) {
                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
                                        allTicked = false;
                                        break;
                                    }
                                }

                                if ( allTicked === true ) {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                        }
                                    }
                                }

                                else {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;

                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        // if data
                        else {
                            tempArr.push( $scope.filteredModel[ i ] );
                        }
                    }
                }

                // if an item (not group marker) is clicked
                else {

                    // If it's single selection mode
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {

                        // first, set everything to false
                        for( i=0 ; i < $scope.filteredModel.length ; i++) {
                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;
                        }
                        for( i=0 ; i < $scope.inputModel.length ; i++) {
                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;
                        }

                        // then set the clicked item to true
                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;
                    }

                    // Multiple
                    else {
                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
                    }

                    // we refresh input model as well
                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];
                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];
                }

                // we execute the callback function here
                clickedItem = angular.copy( item );
                if ( clickedItem !== null ) {
                    $timeout( function() {
                        delete clickedItem[ $scope.indexProperty ];
                        delete clickedItem[ $scope.spacingProperty ];
                        $scope.onItemClick( { data: clickedItem } );
                        clickedItem = null;
                    }, 0 );
                }

                $scope.refreshOutputModel();
                $scope.refreshButton();

                // We update the index here
                prevTabIndex = $scope.tabIndex;
                $scope.tabIndex = ng_repeat_index + helperItemsLength;

                // Set focus on the hidden checkbox
                e.target.focus();

                // set & remove CSS style
                $scope.removeFocusStyle( prevTabIndex );
                $scope.setFocusStyle( $scope.tabIndex );

                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                    // on single selection mode, we then hide the checkbox layer
                    $scope.toggleCheckboxes( e );
                }
            }

            // update $scope.outputModel
            $scope.refreshOutputModel = function() {

                $scope.outputModel  = [];
                var
                    outputProps     = [],
                    tempObj         = {};

                // v4.0.0
                if ( typeof attrs.outputProperties !== 'undefined' ) {
                    outputProps = attrs.outputProperties.split(' ');
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if (
                            typeof value !== 'undefined'
                            && typeof value[ attrs.groupProperty ] === 'undefined'
                            && value[ $scope.tickProperty ] === true
                        ) {
                            tempObj         = {};
                            angular.forEach( value, function( value1, key1 ) {
                                if ( outputProps.indexOf( key1 ) > -1 ) {
                                    tempObj[ key1 ] = value1;
                                }
                            });
                            var index = $scope.outputModel.push( tempObj );
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];
                        }
                    });
                }
                else {
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if (
                            typeof value !== 'undefined'
                            && typeof value[ attrs.groupProperty ] === 'undefined'
                            && value[ $scope.tickProperty ] === true
                        ) {
                            var temp = angular.copy( value );
                            var index = $scope.outputModel.push( temp );
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];
                        }
                    });
                }
            }

            // refresh button label
            $scope.refreshButton = function() {

                $scope.varButtonLabel   = '';
                var ctr                 = 0;

                // refresh button label...
                if ( $scope.outputModel.length === 0 ) {
                    // https://github.com/isteven/angular-multi-select/pull/19
                    $scope.varButtonLabel = $scope.lang.nothingSelected;
                }
                else {
                    var tempMaxLabels = $scope.outputModel.length;
                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
                        tempMaxLabels = attrs.maxLabels;
                    }

                    // if max amount of labels displayed..
                    if ( $scope.outputModel.length > tempMaxLabels ) {
                        $scope.more = true;
                    }
                    else {
                        $scope.more = false;
                    }

                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {
                            if ( ctr < tempMaxLabels ) {
                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
                            }
                            ctr++;
                        }
                    });

                    if ( $scope.more === true ) {
                        // https://github.com/isteven/angular-multi-select/pull/16
                        if (tempMaxLabels > 0) {
                            $scope.varButtonLabel += ', ... ';
                        }
                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';
                    }
                }
                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );
            }

            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
            // Take note that the granular control has higher priority.
            $scope.itemIsDisabled = function( item ) {

                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {
                    return true;
                }
                else {
                    if ( $scope.isDisabled === true ) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

            }

            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
            $scope.writeLabel = function( item, type ) {

                // type is either 'itemLabel' or 'buttonLabel'
                var temp    = attrs[ type ].split( ' ' );
                var label   = '';

                angular.forEach( temp, function( value, key ) {
                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
                        return prev[ current ];
                    }, item ));
                });

                if ( type.toUpperCase() === 'BUTTONLABEL' ) {
                    return label;
                }
                return $sce.trustAsHtml( label );
            }

            // UI operations to show/hide checkboxes based on click event..
            $scope.toggleCheckboxes = function( e ) {

                // We grab the button
                var clickedEl = element.children()[0];

                // Just to make sure.. had a bug where key events were recorded twice
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );

                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect
                // His version is awesome if you need a more simple multi-select approach.

                // close
                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {

                    angular.element( checkBoxLayer ).removeClass( 'show' );
                    angular.element( clickedEl ).removeClass( 'buttonClicked' );
                    angular.element( document ).off( 'click', $scope.externalClickListener );
                    angular.element( document ).off( 'keydown', $scope.keyboardListener );

                    // clear the focused element;
                    $scope.removeFocusStyle( $scope.tabIndex );
                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
                        formElements[ $scope.tabIndex ].blur();
                    }

                    // close callback
                    $timeout( function() {
                        $scope.onClose();
                    }, 0 );

                    // set focus on button again
                    element.children().children()[ 0 ].focus();
                }
                // open
                else
                {
                    // clear filter
                    $scope.inputLabel.labelFilter = '';
                    $scope.updateFilter();

                    helperItems = [];
                    helperItemsLength = 0;

                    angular.element( checkBoxLayer ).addClass( 'show' );
                    angular.element( clickedEl ).addClass( 'buttonClicked' );

                    // Attach change event listener on the input filter.
                    // We need this because ng-change is apparently not an event listener.
                    angular.element( document ).on( 'click', $scope.externalClickListener );
                    angular.element( document ).on( 'keydown', $scope.keyboardListener );

                    // to get the initial tab index, depending on how many helper elements we have.
                    // priority is to always focus it on the input filter
                    $scope.getFormElements();
                    $scope.tabIndex = 0;

                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];

                    if ( typeof helperContainer !== 'undefined' ) {
                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
                        }
                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
                    }

                    // focus on the filter element on open.
                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {
                        element[ 0 ].querySelector( '.inputFilter' ).focus();
                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
                        // blur button in vain
                        angular.element( element ).children()[ 0 ].blur();
                    }
                    // if there's no filter then just focus on the first checkbox item
                    else {
                        if ( !$scope.isDisabled ) {
                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
                            if ( $scope.inputModel.length > 0 ) {
                                formElements[ $scope.tabIndex ].focus();
                                $scope.setFocusStyle( $scope.tabIndex );
                                // blur button in vain
                                angular.element( element ).children()[ 0 ].blur();
                            }
                        }
                    }

                    // open callback
                    $scope.onOpen();
                }
            }

            // handle clicks outside the button / multi select layer
            $scope.externalClickListener = function( e ) {

                var targetsArr = element.find( e.target.tagName );
                for (var i = 0; i < targetsArr.length; i++) {
                    if ( e.target == targetsArr[i] ) {
                        return;
                    }
                }

                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );
                angular.element( checkBoxLayer ).removeClass( 'show' );
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );

                // close callback
                $timeout( function() {
                    $scope.onClose();
                }, 0 );

                // set focus on button again
                element.children().children()[ 0 ].focus();
            }

            // select All / select None / reset buttons
            $scope.select = function( type, e ) {

                var helperIndex = helperItems.indexOf( e.target );
                $scope.tabIndex = helperIndex;

                switch( type.toUpperCase() ) {
                    case 'ALL':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {
                                    value[ $scope.tickProperty ] = true;
                                }
                            }
                        });
                        $scope.refreshOutputModel();
                        $scope.refreshButton();
                        $scope.onSelectAll();
                        break;
                    case 'NONE':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {
                                    value[ $scope.tickProperty ] = false;
                                }
                            }
                        });
                        $scope.refreshOutputModel();
                        $scope.refreshButton();
                        $scope.onSelectNone();
                        break;
                    case 'RESET':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {
                                var temp = value[ $scope.indexProperty ];
                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
                            }
                        });
                        $scope.refreshOutputModel();
                        $scope.refreshButton();
                        $scope.onReset();
                        break;
                    case 'CLEAR':
                        $scope.tabIndex = $scope.tabIndex + 1;
                        $scope.onClear();
                        break;
                    case 'FILTER':
                        $scope.tabIndex = helperItems.length - 1;
                        break;
                    default:
                }
            }

            // just to create a random variable name
            function genRandomString( length ) {
                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                var temp        = '';
                for( var i=0; i < length; i++ ) {
                    temp += possible.charAt( Math.floor( Math.random() * possible.length ));
                }
                return temp;
            }

            // count leading spaces
            $scope.prepareGrouping = function() {
                var spacing     = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.spacingProperty ] = spacing;
                    if ( value[ attrs.groupProperty ] === true ) {
                        spacing+=2;
                    }
                    else if ( value[ attrs.groupProperty ] === false ) {
                        spacing-=2;
                    }
                });
            }

            // prepare original index
            $scope.prepareIndex = function() {
                var ctr = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.indexProperty ] = ctr;
                    ctr++;
                });
            }

            // navigate using up and down arrow
            $scope.keyboardListener = function( e ) {

                var key = e.keyCode ? e.keyCode : e.which;
                var isNavigationKey = false;

                // ESC key (close)
                if ( key === 27 ) {
                    e.preventDefault();
                    e.stopPropagation();
                    $scope.toggleCheckboxes( e );
                }


                // next element ( tab, down & right key )
                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {

                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex;
                    $scope.tabIndex++;
                    if ( $scope.tabIndex > formElements.length - 1 ) {
                        $scope.tabIndex = 0;
                        prevTabIndex = formElements.length - 1;
                    }
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex++;
                        if ( $scope.tabIndex > formElements.length - 1 ) {
                            $scope.tabIndex = 0;
                        }
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                    }
                }

                // prev element ( shift+tab, up & left key )
                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) {
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex;
                    $scope.tabIndex--;
                    if ( $scope.tabIndex < 0 ) {
                        $scope.tabIndex = formElements.length - 1;
                        prevTabIndex = 0;
                    }
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex--;
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                        if ( $scope.tabIndex < 0 ) {
                            $scope.tabIndex = formElements.length - 1;
                        }
                    }
                }

                if ( isNavigationKey === true ) {

                    e.preventDefault();

                    // set focus on the checkbox
                    formElements[ $scope.tabIndex ].focus();
                    var actEl = document.activeElement;

                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {
                        $scope.setFocusStyle( $scope.tabIndex );
                        $scope.removeFocusStyle( prevTabIndex );
                    }
                    else {
                        $scope.removeFocusStyle( prevTabIndex );
                        $scope.removeFocusStyle( helperItemsLength );
                        $scope.removeFocusStyle( formElements.length - 1 );
                    }
                }

                isNavigationKey = false;
            }

            // set (add) CSS style on selected row
            $scope.setFocusStyle = function( tabIndex ) {
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );
            }

            // remove CSS style on selected row
            $scope.removeFocusStyle = function( tabIndex ) {
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
            }

            /*********************
             *********************
             *
             * 1) Initializations
             *
             *********************
             *********************/

            // attrs to $scope - attrs-$scope - attrs - $scope
            // Copy some properties that will be used on the template. They need to be in the $scope.
            $scope.groupProperty    = attrs.groupProperty;
            $scope.tickProperty     = attrs.tickProperty;
            $scope.directiveId      = attrs.directiveId;

            // Unfortunately I need to add these grouping properties into the input model
            var tempStr = genRandomString( 5 );
            $scope.indexProperty = 'idx_' + tempStr;
            $scope.spacingProperty = 'spc_' + tempStr;

            // set orientation css
            if ( typeof attrs.orientation !== 'undefined' ) {

                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {
                    $scope.orientationH = true;
                    $scope.orientationV = false;
                }
                else
                {
                    $scope.orientationH = false;
                    $scope.orientationV = true;
                }
            }

            // get elements required for DOM operation
            checkBoxLayer = element.children().children().next()[0];

            // set max-height property if provided
            if ( typeof attrs.maxHeight !== 'undefined' ) {
                var layer = element.children().children().children()[0];
                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );
            }

            // some flags for easier checking
            for ( var property in $scope.helperStatus ) {
                if ( $scope.helperStatus.hasOwnProperty( property )) {
                    if (
                        typeof attrs.helperElements !== 'undefined'
                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1
                    ) {
                        $scope.helperStatus[ property ] = false;
                    }
                }
            }
            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
                $scope.helperStatus[ 'all' ] = false;
                $scope.helperStatus[ 'none' ] = false;
            }

            // helper button icons.. I guess you can use html tag here if you want to.
            $scope.icon        = {};
            $scope.icon.selectAll  = '&#10003;';    // a tick icon
            $scope.icon.selectNone = '&times;';     // x icon
            $scope.icon.reset      = '&#8630;';     // undo icon
            // this one is for the selected items
            $scope.icon.tickMark   = '&#10003;';    // a tick icon

            // configurable button labels
            if ( typeof attrs.translation !== 'undefined' ) {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
                $scope.lang.search          = $scope.translation.search;
                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );
            }
            else {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
                $scope.lang.search          = 'Search...';
                $scope.lang.nothingSelected = 'Please Select';
            }
            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );

            // min length of keyword to trigger the filter function
            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
            }

            /*******************************************************
             *******************************************************
             *
             * 2) Logic starts here, initiated by watch 1 & watch 2
             *
             *******************************************************
             *******************************************************/

            // watch1, for changes in input model property
            // updates multi-select when user select/deselect a single checkbox programatically
            // https://github.com/isteven/angular-multi-select/issues/8
            $scope.$watch( 'inputModel' , function( newVal ) {
                if ( newVal ) {
                    $scope.refreshOutputModel();
                    $scope.refreshButton();
                }
            }, true );

            // watch2 for changes in input model as a whole
            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
            $scope.$watch( 'inputModel' , function( newVal ) {
                if ( newVal ) {
                    $scope.backUp = angular.copy( $scope.inputModel );
                    $scope.updateFilter();
                    $scope.prepareGrouping();
                    $scope.prepareIndex();
                    $scope.refreshOutputModel();
                    $scope.refreshButton();
                }
            });

            // watch for changes in directive state (disabled or enabled)
            $scope.$watch( 'isDisabled' , function( newVal ) {
                $scope.isDisabled = newVal;
            });

            // this is for touch enabled devices. We don't want to hide checkboxes on scroll.
            var onTouchStart = function( e ) {
                $scope.$apply( function() {
                    $scope.scrolled = false;
                });
            };
            angular.element( document ).bind( 'touchstart', onTouchStart);
            var onTouchMove = function( e ) {
                $scope.$apply( function() {
                    $scope.scrolled = true;
                });
            };
            angular.element( document ).bind( 'touchmove', onTouchMove);

            // unbind document events to prevent memory leaks
            $scope.$on( '$destroy', function () {
                angular.element( document ).unbind( 'touchstart', onTouchStart);
                angular.element( document ).unbind( 'touchmove', onTouchMove);
            });
        }
    }
}]).run( [ '$templateCache' , function( $templateCache ) {
    var template =
        '<span class="multiSelect inlineBlock">' +
        // main button
        '<button id="{{directiveId}}" type="button"' +
        'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
        'ng-bind-html="varButtonLabel"' +
        'ng-disabled="disable-button"' +
        '>' +
        '</button>' +
        // overlay layer
        '<div class="checkboxLayer">' +
        // container of the helper elements
        '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none || helperStatus.reset ">' +
        // container of the first 3 buttons, select all, none and reset
        '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.reset ">' +
        // select all
        '<button type="button" class="helperButton"' +
        'ng-disabled="isDisabled"' +
        'ng-if="helperStatus.all"' +
        'ng-click="select( \'all\', $event );"' +
        'ng-bind-html="lang.selectAll">' +
        '</button>'+
        // select none
        '<button type="button" class="helperButton"' +
        'ng-disabled="isDisabled"' +
        'ng-if="helperStatus.none"' +
        'ng-click="select( \'none\', $event );"' +
        'ng-bind-html="lang.selectNone">' +
        '</button>'+
        // reset
        '<button type="button" class="helperButton reset"' +
        'ng-disabled="isDisabled"' +
        'ng-if="helperStatus.reset"' +
        'ng-click="select( \'reset\', $event );"' +
        'ng-bind-html="lang.reset">'+
        '</button>' +
        '</div>' +
        // the search box
        '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
        // textfield
        '<input placeholder="{{lang.search}}" type="text"' +
        'ng-click="select( \'filter\', $event )" '+
        'ng-model="inputLabel.labelFilter" '+
        'ng-change="searchChanged()" class="inputFilter"'+
        '/>'+
        // clear button
        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
        '</div> '+
        '</div> '+
        // selection items
        '<div class="checkBoxContainer">'+
        '<div '+
        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
        'ng-click="syncItems( item, $event, $index );" '+
        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
        // this is the spacing for grouped items
        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+
        '</div>  '+
        '<div class="acol">'+
        '<label>'+
        // input, so that it can accept focus on keyboard click
        '<input class="checkbox focusable" type="checkbox" '+
        'ng-disabled="itemIsDisabled( item )" '+
        'ng-checked="item[ tickProperty ]" '+
        'ng-click="syncItems( item, $event, $index )" />'+
        // item label using ng-bind-hteml
        '<span '+
        'ng-class="{disabled:itemIsDisabled( item )}" '+
        'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
        '</span>'+
        '</label>'+
        '</div>'+
        // the tick/check mark
        '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
        '</div>'+
        '</div>'+
        '</div>'+
        '</span>';
    $templateCache.put( 'isteven-multi-select.htm' , template );
}]);
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .controller('ProjectDirectiveCtrl', ['$scope','authService','projectService', ProjectDirectiveCtrl]);


    /** @ngInject */
    function ProjectDirectiveCtrl($scope,authService, projectService) {
        var vm = this;
        vm.projectList = [];
        vm.isAdmin = false;
        vm.selectedIds = [];
        vm.dataLoaded = false;

        vm.getIds = getIds;
        vm.clear = clear;

        function init() {
            vm.isAdmin = authService.isAdmin();
            if(vm.isAdmin){
                projectService.getAllActiveProjects().then(function (data) {
                    vm.dataLoaded = true;
                    vm.projectList = data.projectList;
                    $scope.ids = vm.projectList.map(function (data) {
                        return data.id;
                    });
                    console.log("In directive controller " + $scope.ids);
                })
            }else if(!vm.isAdmin) {
                $scope.ids = authService.getAllInformation().id;
            }
        }
        init();

        function getIds() {
            console.log("In directive controller" + vm.selectedProjectList);
            $scope.ids = vm.selectedProjectList.map(function (data) {
                return data.id;
            });
        }

        function clear() {
            $scope.ids = [];
        }


    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('projectDirective',function () {
            return{
                restrict:'E',
                scope:{
                  ids:"="
                },
                controller:'ProjectDirectiveCtrl as vm',
                templateUrl:'app/pages/main/directives/project/projectDirective.html'

            };
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.academics.shift')
        .controller('ShiftCtrl', ['shiftService','authService','$uibModal','toastr', ShiftCtrl]);


    function ShiftCtrl (shiftService,authService,$uibModal,toastr) {
        var vm = this;
        vm.shiftList = [];
        vm.dataLoaded = false;
        vm.name = null;
        vm.createShift = createShift;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;

        vm.fromTime = new Date();
        vm.toTime = new Date();

        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = true;

        function init() {
            shiftService.getAllShifts().then(function (data) {
                vm.shiftList = processShifts(data);
            },function (error) {
                toastr.error("Could not get Schools");
            })
        }

        init();

        function processShifts(shiftList) {
            return shiftList.map(function (shift) {
                var today = new Date();
                shift.start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Math.floor(shift.startTimeMinute/60),shift.startTimeMinute%60, 0);
                shift.end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Math.floor(shift.endTimeMinute/60),shift.endTimeMinute%60, 0);
                return shift;
            })
        }



        function openDeleteModal(shift) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/academics/shift/delete/delete.modal.html',
                size : 'md',
                controller : 'DeleteShiftCtrl',
                controllerAs : 'vm',
                resolve:{
                    shift: function () {
                        return shift;
                    }
                }
            }).result.then(function (shiftList) {
                toastr.success("Section deleted");
                vm.shiftList = processShifts(shiftList);
            }, function () {
                console.error("Could not delete shift");
            });
        }

        function openEditModal(shift) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/academics/shift/edit/edit.modal.html',
                size : 'md',
                controller : 'EditShiftCtrl',
                controllerAs : 'vm',
                resolve:{
                    shift: function () {
                        return shift;
                    }
                }
            }).result.then(function (shiftList) {
                toastr.success("Shift edited.");
                vm.shiftList = processShifts(shiftList);
            }, function () {
                console.error("Could not delete shift");
            });
        }

        function createShift() {
            var schoolId = authService.getLoggedInUser().schoolId;
            if(vm.name == null || vm.name=='')
                return toastr.error("Name cannot be empty");
            var fromMinutes = (vm.fromTime.getHours() * 60) + vm.fromTime.getMinutes();
            var toMinutes = (vm.toTime.getHours() * 60) + vm.toTime.getMinutes();

            if(fromMinutes >= toMinutes)
                return toastr.error("Start time cannot be after end time");
            var data = {
                name:vm.name,
                schoolId:schoolId,
                startTimeMinute:fromMinutes,
                endTimeMinute:toMinutes,

            };
            shiftService.createShift(data).then(function (responseData) {
                toastr.success("Shift creation successful");
                vm.shiftList = processShifts(responseData);
                vm.name = null;
            },function (error) {
                toastr.error("Shift creation failed");
            })
        }

    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.educationOffice')
        .controller('EditEducationOfficeCtrl', ['$q', '$state', '$stateParams', 'toastr', 'DISTRICT', 'SUBDISTRICT', 'educationOfficeService', 'authService', EditEducationOfficeCtrl]);


    function EditEducationOfficeCtrl ($q, $state, $stateParams, toastr, DISTRICT, SUBDISTRICT, educationOfficeService, authService) {
        var vm = this;
        vm.districtList = DISTRICT;
        vm.subdistrictList = SUBDISTRICT;
        vm.officeHierarchyList = [];
        vm.educationOfficeList = [];
        vm.educationOffice = null;
        vm.selectedOfficeHierarchy = null;
        vm.selectedParentOffice = null;
        vm.isAdmin = authService.isAdmin();


        vm.updateEducationOffice = updateEducationOffice;

        function init() {
            $q.all([getAllOfficeHierarchies(),
                getAllEducationOffices(),
                getEducationOfficeById()]
            ).then(function () {
                makeOfficeHierarchySelected();
                makeParentOfficeSelected();
            }, function (error) {
                console.log("Error " + error);
            });
        }

        function updateEducationOffice() {
            if(vm.educationOffice.email == null && vm.educationOffice.password != null) return toastr.error("Admin Email cannot be empty");

            var data = {
                name:vm.educationOffice.name,
                email: vm.educationOffice.email,
                password: vm.educationOffice.password,
                address:vm.educationOffice.address,
                district:vm.educationOffice.district,
                subDistrict :vm.educationOffice.subDistrict,
                phoneNo : vm.educationOffice.phoneNo,
                website : vm.educationOffice.website,
                parentId: vm.selectedParentOffice == null ? null : vm.selectedParentOffice.id,
                officeHierarchyId : vm.selectedOfficeHierarchy == null ? null : vm.selectedOfficeHierarchy.id
            };

            educationOfficeService.updateEducationOffice(vm.educationOffice.id, data).then(function (data) {
                toastr.success("Education office updated");
                $state.go('educationOffice')
            },function (error) {
                toastr.error("Could not update education office");
            });

        }

        function getAllOfficeHierarchies(){
            return educationOfficeService.getAllOfficeHierarchies().then(function (data) {
                vm.officeHierarchyList = data;
            }, function (error) {
                toastr.error("Could not fetch office hierarachies.");
            });
        }

        function getEducationOfficeById() {
            return educationOfficeService.getEducationOfficeById($stateParams.educationOfficeId).then(function (data) {
                vm.educationOffice = data;
            }, function (error) {
                toastr.error("Could not fetch education office info.");
            });
        }

        function makeOfficeHierarchySelected() {
            for(var i=0;i<vm.officeHierarchyList.length;i++){
                if(vm.officeHierarchyList[i].id === vm.educationOffice.officeHierarchyId){
                    vm.selectedOfficeHierarchy = vm.officeHierarchyList[i];
                    break;
                }
            }
        }

        function getAllEducationOffices() {
            if(!vm.isAdmin) return;
            return educationOfficeService.getAllEducationOfficesForDropDown().then(function (data) {
                vm.educationOfficeList = data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get Education Offices");
            });
        }

        function makeParentOfficeSelected() {
            if(!vm.isAdmin) return;
            for(var i=0;i<vm.educationOfficeList.length;i++){
                if(vm.educationOfficeList[i].id === vm.educationOffice.parentId){
                    vm.selectedParentOffice = vm.educationOfficeList[i];
                    break;
                }
            }
        }

        init();
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.educationOffice')
        .controller('CreateEducationOfficeCtrl', ['$q','$state','toastr','DISTRICT','SUBDISTRICT', 'educationOfficeService', CreateEducationOfficeCtrl]);


    function CreateEducationOfficeCtrl ($q,$state,toastr,DISTRICT,SUBDISTRICT, educationOfficeService) {
        var vm = this;
        vm.districtList = DISTRICT;
        vm.subdistrictList = SUBDISTRICT;
        vm.selectedDistrict = null;
        vm.selectedSubdistrict = null;
        vm.officeHierarchyList = [];
        vm.educationOfficeList = [];

        vm.name = null;
        vm.address = null;
        vm.email = null;
        vm.password = null;
        vm.district = null;
        vm.subDistrict = null;
        vm.phoneNo = null;
        vm.website = null;
        vm.selectedOfficeHierarchy = null;
        vm.selectedParentOffice = null;

        vm.createEducationOffice = createEducationOffice;

        function init() {
            $q.all([
                getAllOfficeHierarchies(),
                getAllEducationOffices()
            ]).then(function () {

            }, function (error) {
                console.log("Error " + error);
            });
        }

        function createEducationOffice() {
            if(vm.name == null) return toastr.error("Office Name cannot be empty");
            if(vm.email == null) return toastr.error("Admin email cannot be empty");
            if(vm.password == null) return toastr.error("Admin password cannot be empty");
            if(vm.selectedOfficeHierarchy == null) return toastr.error("Must select an Office Type");
            if(vm.address == null) return toastr.error("Address cannot be empty");

            var data = {
                name:vm.name,
                address:vm.address,
                email: vm.email,
                password: vm.password,
                district:vm.selectedDistrict,
                subDistrict :vm.selectedSubdistrict,
                phoneNo : vm.phoneNo,
                website : vm.website,
                parentId: vm.selectedParentOffice == null? null : vm.selectedParentOffice.id,
                officeHierarchyId : vm.selectedOfficeHierarchy == null ? null : vm.selectedOfficeHierarchy.id
            };

            educationOfficeService.createEducationOffice(data).then(function (data) {
                toastr.success("Education office created");
                $state.go('educationOffice')
            },function (error) {
                toastr.error("Could not create education office");
            });

        }

        function getAllOfficeHierarchies(){
            return educationOfficeService.getAllOfficeHierarchies().then(function (data) {
                vm.officeHierarchyList = data;
            }, function (error) {
                toastr.error("Could not fetch office hierarachies.");
            });
        }

        function getAllEducationOffices() {
            return educationOfficeService.getAllEducationOffices().then(function (data) {
                vm.educationOfficeList = data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get Education Offices");
            });
        }

        init();
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.applyLeave')
        .controller('ApplyLeaveCtrl', ['authService','teacherService','leaveService', '$q','toastr','$filter', ApplyLeaveCtrl]);


    function ApplyLeaveCtrl(authService, teacherService, leaveService, $q,toastr,$filter) {
        var vm = this;
        vm.datePicker = {};
        vm.datePicker.date = null;
        vm.datePicker.options = null;
        vm.datePicker.ranges = null;
        vm.description = null;
        vm.teacherList = [];
        vm.address = null;
        vm.teacher = {};
        vm.teacher.selectedTeacher = null;
        vm.schoolIdList = [];
        vm.searchString = "";
        vm.applyForLeave = applyForLeave;

        function init() {
            modifyDatePicker();
            vm.schoolIdList.push(authService.getLoggedInUser().schoolId);
            $q.all([getAllTeachers()]).then(function () {
                console.log("done");
            });
        }

        function getAllTeachers() {
            var filterData = {
                teacherName: vm.searchString,
                schoolIdList:vm.schoolIdList
            };
            return teacherService.getAllTeachers(filterData).then(function (data) {
                vm.teacherList = data;
            },function (error) {
                toastr.error("Could not get teachers data");
            });
        }

        function modifyDatePicker() {
            vm.datePicker.date = getInitialFromAndToDate();
            //console.log(vm.datePicker.date);
            vm.datePicker.options = {
                applyClass: 'btn-green',
                locale: {
                    applyLabel: "Apply",
                    fromLabel: "From",
                    // format: "YYYY-MM-DD", //will give you 2017-01-06
                    format: "D/MMM/YY", //will give you 6-Jan-17
                    //format: "D-MMMM-YY", //will give you 6-January-17
                    toLabel: "To",
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom range'
                },
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                    'Last 7 days': [moment().subtract('days', 7), moment()],
                    'Last 30 days': [moment().subtract('days', 30), moment()],
                    'This month': [moment().startOf('month'), moment().endOf('month')]
                }
            };
        }

        function getInitialFromAndToDate() {
            var start = moment().startOf('day').subtract(3, 'day');
            var end = moment().endOf('day');
            return {
                'startDate': start,
                'endDate': end
            };
        }

        function applyForLeave() {
            var startDate = vm.datePicker.date.startDate.valueOf();
            var endDate = vm.datePicker.date.endDate.valueOf();
            if (vm.teacher.selectedTeacher) {
                var data = {
                    startDate: startDate,
                    endDate: endDate,
                    description: vm.description,
                    teacherId: vm.teacher.selectedTeacher.id
                };
                leaveService.applyForLeave(data).then(function (data) {
                    toastr.success("Leave added successful");
                },function (error) {
                    toastr.error("Could not apply for leave");
                });
            } else {
                toastr.error("Please select a teacher");
            }
        }

        init();
    }


})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leaveList')
        .controller('LeaveListCtrl', ['teacherService','leaveService','$q','toastr','$filter', '$uibModal', LeaveListCtrl]);


    function LeaveListCtrl (teacherService,leaveService,$q,toastr,$filter, $uibModal) {
        var vm = this;
        vm.leaveList = [];
        vm.showFilters = false;
        vm.dataLoaded = false;
        vm.designationList = [];
        vm.defaultImg = $filter('appImage')('theme/no-image.jpg');
        vm.searchString = '';

        vm.getAllLeaves = getAllLeaves;
        vm.clearFilter = clearFilter;
        vm.openDeleteModal = openDeleteModal;

        function init() {
            $q.all([getAllLeaves(vm.searchString)]).then(function () {
                console.log("All data loaded");
            });
        }

        function getAllLeaves(searchString) {
            leaveService.getAllLeaves(searchString).then(function (data) {
                vm.leaveList = data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get leave data");
            });
        }

        function clearFilter() {
            vm.searchString = "";
            getAllLeaves(vm.searchString);
        }

        function openDeleteModal(leaveId) {
            $uibModal.open({
                templateUrl: 'app/pages/main/leave/list/delete/leaveDelete.modal.html',
                controller: 'DeleteLeaveModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    leaveIdToDelete: function () { return leaveId }
                }
            }).result.then(function (data) {
                console.log(data);
                vm.leaveList = data;
                toastr.success("Leave successfully deleted");
            });
        }

        init();
    }


})();

(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.holidays')
        .controller('HolidayCreateModalCtrl',['holidayService','$uibModalInstance','toastr','authService','utilService',HolidayCreateModalCtrl]);

    function HolidayCreateModalCtrl(holidayService,$uibModalInstance,toastr,authService,utilService) {
        var vm = this;

        vm.modal = {};
        vm.modal.newEvent = {};
        vm.modal.newEvent.description = null;
        vm.modal.newEvent.startDate = null;
        vm.modal.newEvent.isOpenStart = null;

        vm.saveHoliday = saveHoliday;
        vm.openStart = openStart;

        function init() {
            vm.modal.newEvent.startDate = new Date();
        }

        init();

        function openStart () {
            vm.modal.newEvent.isOpenStart = true;
        }

        function saveHoliday (event) {
            if(vm.modal.newEvent.description.length === 0){
                toastr.error("Description can not be empty");
            }
            if(utilService.isDateEmpty(event.startDate)) {
                toastr.error("Date cannot be empty ");
                return;
            }
            if(!utilService.isTimeInCurrentYear(event.startDate.getTime())) {
                toastr.error('Date not within current year');
                return;
            }
            var loggedInUser = authService.getLoggedInUser();
            var data =
                {
                    description: event.description,
                    holidayDate: event.startDate.getTime(),
                    officeId : loggedInUser.isAdmin == true ? null : loggedInUser.schoolId,
                };
            holidayService.createHoliday(data).then(function (event) {
                    $uibModalInstance.close(event);
                },function () {
                    toastr.error("Could not create Holiday");
                });
        }

    }
})();
(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.holidays')
        .controller('HolidayDeleteModalCtrl',['holidayService','$uibModalInstance','toastr','holidayToDelete',HolidayDeleteModalCtrl]);

    function HolidayDeleteModalCtrl(holidayService,$uibModalInstance,toastr,holidayToDelete) {
        var vm = this;

        vm.holidayToDelete = null;
        vm.deleteHoliday = deleteHoliday;

        function init() {
            vm.holidayToDelete = holidayToDelete;
        }

        init();

        function deleteHoliday (event) {
            holidayService.updateHoliday(event.id,{status:-1}).then(function () {
                $uibModalInstance.close()
            },function (error) {
                toastr.error(error);
            });
        }

    }
})();
(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.holidays')
        .controller('HolidayUpdateModalCtrl',['$uibModalInstance','holidayService','toastr','utilService', 'holidayToUpdate',HolidayUpdateModalCtrl]);

    function HolidayUpdateModalCtrl($uibModalInstance,holidayService,toastr,utilService,holidayToUpdate) {
        var vm = this;

        vm.modal = {};
        vm.modal.eventToChange = null;

        vm.openStart = openStart;
        vm.openEnd = openEnd;
        vm.updateHoliday = updateHoliday;

        function init() {
            vm.modal.eventToChange = angular.copy(holidayToUpdate);
            console.log(vm.modal.eventToChange)
        }

        init();

        function openStart () {
            vm.modal.eventToChange.isOpenStart = true;
        }

        function openEnd () {
            vm.modal.eventToChange.isOpenEnd = true;
        }

        function updateHoliday () {
            var data =
                {
                    description: vm.modal.eventToChange.description,
                    holidayDate: new Date(vm.modal.eventToChange.holidayDate).getTime()
                };
            if(vm.modal.eventToChange.holidayDate === null) {
                return toastr.error("Date cannot be empty");
            }
            if(!utilService.isTimeInCurrentYear(new Date(vm.modal.eventToChange.holidayDate).getTime())) {
                toastr.error("Starting date cannot be after ending date");
                return;
            }
            holidayService.updateHoliday( vm.modal.eventToChange.id,data).then(function (eventFromApi) {
                console.log(eventFromApi)
                $uibModalInstance.close(eventFromApi);
            },function () {
                return toastr.error("Holiday could not be updated");
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.notice')
        .controller('DeleteNoticeCtrl', ['noticeService','toastr','notice','$uibModalInstance', DeleteNoticeCtrl]);


    function DeleteNoticeCtrl (noticeService,toastr,notice,$uibModalInstance) {
        var vm = this;

        vm.notice = null;
        vm.deleteNotice = deleteNotice;

        function init() {
            vm.notice = notice;
        }

        init();

        function deleteNotice() {
            noticeService.deleteNotice(vm.notice.id).then(function (data) {
                $uibModalInstance.close(data);
            })
        }
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.notice')
        .controller('NoticeImageUploadModalCtrl', ['$filter', '$uibModalInstance', 'API', 'currentNoticePicURL', 'toastr', 'Upload', NoticeImageUploadModalCtrl]);

    /** @ngInject */
    function NoticeImageUploadModalCtrl($filter, $uibModalInstance, API, currentNoticePicURL, toastr, Upload) {

        var vm = this;
        vm.defaultImage = null;
        vm.currentNoticePicURL = null;
        vm.isFileSelected = false;
        vm.fileSelected = fileSelected;
        vm.uploadNoticePicture = uploadNoticePicture;

        init();

        function init () {
            vm.currentNoticePicURL = currentNoticePicURL ? currentNoticePicURL : $filter('appImage')('theme/no-image.jpg');
        }

        function fileSelected() {
            vm.isFileSelected = true;
        }

        function uploadNoticePicture(dataUrl, name) {
            vm.isFileSelected = false;
            Upload.upload({
                url: API.student.uploadPicture,
                data: {
                    file: Upload.dataUrltoBlob(dataUrl, name)
                }
            }).then(function (response) {
                if (response.status === 200) {
                    $uibModalInstance.close(response.data);
                    toastr.success("Notice picture updated.");
                } else {
                    $uibModalInstance.dismiss("Failed to upload notice picture. " + response.message);
                    console.error("failed to upload notice picture : " + response.message);
                    toastr.error("Failed to upload notice picture. " + response.message);
                }

            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to upload notice picture. " + response.message);
                    console.error("failed to upload notice picture : " + response.message);
                    toastr.error("Failed to upload notice picture. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.school')
        .controller('CreateSchoolCtrl', ['schoolService','$state','toastr','DISTRICT','SUBDISTRICT', 'educationOfficeService', CreateSchoolCtrl]);


    function CreateSchoolCtrl (schoolService,$state,toastr,DISTRICT,SUBDISTRICT, educationOfficeService) {
        var vm = this;
        vm.typeList = [];
        vm.selectedType = [];
        vm.resellerList = [];
        vm.selectedReseller = null;
        vm.districtList = DISTRICT;
        vm.subdistrictList = SUBDISTRICT;
        vm.selectedDistrict = null;
        vm.selectedSubdistrict = null;
        vm.educationOfficeList = [];

        vm.name = null;
        vm.eiin = null;
        vm.code = null;
        vm.address = null;
        vm.email = null;
        vm.password = null;
        vm.district = null;
        vm.subDistrict = null;
        vm.selectedEducationOffice = null;
        vm.phoneNo = null;
        vm.website = null;
        vm.studentCount = null;
        vm.teacherCount = null;

        vm.createSchool = createSchool;

        function init() {
            schoolService.getAllInstitutionTypes().then(function (data) {
                vm.typeList = data.institutionTypeList;
            },function (error) {
                toastr.error("Could not fetch institution type");
            });

            schoolService.getAllReseller().then(function (data) {
                vm.resellerList = data;
            },function (error) {
                toastr.error("Could not fetch reseller list");
            });

            educationOfficeService.getAllEducationOffices().then(function (data) {
                vm.educationOfficeList = data;
            },function (error) {
                toastr.error("Could not fetch education offices");
            });
        }
        init();

        function createSchool() {
            if(vm.name == null) return toastr.error("School Name cannot be empty");
            if(vm.email == null) return toastr.error("Admin email cannot be empty");
            if(vm.password == null) return toastr.error("Admin password cannot be empty");

            var data = {
                name:vm.name,
                typeId:vm.selectedType[0].id,
                eiin:vm.eiin,
                code : vm.code,
                address:vm.address,
                email: vm.email,
                password: vm.password,
                district:vm.selectedDistrict,
                subDistrict :vm.selectedSubdistrict,
                educationOfficeId : vm.selectedEducationOffice == null ? null : vm.selectedEducationOffice.id,
                resellerId : vm.selectedReseller.id,
                phoneNo : vm.phoneNo,
                website : vm.website,
                studentCount : vm.studentCount,
                teacherCount : vm.teacherCount
            };

            schoolService.createSchool(data).then(function (data) {
                toastr.success("School created");
                $state.go('school')
            },function (error) {
                toastr.error("Could not create school");
            });

        }

        init();
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.school')
        .controller('EditSchoolCtrl', ['schoolService', '$q', '$state', '$stateParams', 'toastr', 'DISTRICT', 'SUBDISTRICT', 'educationOfficeService', 'authService', EditSchoolCtrl]);


    function EditSchoolCtrl(schoolService, $q, $state, $stateParams, toastr, DISTRICT, SUBDISTRICT, educationOfficeService, authService) {
        var vm = this;
        vm.typeList = [];
        vm.selectedType = [];
        vm.districtList = DISTRICT;
        vm.subdistrictList = SUBDISTRICT;
        vm.selectedDistrict = null;
        vm.selectedSubdistrict = null;
        vm.school = null;
        vm.dataLoaded = false;
        vm.school = null;
        vm.educationOfficeList = [];
        vm.selectedEducationOffice = null;
        vm.isAdmin = authService.isAdmin();

        vm.editSchool = editSchool;

        // var getInstitutionTypes = function () {
        //     schoolService.getAllInstitutionTypes().then(function (data) {
        //         vm.typeList = data.institutionTypeList;
        //     }, function (error) {
        //         vm.dataLoaded = true;
        //         toastr.error("Could not fetch institution type");
        //     })
        // };
        //
        // var getSchoolById = function () {
        //     schoolService.getSchoolById($stateParams.schoolId).then(function (data) {
        //         vm.school = data;
        //         console.log("School get complete");
        //     }, function () {
        //         vm.dataLoaded = true;
        //         toastr.error("Error while getting schoold");
        //     })
        // };

        function init() {
            vm.dataLoaded = false;
            $q.all([
                    getInstitutionTypes(),
                    getSchoolById(),
                    getAllEducationOffices()
                ]
            ).then(function () {
                makeInstitutionTypeSelected();
                makeEducationOfficeSelected();
            }, function (error) {
                console.log("Error " + error);
            });

        }

        init();

        function getInstitutionTypes() {
            return schoolService.getAllInstitutionTypes().then(function (data) {
                vm.typeList = data.institutionTypeList;
                console.log("Instituion type get complete");
            }, function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not fetch institution type");
            });
        }

        function getSchoolById() {
            return schoolService.getSchoolById($stateParams.schoolId).then(function (data) {
                vm.school = data;
                vm.school.password ='aboltabol';
                // console.log(vm.school);
                // makeInstitutionTypeSelected();
            }, function () {
                vm.dataLoaded = true;
                toastr.error("Error while getting schoold");
            });
        }


        function editSchool() {
            if (vm.school.name == null) return toastr.error("School Name cannot be empty");
            if(vm.school.email == null) return toastr.error("Admin email cannot be empty");
            //if(vm.school.password == null) return toastr.error("Admin password cannot be empty");

            var data = {
                name: vm.school.name,
                typeId: vm.selectedType[0].id,
                eiin: vm.school.eiin,
                code: vm.school.code,
                address: vm.school.address,
                email: vm.school.email,
                password: vm.school.password!='aboltabol' ? vm.school.password : '',
                district: vm.school.district,
                subDistrict: vm.school.subDistrict,
                educationOfficeId: vm.selectedEducationOffice == null ? null : vm.selectedEducationOffice.id,
                phoneNo: vm.school.phoneNo,
                website: vm.school.website,
                studentCount: vm.school.studentCount,
                teacherCount: vm.school.teacherCount
            };

            schoolService.editSchool(vm.school.id, data).then(function (data) {
                toastr.success("School Edited");
                $state.go('school')
            }, function (error) {
                toastr.error("Could not update school");
            });

        }

        function makeInstitutionTypeSelected() {
            console.log("Callback called");
            for (var i = 0; i < vm.typeList.length; i++) {
                if (vm.typeList[i].id == vm.school.typeId) {
                    vm.dataLoaded = true;
                    console.log("FOUND");
                    vm.typeList[i].ticked = true;
                    vm.selectedType.push({id: vm.typeList[i].id});
                }
            }
        }

        function makeEducationOfficeSelected() {
            if(!vm.isAdmin) return;
            if(vm.school.educationOfficeId == null || !vm.school.educationOfficeId) return;
            for(var i=0;i<vm.educationOfficeList.length;i++){
                if(vm.educationOfficeList[i].id === vm.school.educationOfficeId){
                    vm.selectedEducationOffice = vm.educationOfficeList[i];
                    break;
                }
            }
        }

        function getAllEducationOffices() {
            if(!vm.isAdmin) return;
            return educationOfficeService.getAllEducationOffices().then(function (data) {
                vm.educationOfficeList = data;
            },function (error) {
                toastr.error("Could not fetch education offices");
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.createStudent')
        .controller('CreateStudentCtrl', ['studentService','authService','assocService','$state','$scope','$q','toastr','GENDER','RELIGION','BLOOD_GROUP','DISTRICT','SUBDISTRICT', '$uibModal', CreateStudentCtrl]);


    function CreateStudentCtrl (studentService,authService,assocService,$state,$scope,$q,toastr,GENDER,RELIGION,BLOOD_GROUP,DISTRICT,SUBDISTRICT, $uibModal) {
        var vm = this;
        vm.genderList = GENDER;
        vm.religionList = RELIGION;
        vm.bloodGroupList = BLOOD_GROUP;
        vm.districtList = DISTRICT;
        vm.subdistrictList = SUBDISTRICT;
        vm.assocList = [];
        vm.selectedGender = null;
        vm.selectedReligion = null;
        vm.selectedBloodGroup = null;
        vm.selectedPresentDistrict = null;
        vm.selectedPermanentDistrict = null;
        vm.selectedPresentSubdistrict = null;
        vm.selectedPermanentSubdistrict = null;
        vm.selectedAssoc = null;
        vm.currentProfilePicURL = null;

        vm.name = null;
        vm.dateOfBirth = new Date();
        vm.birthCertNo = null;
        vm.fatherName = null;
        vm.motherName = null;
        vm.guardianName = null;
        vm.emergencyContact = null;
        vm.presentAddress = null;
        vm.permanentAddress = null;
        vm.assocYear = null;
        vm.rollNo = null;
        vm.rfidNo = null;
        vm.primaryText = null;
        vm.secondaryText = null;
        vm.schoolId = authService.getLoggedInUser().schoolId;

        vm.createStudent = createStudent;
        vm.showProfileImageUploadModal = showProfileImageUploadModal;


        function init() {
            $q.all([getAllCssAsocs()]).then(function () {
                console.log("All data loaded");
            });
        }
        function getAllCssAsocs() {
            assocService.getAllAssocs().then(function (data) {
                vm.assocList = data;
            })
        }
        $scope.dateOfBirth = function() {
            $scope.dateOfBirth.opened = true;
        };
        init();

        function showProfileImageUploadModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/student/create/profileImageUploadModal/profileImageUpload.modal.html',
                controller: 'ProfileImageUploadModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    currentProfilePicURL: function () {
                        return vm.currentProfilePicURL;
                    },
                    userId: function () {
                        return vm.userId;
                    }
                }
            }).result.then(function (profileImage) {
                console.log(profileImage);
                vm.currentProfilePicURL = profileImage.url;
                vm.noPicture = false;
            }, function () {
                console.log("Profile image upload modal dismissed.");
            });
        }

        function createStudent() {
            if(vm.name == null) return toastr.error("Student Name cannot be empty");
            if(vm.selectedGender == null) return toastr.error("Please select student's gender");
            if(vm.selectedReligion == null) return toastr.error("Please select student's religion");
            if(vm.dateOfBirth == null) return toastr.error("Date of birth cannot be empty");
            if(vm.fatherName == null) return toastr.error("Father Name cannot be empty");
            if(vm.motherName == null) return toastr.error("Mother Name cannot be empty");
            if(vm.emergencyContact == null) return toastr.error("Contact Number cannot be empty");
            if(vm.selectedAssoc == null) return toastr.error("Please select student's class allocation");
            if(vm.assocYear == null) return toastr.error("Year cannot be empty");
            if(vm.rollNo == null) return toastr.error("Roll Number cannot be empty");

            var data = {
                name:vm.name,
                gender:vm.selectedGender[0].id,
                religion:vm.selectedReligion[0].id,
                bloodGroup:vm.selectedBloodGroup[0].id,
                dateOfBirth:vm.dateOfBirth,
                birthCertNo:vm.birthCertNo,
                fatherName :vm.fatherName,
                motherName : vm.motherName,
                guardianName : vm.guardianName,
                emergencyContact:vm.emergencyContact,
                presentAddress1:vm.presentAddress,
                presentSubdistrict:vm.selectedPresentSubdistrict[0].id,
                presentDistrict:vm.selectedPresentDistrict[0].id,
                permanentAddress1:vm.permanentAddress,
                permanentSubdistrict:vm.selectedPermanentSubdistrict[0].id,
                permanentDistrict:vm.selectedPermanentDistrict[0].id,
                assocId:vm.selectedAssoc[0].id,
                assocYear : vm.assocYear,
                rollNo : vm.rollNo,
                rfidNo : vm.rfidNo,
                primaryText : vm.primaryText,
                secondaryText : vm.secondaryText,
                schoolId : vm.schoolId,
            }

            studentService.createStudent(data).then(function (data) {
                toastr.success("Student created");
                $state.go('student')
            },function (error) {
                toastr.error("Could not create student");
            });

        }
        init();
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.studentDailyAttendance')
        .controller('StudentDailyAttendanceCtrl', ['attendanceService','authService','classService','sectionService','shiftService','$scope','$q','toastr', StudentDailyAttendanceCtrl]);


    function StudentDailyAttendanceCtrl (attendanceService,authService,classService,sectionService,shiftService,$scope,$q,toastr) {
        var vm = this;
        vm.studentList = [];
        vm.showFilters = false;
        vm.dataLoaded = false;
        vm.classList = [];
        vm.sectionList = [];
        vm.shiftList = [];
        vm.selectedClass = null;
        vm.selectedSection = null;
        vm.selectedShift = null;
        vm.studentName = null;
        vm.filterDate = new Date();
        vm.schoolId = authService.getLoggedInUser().schoolId;
        vm.filterAttendances = filterAttendances;

        function init() {
            vm.filterDate.setHours(0,0,0,0);
            var filterData = {
                from:vm.filterDate.getTime(),
                to:vm.filterDate.getTime(),
                schoolId:vm.schoolId,
                studentName: vm.studentName,
                classId: vm.selectedClass,
                sectionId: vm.selectedSection,
                shiftId: vm.selectedShift
            }
            $q.all([getDailyStudentAttendances(filterData),getAllClasses(),getAllSections(),getAllShifts()]).then(function () {
                console.log("All data loaded");
            });
        }
        $scope.filterDate = function() {
            $scope.filterDate.opened = true;
        };

        function getDailyStudentAttendances(filterData) {
            attendanceService.getStudentAttendances(filterData).then(function (data) {
                vm.studentList = data.attendance;
                vm.dataLoaded = true;
                //console.log(JSON.stringify(vm.studentList));
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get students attendance data");
            });
        }
        function filterAttendances(){
            console.log(JSON.stringify(vm.selectedClass));
            vm.filterDate.setHours(0,0,0,0);
            var filterData = {
                from:vm.filterDate.getTime(),
                to:vm.filterDate.getTime(),
                schoolId:vm.schoolId,
                studentName: vm.studentName,
                classId: vm.selectedClass!=null ? vm.selectedClass.id : vm.selectedClass,
                sectionId: vm.selectedSection!=null ? vm.selectedSection.id : vm.selectedSection,
                shiftId: vm.selectedShift!=null ? vm.selectedShift.id : vm.selectedShift
            }
            getDailyStudentAttendances(filterData);
        }
        function getAllClasses() {
            classService.getAllClasses().then(function (data) {
                vm.classList = data;
            });
        }

        function getAllSections() {
            sectionService.getAllSections().then(function (data) {
                vm.sectionList = data;
            });
        }

        function getAllShifts() {
            shiftService.getAllShifts().then(function (data) {
                vm.shiftList = data;
            });
        }

        init();
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.studentList')
        .controller('StudentListCtrl', ['studentService','classService','sectionService','shiftService','$q','toastr', StudentListCtrl]);


    function StudentListCtrl (studentService,classService,sectionService,shiftService,$q,toastr) {
        var vm = this;
        vm.studentList = [];
        vm.showFilters = false;
        vm.dataLoaded = false;
        vm.classList = [];
        vm.sectionList = [];
        vm.shiftList = [];
        vm.selectedClass = null;
        vm.selectedSection = null;
        vm.selectedShift = null;

        function init() {
            $q.all([getAllStudents(),getAllClasses(),getAllSections(),getAllShifts()]).then(function () {
                console.log("All data loaded");
            });
        }

        function getAllStudents() {
            studentService.getAllStudents().then(function (data) {
                vm.studentList = data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get students data");
            });
        }
        function getAllClasses() {
            classService.getAllClasses().then(function (data) {
                vm.classList = data;
            });
        }

        function getAllSections() {
            sectionService.getAllSections().then(function (data) {
                vm.sectionList = data;
            });
        }

        function getAllShifts() {
            shiftService.getAllShifts().then(function (data) {
                vm.shiftList = data;
            });
        }

        init();
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.editStudent')
        .controller('EditStudentCtrl', ['studentService','authService','assocService','$state','$scope','$q','toastr', '$filter', '$uibModal', 'Upload','GENDER','RELIGION','BLOOD_GROUP','DISTRICT','SUBDISTRICT', EditStudentCtrl]);


    function EditStudentCtrl(studentService,authService,assocService,$state,$scope,$q,toastr,$filter,$uibModal,Upload,GENDER,RELIGION,BLOOD_GROUP,DISTRICT,SUBDISTRICT) {
        var vm = this;
        vm.student = null;
        vm.dataLoaded = false;
        vm.genderList = GENDER;
        vm.religionList = RELIGION;
        vm.bloodGroupList = BLOOD_GROUP;
        vm.districtList = DISTRICT;
        vm.subdistrictList = SUBDISTRICT;
        vm.assocList = [];
        vm.selectedGender = null;
        vm.selectedReligion = null;
        vm.selectedBloodGroup = null;
        vm.selectedPresentDistrict = null;
        vm.selectedPermanentDistrict = null;
        vm.selectedPresentSubdistrict = null;
        vm.selectedPermanentSubdistrict = null;
        vm.selectedAssoc = null;

        vm.editStudent = editStudent;
        vm.showStudentPictureUploadModal = showStudentPictureUploadModal;

        function init() {
            vm.dataLoaded = false;
            $q.all([
                    getStudentById(),
                    getAllCssAsocs()
                ]
            ).then(function () {
                console.log("Callback called");
                vm.dataLoaded = true;
                console.log("FOUND");
            }, function (error) {
                console.log("Erorr " + error);
            });
        }

        function getAllCssAsocs() {
            assocService.getAllAssocs().then(function (data) {
                vm.assocList = data;
            })
        }
        $scope.dateOfBirth = function() {
            $scope.dateOfBirth.opened = true;
        };
        init();

        function getStudentById() {
            return studentService.getStudentById($state.params.studentId).then(function (data) {
                vm.student = data;
                if(vm.student.photoDir==null || vm.student.photoDir=="") vm.student.photoDir = $filter('appImage')('theme/no-image.jpg');
                console.log("Student get complete");
            }, function () {
                vm.dataLoaded = true;
                toastr.error("Error while getting student");
            });
        }

        function editStudent() {
            if(vm.student.name == null) return toastr.error("Student Name cannot be empty");
            if(vm.selectedGender == null) return toastr.error("Please select student's gender");
            if(vm.selectedReligion == null) return toastr.error("Please select student's religion");
            if(vm.student.dateOfBirth == null) return toastr.error("Date of birth cannot be empty");
            if(vm.student.fatherName == null) return toastr.error("Father Name cannot be empty");
            if(vm.student.motherName == null) return toastr.error("Mother Name cannot be empty");
            if(vm.student.emergencyContact == null) return toastr.error("Contact Number cannot be empty");
            if(vm.selectedAssoc == null) return toastr.error("Please select student's class allocation");
            if(vm.student.assocYear == null) return toastr.error("Year cannot be empty");
            if(vm.student.rollNo == null) return toastr.error("Roll Number cannot be empty");

            var data = {
                name:vm.student.name,
                gender:vm.selectedGender[0].id,
                religion:vm.selectedReligion[0].id,
                bloodGroup: vm.selectedBloodGroup!=null ? vm.selectedBloodGroup[0].id : null,
                dateOfBirth:vm.student.dateOfBirth,
                birthCertNo:vm.student.birthCertNo,
                fatherName :vm.student.fatherName,
                motherName : vm.student.motherName,
                guardianName : vm.student.guardianName,
                emergencyContact:vm.student.emergencyContact,
                presentAddress1:vm.student.presentAddress1,
                presentSubdistrict: vm.selectedPresentSubdistrict!=null ? vm.selectedPresentSubdistrict[0].id : null,
                presentDistrict: vm.selectedPresentDistrict!=null ? vm.selectedPresentDistrict[0].id : null,
                permanentAddress1:vm.student.permanentAddress1,
                permanentSubdistrict: vm.selectedPermanentSubdistrict!=null ? vm.selectedPermanentSubdistrict[0].id: null,
                permanentDistrict: vm.selectedPermanentDistrict!=null ? vm.selectedPermanentDistrict[0].id : null,
                assocId:vm.selectedAssoc.id,
                assocYear : vm.student.assocYear,
                rollNo : vm.student.rollNo,
                rfidNo : vm.student.rfidNo,
                primaryText : vm.student.primaryText,
                secondaryText : vm.student.secondaryText,
                schoolId : vm.student.schoolId,
            }
            studentService.editStudent(vm.student.id, data).then(function (data) {
                toastr.success("Student Edited");
                $state.go('student')
            }, function (error) {
                toastr.error("Could not create student");
            });

        }
        function showStudentPictureUploadModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/student/edit/studentPictureUploadModal/studentPictureUpload.modal.html',
                controller: 'StudentPictureUploadModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    currentPicURL: function () {
                        return vm.student.photoDir;
                    }
                }
            }).result.then(function (studentPicture) {
                vm.student.photoDir = studentPicture.url;
            }, function () {
                console.log("Student picture upload modal dismissed.");
            });
        }

    }


})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.studentMonthlyAttendance')
        .controller('StudentMonthlyAttendanceCtrl', ['attendanceService','authService','classService','sectionService','shiftService','$q','$scope','toastr', StudentMonthlyAttendanceCtrl]);


    function StudentMonthlyAttendanceCtrl (attendanceService,authService,classService,sectionService,shiftService,$q,$scope,toastr) {
        var vm = this;
        vm.studentList = [];
        vm.showFilters = false;
        vm.dataLoaded = false;
        vm.classList = [];
        vm.sectionList = [];
        vm.shiftList = [];
        vm.selectedClass = null;
        vm.selectedSection = null;
        vm.selectedShift = null;
        vm.studentName = null;
        vm.filterYear = new Date();
        vm.filterMonth = new Date();
        vm.filterFrom = null;
        vm.filterTo = null;
        vm.schoolId = authService.getLoggedInUser().schoolId;
        vm.monthlyDates = [];
        vm.filterAttendances = filterAttendances;

        function init() {
            vm.filterFrom = new Date(vm.filterYear.getFullYear(), vm.filterMonth.getMonth(), 1, 0, 0, 0, 0);
            vm.filterTo = new Date(vm.filterYear.getFullYear(), vm.filterMonth.getMonth()+1, 0, 0, 0, 0, 0);
            var filterData = {
                from:vm.filterFrom.getTime(),
                to:vm.filterTo.getTime(),
                schoolId:vm.schoolId,
                studentName: vm.studentName,
                classId: vm.selectedClass,
                sectionId: vm.selectedSection,
                shiftId: vm.selectedShift
            }
            $q.all([getDailyStudentAttendances(filterData),getAllClasses(),getAllSections(),getAllShifts()]).then(function () {
                console.log("All data loaded");
            });
        }
        $scope.filterYear = function() {
            $scope.filterYear.opened = true;
        };
        $scope.filterMonth = function() {
            $scope.filterMonth.opened = true;
        };

        function getDailyStudentAttendances(filterData) {
            attendanceService.getStudentAttendances(filterData).then(function (data) {
                vm.studentList = data.attendance;
                vm.monthlyDates = data.dates;
                vm.dataLoaded = true;
                //console.log(JSON.stringify(vm.studentList));
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get students attendance data");
            });
        }
        function filterAttendances(){
            vm.filterFrom = new Date(vm.filterYear.getFullYear(), vm.filterMonth.getMonth(), 1, 0, 0, 0, 0);
            vm.filterTo = new Date(vm.filterYear.getFullYear(), vm.filterMonth.getMonth()+1, 0, 0, 0, 0, 0);
            var filterData = {
                from:vm.filterFrom.getTime(),
                to:vm.filterTo.getTime(),
                schoolId:vm.schoolId,
                studentName: vm.studentName,
                classId: vm.selectedClass!=null ? vm.selectedClass.id : vm.selectedClass,
                sectionId: vm.selectedSection!=null ? vm.selectedSection.id : vm.selectedSection,
                shiftId: vm.selectedShift!=null ? vm.selectedShift.id : vm.selectedShift
            }
            getDailyStudentAttendances(filterData);
        }
        function getAllClasses() {
            classService.getAllClasses().then(function (data) {
                vm.classList = data;
            });
        }

        function getAllSections() {
            sectionService.getAllSections().then(function (data) {
                vm.sectionList = data;
            });
        }

        function getAllShifts() {
            shiftService.getAllShifts().then(function (data) {
                vm.shiftList = data;
            });
        }

        init();
    }


})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.teacher.batchCreateTeachers')
        .controller('BatchTeachersCtrl', ['$scope','$window',BatchTeachersCtrl]);

    /** @ngInject */
    function BatchTeachersCtrl($scope,$window) {

        var vm = this;
        vm.onSwitchToHistoryTab = onSwitchToHistoryTab;

        function onSwitchToHistoryTab () {
            $scope.$broadcast('switchedToHistoryTab');
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.createTeacher')
        .controller('CreateTeacherCtrl', ['teacherService','authService','designationService','$state','$scope','$q','toastr', '$filter', '$uibModal', 'Upload','GENDER','RELIGION','BLOOD_GROUP','DISTRICT','SUBDISTRICT', CreateTeacherCtrl]);


    function CreateTeacherCtrl (teacherService,authService,designationService,$state,$scope,$q,toastr,$filter,$uibModal,Upload,GENDER,RELIGION,BLOOD_GROUP,DISTRICT,SUBDISTRICT) {
        var vm = this;
        
        vm.districtList = DISTRICT;
        vm.subdistrictList = SUBDISTRICT;
        vm.designationList = [];
        vm.selectedPresentDistrict = null;
        vm.selectedPermanentDistrict = null;
        vm.selectedPresentSubdistrict = null;
        vm.selectedPermanentSubdistrict = null;
        vm.selectedDesignation = null;

        vm.name = null;
        vm.email = null;
        vm.dateOfJoining = new Date();
        vm.contact = null;
        vm.presentAddress = null;
        vm.permanentAddress = null;
        vm.rfidNo = null;
        vm.primaryText = null;
        vm.secondaryText = null;
        vm.qualifications = null;
        vm.schoolId = authService.getLoggedInUser().schoolId;
        vm.photoDir = $filter('appImage')('theme/no-image.jpg');
        vm.photoUploaded = false;

        vm.createTeacher = createTeacher;
        vm.showTeacherPictureUploadModal = showTeacherPictureUploadModal;


        function init() {
            $q.all([getAllDesignations()]).then(function () {
                console.log("All data loaded");
            });
        }

        function isNumeric(num){
            return !isNaN(num)
        }
        
        function getAllDesignations() {
            designationService.getAllDesignations().then(function (data) {
                vm.designationList = data;
            })
        }
        
        $scope.dateOfJoining = function() {
            $scope.dateOfJoining.opened = true;
        };
        init();

        function createTeacher() {
            if(vm.name == null) return toastr.error("Teacher Name cannot be empty");
            if(vm.contact == null) return toastr.error("Mobile Number cannot be empty");
            if(vm.dateOfJoining == null) return toastr.error("Date of joining cannot be empty");
            if(vm.rfidNo != null && (!vm.rfidNo.match(/^[0-9]+$/) || vm.rfidNo.length < 10)) return toastr.error("RFID number not valid");
            if(vm.primaryText == null) return toastr.error("Primary display text cannot be empty");
            if(vm.primaryText != null && (!vm.primaryText.match(/^[a-zA-Z0-9 ]+$/) || vm.primaryText.length > 10)) return toastr.error("Primary display text must be english alphanumeric and max 10 characters.");
            if(vm.secondaryText == null) return toastr.error("Secondary display text cannot be empty");
            if(vm.secondaryText != null && (!vm.secondaryText.match(/^[a-zA-Z0-9 ]+$/) || vm.secondaryText.length > 10)) return toastr.error("Secondary display text must be english alphanumeric and max 10 characters.");

            var data = {
                "dateOfJoining": vm.dateOfJoining,
                "designationId": vm.selectedDesignation!=null ? vm.selectedDesignation.id : 0,
                "email": vm.email,
                "experience": vm.experience,
                "mpoIndex": vm.mpoIndex,
                "name": vm.name,
                "permanentAddress1": vm.permanentAddress,
                "permanentAddress2": "",
                "permanentDistrict": vm.selectedPermanentDistrict,
                "permanentSubDistrict": vm.selectedPermanentSubdistrict,
                "phoneNo": vm.contact,
                "photoDir": vm.photoUploaded ? vm.photoDir : "",
                "presentAddress1": vm.presentAddress,
                "presentAddress2": "",
                "presentDistrict": vm.selectedPresentDistrict,
                "presentSubDistrict": vm.selectedPresentSubdistrict,
                "primaryDisplayText": vm.primaryText,
                "qualifications": vm.qualifications,
                "rfid": vm.rfidNo,
                "schoolId": vm.schoolId,
                "secondaryDisplayText": vm.secondaryText
            };

            teacherService.createTeacher(data).then(function (data) {
                toastr.success("Teacher created");
                $state.go('teacher.teacherList');
            },function (error) {
                toastr.error("Could not create teacher");
            });

        }
        function showTeacherPictureUploadModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/teacher/create/teacherPictureUploadModal/teacherPictureUpload.modal.html',
                controller: 'TeacherPictureUploadModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    currentPicURL: function () {
                        return vm.photoDir;
                    }
                }
            }).result.then(function (teacherPicture) {
                console.log(teacherPicture);
                vm.photoUploaded = true;
                vm.photoDir = teacherPicture.url;
            }, function () {
                console.log("Teacher picture upload modal dismissed.");
            });
        }

    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.teacherDailyAttendance')
        .controller('TeacherDailyAttendanceCtrl', ['attendanceService', 'authService', 'classService', 'sectionService', 'shiftService', 'educationOfficeService', '$scope', '$q', 'schoolService', 'toastr', '$state', TeacherDailyAttendanceCtrl]);


    function TeacherDailyAttendanceCtrl (attendanceService, authService, classService, sectionService, shiftService, educationOfficeService, $scope, $q, schoolService, toastr, $state) {
        var vm = this;
        vm.teacherList = [];
        vm.showFilters = false;
        vm.dataLoaded = false;
        vm.selectedClass = null;
        vm.selectedSection = null;
        vm.selectedShift = null;
        vm.excelUrl = '';
        vm.teacherName = null;
        vm.filterDate = new Date();
        vm.schoolId = authService.getLoggedInUser().schoolId;
        vm.educationOfficeId = authService.getLoggedInUser().educationOfficeId;
        vm.isEducationOfficeAdmin = false;
        vm.selectedSchoolList = [];
        vm.schoolList = [];
        vm.schoolListDropDown = [];
        vm.userEducationOffice = null;
        vm.userOfficeHierarchy = 0;
        vm.subordinateClusters = [];
        vm.selectedSubordinateCluster = null;

        vm.clearFilter = clearFilter;
        vm.filterAttendances = filterAttendances;
        vm.updateSchoolDropDownList = updateSchoolDropDownList
        // vm.filterDate = filterDate;

        function init() {
            vm.isEducationOfficeAdmin = authService.getLoggedInUser().isEducationOfficeAdmin;
            vm.filterDate.setHours(0,0,0,0);
            if(vm.schoolId == null && $state.params.schoolId != null) vm.schoolId = parseInt($state.params.schoolId);

            $q.all([
                createSchoolList(),
                getUserEducationOffice()
            ]).then(function () {
                var filterData = {
                    from:vm.filterDate.getTime(),
                    to:vm.filterDate.getTime(),
                    schoolIdList:getSelectedSchoolIds(),
                    teacherName: vm.teacherName,
                };
                getDailyTeacherAttendances(filterData);
                vm.excelUrl = attendanceService.getExcelUrl(vm.filterDate.getTime(), vm.filterDate.getTime(), filterData.schoolIdList, vm.teacherName);
                console.log("All data loaded");
            });
        }
        $scope.filterDate = function() {
            $scope.filterDate.opened = true;
        };

        function getDailyTeacherAttendances(filterData) {
            attendanceService.getTeacherAttendance(filterData).then(function (data) {
                vm.teacherList = data.attendance;
                //console.log(JSON.stringify(vm.teacherList));
                vm.monthlyDates = data.dates;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get teachers attendance data");
            });
        }

        function filterAttendances(){
            if(vm.selectedSchoolList.length === 0) return toastr.error("Please select at least one school");
            vm.filterDate.setHours(0,0,0,0);
            var filterData = {
                from:vm.filterDate.getTime(),
                to:vm.filterDate.getTime(),
                schoolIdList:getSelectedSchoolIds(),
                teacherName: vm.teacherName,
                classId: vm.selectedClass!=null ? vm.selectedClass.id : vm.selectedClass,
                sectionId: vm.selectedSection!=null ? vm.selectedSection.id : vm.selectedSection,
                shiftId: vm.selectedShift!=null ? vm.selectedShift.id : vm.selectedShift
            };
            vm.dataLoaded = false;
            vm.showFilters = false;
            getDailyTeacherAttendances(filterData);
            vm.excelUrl = attendanceService.getExcelUrl(vm.filterDate.getTime(), vm.filterDate.getTime(), filterData.schoolIdList, vm.teacherName);
        }

        function clearFilter(){
            vm.teacherName = null;
            vm.filterDate = new Date();
            vm.selectedSchoolList = [];
            if(vm.userOfficeHierarchy > 1){
                resetClusterDropDown();
                updateSchoolDropDownList();
            }
            vm.showFilters = false;
            init();
        }

        function createSchoolList() {
            if(vm.isEducationOfficeAdmin){
                return schoolService.getAllSchoolsUnderAnEducationOffice().then(function (data) {
                    vm.schoolList = data;
                    vm.schoolListDropDown = data;
                    makeSchoolSelected(vm.schoolId);
                },function (error) {
                    toastr.error("Could not get Schools");
                });
            } else {
                vm.schoolList = [];
                vm.schoolListDropDown = [];
                return schoolService.getSchoolById(vm.schoolId).then(function (data) {
                    vm.schoolList.push(data);
                    vm.schoolListDropDown.push(data);
                    makeSchoolSelected(vm.schoolId);
                },function (error) {
                    toastr.error("Could not get Schools");
                });
            }
        }

        function getSelectedSchoolIds() {
            if(vm.selectedSchoolList.length === 0)
                return null;
            else{
                return vm.selectedSchoolList.map(function (item) {
                    return item.id;
                });
            }
        }

        function makeSchoolSelected(schoolId) {
            if(schoolId != null){
                for(var i=0;i<vm.schoolListDropDown.length;i++){
                    if(vm.schoolListDropDown[i].id === schoolId){
                        vm.schoolListDropDown[i].ticked = true;
                        vm.selectedSchoolList.push({"id":vm.schoolListDropDown[i].id});
                    }
                }
            } else if(vm.isEducationOfficeAdmin || vm.isAdmin){
                for(var i=0;i<vm.schoolListDropDown.length;i++){
                    vm.schoolListDropDown[i].ticked = true;
                    vm.selectedSchoolList.push({"id":vm.schoolListDropDown[i].id});
                }
            }
        }

        function getUserEducationOffice() {
            if(!vm.isEducationOfficeAdmin) return;
            return educationOfficeService.getEducationOfficeById(vm.educationOfficeId)
                .then(function (data) {
                    vm.userEducationOffice = data;
                    vm.userOfficeHierarchy = vm.userEducationOffice.officeHierarchyId;
                    return getSubordinateClusters();
                }, function (error) {
                    toastr.error("Could not get education office data.");
                });
        }

        function getSubordinateClusters() {
            if(vm.userOfficeHierarchy < 2) return;
            return educationOfficeService.getAllSubordinateClusters()
                .then(function (data) {
                    vm.subordinateClusters = data;
                }, function (error) {
                    toastr.error("Could not get subordinate office data.");
                });
        }

        function updateSchoolDropDownList() {
            resetSchoolDropDownList();
            if(!vm.selectedSubordinateCluster || vm.selectedSubordinateCluster == null || vm.selectedSubordinateCluster.length == 0){
                vm.schoolListDropDown = angular.copy(vm.schoolList);
                makeSchoolSelected();
            } else {
                schoolService.getAllSchoolsUnderAnEducationOffice(vm.selectedSubordinateCluster[0].id).then(function (data) {
                    vm.schoolListDropDown = data;
                    makeSchoolSelected();
                },function (error) {
                    toastr.error("Could not get Schools");
                });
            }
        }

        function resetSchoolDropDownList() {
            vm.schoolListDropDown = [];
            vm.selectedSchoolList = [];
        }

        function resetClusterDropDown() {
            for(var i=0;i<vm.subordinateClusters.length;i++){
                vm.subordinateClusters[i].ticked = false;
            }
            vm.selectedSubordinateCluster = null;
        }

        init();
    }


})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.editTeacher')
        .controller('EditTeacherCtrl', ['teacherService','authService','designationService','$state', '$stateParams','$scope','$q','toastr', '$filter', '$uibModal', 'Upload','GENDER','RELIGION','BLOOD_GROUP','DISTRICT','SUBDISTRICT', EditTeacherCtrl]);


    function EditTeacherCtrl(teacherService,authService,designationService,$state, $stateParams,$scope,$q,toastr,$filter,$uibModal,Upload,GENDER,RELIGION,BLOOD_GROUP,DISTRICT,SUBDISTRICT) {
        var vm = this;
        vm.teacher = null;
        vm.dateOfJoining = new Date();
        vm.districtList = DISTRICT;
        vm.subdistrictList = SUBDISTRICT;
        vm.designationList = [];
        vm.dataLoaded = false;
        vm.photoUploaded = false;

        vm.editTeacher = editTeacher;
        vm.showTeacherPictureUploadModal = showTeacherPictureUploadModal;

        function init() {
            vm.dataLoaded = false;
            $q.all([
                    getTeacherById(),
                    getAllDesignations()
                ]
            ).then(function () {
                console.log("Callback called");
                vm.dataLoaded = true;
                console.log("FOUND");
            }, function (error) {
                console.log("Erorr " + error);
            });
        }

        $scope.dateOfJoining = function() {
            $scope.dateOfJoining.opened = true;
        };
        init();

        function getTeacherById() {
            return teacherService.getTeacherById($stateParams.teacherId).then(function (data) {
                vm.teacher = data;
                if(vm.teacher.photoDir==null || vm.teacher.photoDir=="") vm.teacher.photoDir = $filter('appImage')('theme/no-image.jpg');
                console.log(vm.teacher);
                console.log("Teacher get complete");
            }, function () {
                vm.dataLoaded = true;
                toastr.error("Error while getting teacher");
            });
        }

        function getAllDesignations() {
            designationService.getAllDesignations().then(function (data) {
                vm.designationList = data;
            })
        }

        function editTeacher() {
            if(vm.teacher.name == "") return toastr.error("Teacher Name cannot be empty");
            if(vm.teacher.phoneNo == null || vm.teacher.phoneNo == "") return toastr.error("Mobile Number cannot be empty");
            if(vm.teacher.dateOfJoining == null || vm.teacher.dateOfJoining == "") return toastr.error("Date of joining cannot be empty");
            if(vm.teacher.rfid != null && vm.teacher.rfid != "" && (!vm.teacher.rfid.match(/^[0-9]+$/) || vm.teacher.rfid.length < 10)) return toastr.error("RFID number not valid");
            if(vm.teacher.primaryDisplayText == "") return toastr.error("Primary display text cannot be empty");
            if(vm.teacher.primaryDisplayText != "" && (!vm.teacher.primaryDisplayText.match(/^[a-zA-Z0-9 ]+$/) || vm.teacher.primaryDisplayText.length > 10)) return toastr.error("Primary display text must be english alphanumeric and max 10 characters.");
            if(vm.teacher.secondaryDisplayText == "") return toastr.error("Secondary display text cannot be empty");
            if(vm.teacher.secondaryDisplayText != "" && (!vm.teacher.secondaryDisplayText.match(/^[a-zA-Z0-9 ]+$/) || vm.teacher.secondaryDisplayText.length > 10)) return toastr.error("Secondary display text must be english alphanumeric and max 10 characters.");
            if(vm.teacher.photoDir=="assets/img/theme/no-image.jpg") vm.teacher.photoDir="";

            var data = {
                "dateOfJoining": vm.teacher.dateOfJoining,
                "designationId": vm.teacher.designation.id,
                "email": vm.teacher.email,
                "experience": vm.teacher.experience,
                "qualifications": vm.teacher.qualifications,
                "mpoIndex": vm.teacher.mpoIndex,
                "name": vm.teacher.name,
                "permanentAddress1": vm.teacher.permanentAddress1,
                "permanentAddress2": "",
                "permanentDistrict": vm.teacher.permanentDistrict,
                "permanentSubDistrict": vm.teacher.permanentSubDistrict,
                "phoneNo": vm.teacher.phoneNo,
                "photoDir": vm.teacher.photoDir,
                "presentAddress1": vm.teacher.presentAddress1,
                "presentAddress2": "",
                "presentDistrict": vm.teacher.presentDistrict,
                "presentSubDistrict": vm.teacher.presentSubDistrict,
                "primaryDisplayText": vm.teacher.primaryDisplayText,
                "secondaryDisplayText": vm.teacher.secondaryDisplayText,
                "rfid": vm.teacher.rfid,
                "schoolId": vm.teacher.schoolId
            };

            teacherService.editTeacher(vm.teacher.id, data).then(function (data) {
                toastr.success("Teacher info updated");
                $state.go('teacher.teacherList');
            }, function (error) {
                toastr.error("Failed to update teacher info");
            });

        }
        function showTeacherPictureUploadModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/teacher/edit/teacherPictureUploadModal/teacherPictureUpload.modal.html',
                controller: 'TeacherPictureUploadModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    currentPicURL: function () {
                        return vm.teacher.photoDir;
                    }
                }
            }).result.then(function (teacherPicture) {
                console.log(teacherPicture);
                vm.photoUploaded = true;
                vm.teacher.photoDir = teacherPicture.url;
            }, function () {
                console.log("Teacher picture upload modal dismissed.");
            });
        }

    }


})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.teacherList')
        .controller('TeacherListCtrl', ['authService', 'schoolService', 'teacherService', 'classService', 'sectionService', 'shiftService', 'educationOfficeService', '$q', 'toastr', '$filter', '$uibModal', TeacherListCtrl]);


    function TeacherListCtrl (authService, schoolService, teacherService, classService, sectionService, shiftService, educationOfficeService, $q, toastr, $filter, $uibModal) {
        var vm = this;
        vm.teacherList = [];
        vm.showFilters = false;
        vm.dataLoaded = false;
        vm.designationList = [];
        vm.defaultImg = $filter('appImage')('theme/no-image.jpg');
        vm.searchString = '';
        vm.isEducationOfficeAdmin = false;
        vm.selectedSchoolList = [];
        vm.schoolList = [];
        vm.schoolListDropDown = [];
        vm.schoolId = authService.getLoggedInUser().schoolId;
        vm.educationOfficeId = authService.getLoggedInUser().educationOfficeId;
        vm.userEducationOffice = null;
        vm.userOfficeHierarchy = 0;
        vm.subordinateClusters = [];
        vm.selectedSubordinateCluster = null;

        vm.clearFilter = clearFilter;
        vm.openDeleteModal = openDeleteModal;
        vm.applyFilterAndFetchTeacherList = applyFilterAndFetchTeacherList
        vm.updateSchoolDropDownList = updateSchoolDropDownList

        function init() {
            vm.isEducationOfficeAdmin = authService.getLoggedInUser().isEducationOfficeAdmin;
            $q.all([
                createSchoolList(),
                getUserEducationOffice()
            ]).then(function () {
                applyFilterAndFetchTeacherList();
                console.log("All data loaded");
            });
        }

        function applyFilterAndFetchTeacherList(){
            if(vm.selectedSchoolList.length === 0) return toastr.error("Please select at least one school");
            vm.showFilters = false;
            if(vm.dataLoaded) vm.dataLoaded = false;
            var filterData = {
                teacherName: vm.searchString,
                schoolIdList:getSelectedSchoolIds()
            };
            getAllTeachers(filterData);
        }

        function getAllTeachers(filterData) {
            return teacherService.getAllTeachers(filterData).then(function (data) {
                vm.teacherList = data;
                vm.dataLoaded = true;
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get teachers data");
            });
        }

        function clearFilter() {
            vm.searchString = "";
            vm.selectedSchoolList = [];
            if(vm.userOfficeHierarchy > 1){
                resetClusterDropDown();
                updateSchoolDropDownList();
            }
            init();
        }

        function openDeleteModal(teacher) {
            $uibModal.open({
                templateUrl: 'app/pages/main/teacher/list/delete/teacherDelete.modal.html',
                controller: 'DeleteTeacherModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    teacherToDelete: function () { return teacher }
                }
            }).result.then(function (data) {
                vm.teacherList = data;
                toastr.success("Teacher successfully deleted");
            });
        }

        function createSchoolList(educationOfficeId) {
            if(vm.isEducationOfficeAdmin){
                return schoolService.getAllSchoolsUnderAnEducationOffice(educationOfficeId).then(function (data) {
                    vm.schoolList = data;
                    vm.schoolListDropDown = data;
                    makeSchoolSelected();
                },function (error) {
                    toastr.error("Could not get Schools");
                });
            } else {
                vm.schoolList = [];
                vm.schoolListDropDown = [];
                return schoolService.getSchoolById(vm.schoolId).then(function (data) {
                    vm.schoolList.push(data);
                    vm.schoolListDropDown.push(data);
                    makeSchoolSelected(vm.schoolId);
                },function (error) {
                    toastr.error("Could not get Schools");
                });
            }
        }

        function makeSchoolSelected(schoolId) {
            if(schoolId != null){
                for(var i=0;i<vm.schoolListDropDown.length;i++){
                    if(vm.schoolListDropDown[i].id === schoolId){
                        vm.schoolListDropDown[i].ticked = true;
                        vm.selectedSchoolList.push({"id":vm.schoolListDropDown[i].id});
                    }
                }
            } else if(vm.isEducationOfficeAdmin || vm.isAdmin){
                for(var i=0;i<vm.schoolListDropDown.length;i++){
                    vm.schoolListDropDown[i].ticked = true;
                    vm.selectedSchoolList.push({"id":vm.schoolListDropDown[i].id});
                }
            }
        }

        function getSelectedSchoolIds() {
            if(vm.selectedSchoolList.length === 0)
                return null;
            else{
                return vm.selectedSchoolList.map(function (item) {
                    return item.id;
                });
            }
        }

        function getUserEducationOffice() {
            if(!vm.isEducationOfficeAdmin) return;
            return educationOfficeService.getEducationOfficeById(vm.educationOfficeId)
                .then(function (data) {
                    vm.userEducationOffice = data;
                    vm.userOfficeHierarchy = vm.userEducationOffice.officeHierarchyId;
                    return getSubordinateClusters();
                }, function (error) {
                    toastr.error("Could not get education office data.");
                });
        }

        function getSubordinateClusters() {
            if(vm.userOfficeHierarchy < 2) return;
            return educationOfficeService.getAllSubordinateClusters()
                .then(function (data) {
                    vm.subordinateClusters = data;
                }, function (error) {
                    toastr.error("Could not get subordinate office data.");
                });
        }

        function updateSchoolDropDownList() {
            resetSchoolDropDownList();
            if(!vm.selectedSubordinateCluster || vm.selectedSubordinateCluster == null || vm.selectedSubordinateCluster.length == 0){
                vm.schoolListDropDown = angular.copy(vm.schoolList);
                makeSchoolSelected();
            } else {
                schoolService.getAllSchoolsUnderAnEducationOffice(vm.selectedSubordinateCluster[0].id).then(function (data) {
                    vm.schoolListDropDown = data;
                    makeSchoolSelected();
                },function (error) {
                    toastr.error("Could not get Schools");
                });
            }
        }

        function resetSchoolDropDownList() {
            vm.schoolListDropDown = [];
            vm.selectedSchoolList = [];
        }

        function resetClusterDropDown() {
            for(var i=0;i<vm.subordinateClusters.length;i++){
                vm.subordinateClusters[i].ticked = false;
            }
            vm.selectedSubordinateCluster = null;
        }

        init();
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.teacherMonthlyAttendance')
        .controller('TeacherMonthlyAttendanceCtrl', ['attendanceService', 'authService', 'classService', 'sectionService', 'shiftService', 'educationOfficeService', '$q', '$scope', 'schoolService', 'toastr', TeacherMonthlyAttendanceCtrl]);


    function TeacherMonthlyAttendanceCtrl (attendanceService, authService, classService, sectionService, shiftService, educationOfficeService, $q, $scope, schoolService, toastr) {
        var vm = this;
        vm.teacherList = [];
        vm.showFilters = false;
        vm.dataLoaded = false;
        vm.teacherName = null;
        vm.filterYearMonth = new Date();
        vm.filterFrom = null;
        vm.filterTo = null;
        vm.excelUrl = '';
        vm.schoolId = authService.getLoggedInUser().schoolId;
        vm.educationOfficeId = authService.getLoggedInUser().educationOfficeId;
        vm.monthlyDates = [];
        vm.isEducationOfficeAdmin = false;
        vm.selectedSchoolList = [];
        vm.schoolList = [];
        vm.schoolListDropDown = [];
        vm.userEducationOffice = null;
        vm.userOfficeHierarchy = 0;
        vm.subordinateClusters = [];
        vm.selectedSubordinateCluster = null;

        vm.clearFilter = clearFilter;
        vm.filterAttendances = filterAttendances;
        vm.updateSchoolDropDownList = updateSchoolDropDownList

        function init() {
            vm.filterFrom = new Date(vm.filterYearMonth.getFullYear(), vm.filterYearMonth.getMonth(), 1, 0, 0, 0, 0);
            vm.filterTo = new Date(vm.filterYearMonth.getFullYear(), vm.filterYearMonth.getMonth()+1, 0, 0, 0, 0, 0);
            vm.isEducationOfficeAdmin = authService.getLoggedInUser().isEducationOfficeAdmin;

            $q.all([
                createSchoolList(),
                getUserEducationOffice()
            ]).then(function () {
                var filterData = {
                    from:vm.filterFrom.getTime(),
                    to:vm.filterTo.getTime(),
                    schoolIdList:getSelectedSchoolIds(),
                    teacherName: vm.teacherName,
                };
                getDailyTeacherAttendances(filterData);
                console.log("All data loaded");
                vm.excelUrl = attendanceService.getExcelUrl(vm.filterFrom, vm.filterTo, filterData.schoolIdList, vm.teacherName);
            });
        }
        $scope.filterYearMonth = function() {
            $scope.filterYearMonth.opened = true;
        };
        $scope.getMissingDate = function(noAtt,noDays) {
            var num = noDays - noAtt;
            //console.log(num+" = "+noDays+" - "+noAtt );
            return new Array(num);
        };

        function getDailyTeacherAttendances(filterData) {
            return attendanceService.getTeacherAttendance(filterData).then(function (data) {
                vm.teacherList = data.attendance;
                vm.monthlyDates = data.dates;
                vm.dataLoaded = true;
                //console.log(JSON.stringify(vm.teacherList));
                // console.log(data);
            },function (error) {
                vm.dataLoaded = true;
                toastr.error("Could not get teacher attendance data");
            });
        }
        function filterAttendances(){
            if(vm.filterYearMonth == "") return toastr.error("Year month cannot be empty");
            if(vm.selectedSchoolList.length === 0) return toastr.error("Please select at least one school");
            vm.filterFrom = new Date(vm.filterYearMonth.getFullYear(), vm.filterYearMonth.getMonth(), 1, 0, 0, 0, 0);
            vm.filterTo = new Date(vm.filterYearMonth.getFullYear(), vm.filterYearMonth.getMonth()+1, 0, 0, 0, 0, 0);
            var filterData = {
                from:vm.filterFrom.getTime(),
                to:vm.filterTo.getTime(),
                schoolIdList:getSelectedSchoolIds(),
                teacherName: vm.teacherName,
                classId: vm.selectedClass!=null ? vm.selectedClass.id : vm.selectedClass,
                sectionId: vm.selectedSection!=null ? vm.selectedSection.id : vm.selectedSection,
                shiftId: vm.selectedShift!=null ? vm.selectedShift.id : vm.selectedShift
            };
            vm.dataLoaded = false;
            vm.showFilters = false;
            getDailyTeacherAttendances(filterData);
            vm.excelUrl = attendanceService.getExcelUrl(vm.filterFrom, vm.filterTo, filterData.schoolIdList, vm.teacherName);
        }
        function clearFilter(){
            vm.teacherName = null;
            vm.filterYearMonth = new Date();
            vm.selectedSchoolList = [];
            if(vm.userOfficeHierarchy > 1){
                resetClusterDropDown();
                updateSchoolDropDownList();
            }
            vm.showFilters = false;
            init();
        }

        function createSchoolList() {
            if(vm.isEducationOfficeAdmin){
                return schoolService.getAllSchoolsUnderAnEducationOffice().then(function (data) {
                    vm.schoolList = data;
                    vm.schoolListDropDown = data;
                    makeSchoolSelected();
                },function (error) {
                    toastr.error("Could not get Schools");
                });
            } else {
                vm.schoolList = [];
                vm.schoolListDropDown = [];
                return schoolService.getSchoolById(vm.schoolId).then(function (data) {
                    vm.schoolList.push(data);
                    vm.schoolListDropDown.push(data);
                    makeSchoolSelected(vm.schoolId);
                },function (error) {
                    toastr.error("Could not get Schools");
                });
            }
        }

        function getSelectedSchoolIds() {
            if(vm.selectedSchoolList.length === 0)
                return null;
            else{
                return vm.selectedSchoolList.map(function (item) {
                    return item.id;
                });
            }
        }

        function makeSchoolSelected(schoolId) {
            if(schoolId != null){
                for(var i=0;i<vm.schoolListDropDown.length;i++){
                    if(vm.schoolListDropDown[i].id === schoolId){
                        vm.schoolListDropDown[i].ticked = true;
                        vm.selectedSchoolList.push({"id":vm.schoolListDropDown[i].id});
                    }
                }
            } else if(vm.isEducationOfficeAdmin){
                for(var i=0;i<vm.schoolListDropDown.length;i++){
                    vm.schoolListDropDown[i].ticked = true;
                    vm.selectedSchoolList.push({"id":vm.schoolListDropDown[i].id});
                }
            }
        }

        function getUserEducationOffice() {
            if(!vm.isEducationOfficeAdmin) return;
            return educationOfficeService.getEducationOfficeById(vm.educationOfficeId)
                .then(function (data) {
                    vm.userEducationOffice = data;
                    vm.userOfficeHierarchy = vm.userEducationOffice.officeHierarchyId;
                    return getSubordinateClusters();
                }, function (error) {
                    toastr.error("Could not get education office data.");
                });
        }

        function getSubordinateClusters() {
            if(vm.userOfficeHierarchy < 2) return;
            return educationOfficeService.getAllSubordinateClusters()
                .then(function (data) {
                    vm.subordinateClusters = data;
                }, function (error) {
                    toastr.error("Could not get subordinate office data.");
                });
        }

        function updateSchoolDropDownList() {
            resetSchoolDropDownList();
            if(!vm.selectedSubordinateCluster || vm.selectedSubordinateCluster == null || vm.selectedSubordinateCluster.length == 0){
                vm.schoolListDropDown = angular.copy(vm.schoolList);
                makeSchoolSelected();
            } else {
                schoolService.getAllSchoolsUnderAnEducationOffice(vm.selectedSubordinateCluster[0].id).then(function (data) {
                    vm.schoolListDropDown = data;
                    makeSchoolSelected();
                },function (error) {
                    toastr.error("Could not get Schools");
                });
            }
        }

        function resetSchoolDropDownList() {
            vm.schoolListDropDown = [];
            vm.selectedSchoolList = [];
        }

        function resetClusterDropDown() {
            for(var i=0;i<vm.subordinateClusters.length;i++){
                vm.subordinateClusters[i].ticked = false;
            }
            vm.selectedSubordinateCluster = null;
        }

        init();
    }


})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.academics.shift')
        .controller('ConfigureClassCtrl', ['$scope','authService','shiftService','sectionService','classService','assocService','$uibModal','$q','toastr', ConfigureClassCtrl]);


    function ConfigureClassCtrl ($scope,authService,shiftService,sectionService,classService,assocService,$uibModal,$q,toastr) {
        var vm = this;

        vm.classList = [];
        vm.sectionList = [];
        vm.shiftList = [];
        vm.assocList = [];
        vm.selectedClass = null;
        vm.selectedSection = null;
        vm.selectedShift = null;
        vm.name = null;
        vm.dataLoaded = false;

        vm.createCssAssoc = createCssAssoc;
        vm.openDeleteModal = openDeleteModal;

        function init() {
            $q.all([getAllClasses(),getAllSections(),getAllShifts(),getAllCssAsocs()]).then(function () {
                console.log("All data loaded");
            });
            createEventWatcher();
        };

        function createEventWatcher() {
            $scope.$on('classList-updated', function(event, data) {
                console.log("Received classlist " + JSON.stringify(data.classList));
                vm.classList = data.classList;
            });
        };

        function getAllClasses() {
            classService.getAllClasses().then(function (data) {
                vm.classList = data;
            });
        }

        function getAllSections() {
            sectionService.getAllSections().then(function (data) {
                vm.sectionList = data;
            });
        }

        function getAllShifts() {
            shiftService.getAllShifts().then(function (data) {
                vm.shiftList = data;
            });

        }

        function getAllCssAsocs() {
            assocService.getAllAssocs().then(function (data) {
                vm.assocList = data;
            })
        }

        function openDeleteModal(assoc) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/academics/class/configure/deleteAssoc/deleteAssoc.modal.html',
                size : 'md',
                controller : 'DeleteAssocCtrl',
                controllerAs : 'vm',
                resolve:{
                    assoc: function () {
                        return assoc;
                    }
                }
            }).result.then(function (assocList) {
                toastr.success("Configuration deleted");
                vm.assocList = assocList;
            }, function () {
                console.error("Could not delete configuration");
            });
        }

        function createCssAssoc() {
            if(vm.selectedShift == null)
                return toastr.error("Please select a shift");
            if(vm.selectedClass == null)
                return toastr.error("Please select a class");
            if(vm.selectedSection == null)
                return toastr.error("Please select a section");
            if(vm.name == null)
                return toastr.error("Please write a name");

            var data = {
                schoolId:authService.getLoggedInUser().schoolId,
                classId:vm.selectedClass.id,
                sectionId:vm.selectedSection.id,
                shiftId:vm.selectedShift.id,
                name : vm.name
            };

            assocService.createAssoc(data).then(function (responseData) {
                vm.assocList = responseData;
            },function (error) {
                toastr.error("Could not create configuration");
            })
        }
        init();

    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.academics.class')
        .controller('DeleteClassCtrl', ['classService','toastr','classObject','$uibModalInstance', DeleteClassCtrl]);


    function DeleteClassCtrl (classService,toastr,classObject,$uibModalInstance) {
        var vm = this;

        vm.class = null;
        vm.deleteClass = deleteClass;

        function init() {
            vm.class = classObject;
        }
        init();
        
        function deleteClass() {
            console.log(vm.class);
            classService.deleteClass(vm.class.id).then(function (data) {
                $uibModalInstance.close(data);
            })
        }
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.academics.section')
        .controller('DeleteSectionCtrl', ['sectionService','toastr','section','$uibModalInstance', DeleteSectionCtrl]);


    function DeleteSectionCtrl (sectionService,toastr,section,$uibModalInstance) {
        var vm = this;

        vm.section = null;
        vm.deleteClass = deleteClass;

        function init() {
            vm.section = section;
        }

        init();
        
        function deleteClass() {
            sectionService.deleteSection(vm.section.id).then(function (data) {
                $uibModalInstance.close(data);
            })
        }
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.academics.shift')
        .controller('DeleteShiftCtrl', ['shiftService','toastr','shift','$uibModalInstance', DeleteShiftCtrl]);


    function DeleteShiftCtrl (shiftService,toastr,shift,$uibModalInstance) {
        var vm = this;

        vm.shift = null;
        vm.deleteShift = deleteShift;

        function init() {
            vm.shift = shift;
        }

        init();

        function deleteShift() {
            shiftService.deleteShift(vm.shift.id).then(function (data) {
                $uibModalInstance.close(data);
            })
        }
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.academics.shift')
        .controller('EditShiftCtrl', ['shiftService','toastr','shift','$uibModalInstance', EditShiftCtrl]);


    function EditShiftCtrl (shiftService,toastr,shift,$uibModalInstance) {
        var vm = this;

        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = true;

        vm.shift = null;
        vm.editShift = editShift;

        function init() {
            vm.shift = shift;
            var today = new Date();
            vm.fromTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Math.floor(shift.startTimeMinute/60),shift.startTimeMinute%60, 0);
            vm.toTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Math.floor(shift.endTimeMinute/60),shift.endTimeMinute%60, 0);
        }

        init();

        function editShift() {
            if(vm.shift.name == null || vm.shift.name=='')
                return toastr.error("Name cannot be empty");
            var fromMinutes = (vm.fromTime.getHours() * 60) + vm.fromTime.getMinutes();
            var toMinutes = (vm.toTime.getHours() * 60) + vm.toTime.getMinutes();
            if(fromMinutes >= toMinutes)
                return toastr.error("Start time cannot be after end time");
            var data = {
                name: vm.name,
                schoolId: vm.shift.schoolId,
                startTimeMinute: fromMinutes,
                endTimeMinute: toMinutes,
            };
            shiftService.updateShift(vm.shift.id,data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            });
        }
    }


})();
(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.teacher')
        .controller('DeleteLeaveModalCtrl',['leaveService','$uibModalInstance','toastr','leaveIdToDelete',DeleteLeaveModalCtrl]);

    function DeleteLeaveModalCtrl(leaveService,$uibModalInstance,toastr,leaveIdToDelete) {
        var vm = this;

        vm.leaveIdToDelete = null;
        vm.deleteLeave = deleteLeave;

        function init() {
            vm.leaveIdToDelete = leaveIdToDelete;
            console.log(vm.leaveIdToDelete);
        }

        init();

        function deleteLeave() {
            leaveService.deleteLeave(vm.leaveIdToDelete).then(function (data) {
                $uibModalInstance.close(data);
            },function (error) {
                toastr.error(error);
            });
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.school')
        .controller('BatchSchoolCreateCtrl', ['$window','schoolService','toastr',BatchSchoolCreateCtrl]);

    /** @ngInject */
    function BatchSchoolCreateCtrl($window,schoolService,toastr) {

        var vm = this;
        vm.batchCreationDone = true;
        vm.resellerList = [];

        vm.requests = [];

        vm.redirectToDownloadSamplePage = redirectToDownloadSamplePage;
        vm.batchCreateSchools = batchCreateSchools;

        function init() {
            schoolService.getAllReseller().then(function (data) {
                vm.resellerList = data;
            },function (error) {
                toastr.error("Could not fetch reseller list");
            })
            console.log("Batch create ctrl loaded");
        }

        init();

        function redirectToDownloadSamplePage() {
            $window.open ("https://docs.google.com/spreadsheets/d/1C6m1A4MMi2jrtsWZnnYrb6UCnNLs93vdmgoFXzXiRPU");
        }

        function batchCreateSchools() {
            vm.batchCreationDone = false;
            if (vm.file == null) {
                toastr.error("File not selected or size limit exceeded.");
                return;
            }
            schoolService.batchCreate(vm.file).then(function (data) {
                vm.batchCreationDone = true;
                toastr.success("School batch create request successful");
            }, function (errorMessage) {
                console.error(errorMessage);
                toastr.error("Could not perform batch create request of school : " + errorMessage);
            });
        }


    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.school')
        .controller('SchoolCreationHistoryCtrl', ['$scope','scheduledSchoolCreateService','toastr',SchoolCreationHistoryCtrl]);

    /** @ngInject */
    function SchoolCreationHistoryCtrl($scope,scheduledSchoolCreateService,toastr) {

        var vm = this;

        vm.requests = [];

        vm.retry = retry;
        vm.getDisabled = getDisabled;

        function init() {
            $scope.$on('switchedToHistoryTab',getHistory);
            getHistory();
        }

        init();

        function getHistory() {
            scheduledSchoolCreateService.getAll().then(function (data) {
                vm.requests = data;
                console.log(data);
                console.log("History fetched");
            })
        }

        function retry(index,id) {
            scheduledSchoolCreateService.retry(id).then(function () {
                vm.requests[index].status = 1;
            },function (error) {
               toastr.error("Could not create school ");
            });
        }

        function getDisabled(request) {
            return request.status !== -1;
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student')
        .controller('ProfileImageUploadModalCtrl', ['$filter', '$uibModalInstance', 'API', 'currentProfilePicURL', 'toastr', 'Upload', ProfileImageUploadModalCtrl]);

    /** @ngInject */
    function ProfileImageUploadModalCtrl($filter, $uibModalInstance, API, currentProfilePicURL, toastr, Upload) {

        var vm = this;
        vm.defaultImage = null;
        vm.currentProfilePicURL = null;
        vm.isFileSelected = false;
        vm.fileSelected = fileSelected;
        vm.uploadProfilePicture = uploadProfilePicture;

        init();

        function init () {
            vm.currentProfilePicURL = currentProfilePicURL ? currentProfilePicURL : $filter('appImage')('theme/no-image.jpg');
        }

        function fileSelected() {
            vm.isFileSelected = true;
        }

        function uploadProfilePicture(dataUrl, name) {
            vm.isFileSelected = false;
            Upload.upload({
                url: API.student.uploadPicture,
                data: {
                    file: Upload.dataUrltoBlob(dataUrl, name)
                }
            }).then(function (response) {
                if (response.status === 200) {
                    $uibModalInstance.close(response.data);
                    toastr.success("Student picture updated.");
                } else {
                    $uibModalInstance.dismiss("Failed to upload student picture. " + response.message);
                    console.error("failed to upload student picture : " + response.message);
                    toastr.error("Failed to upload student picture. " + response.message);
                }

            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to upload student picture. " + response.message);
                    console.error("failed to upload student picture : " + response.message);
                    toastr.error("Failed to upload student picture. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.student.editStudent')
        .controller('StudentPictureUploadModalCtrl', ['$filter', '$uibModalInstance', 'API', 'currentPicURL', 'toastr', 'Upload', StudentPictureUploadModalCtrl]);

    /** @ngInject */
    function StudentPictureUploadModalCtrl($filter, $uibModalInstance, API, currentPicURL, toastr, Upload) {

        var vm = this;
        vm.defaultImage = null;
        vm.currentPicURL = null;
        vm.isFileSelected = false;
        vm.fileSelected = fileSelected;
        vm.uploadNoticePicture = uploadNoticePicture;

        init();

        function init () {
            vm.currentPicURL = currentPicURL ? currentPicURL : $filter('appImage')('theme/no-image.jpg');
        }

        function fileSelected() {
            vm.isFileSelected = true;
        }

        function uploadNoticePicture(dataUrl, name) {
            vm.isFileSelected = false;
            Upload.upload({
                url: API.student.uploadPicture,
                data: {
                    file: Upload.dataUrltoBlob(dataUrl, name)
                }
            }).then(function (response) {
                if (response.status === 200) {
                    $uibModalInstance.close(response.data);
                    toastr.success("Student picture updated.");
                } else {
                    $uibModalInstance.dismiss("Failed to upload student picture. " + response.message);
                    console.error("failed to upload student picture : " + response.message);
                    toastr.error("Failed to upload student picture. " + response.message);
                }

            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to upload student picture. " + response.message);
                    console.error("failed to upload student picture : " + response.message);
                    toastr.error("Failed to upload student picture. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.teacher.batchCreateTeachers')
        .controller('BatchCreateCtrl', ['$window','teacherService','toastr',BatchCreateCtrl]);

    /** @ngInject */
    function BatchCreateCtrl($window,teacherService,toastr) {

        var vm = this;
        vm.batchCreationDone = true;

        vm.requests = [];

        vm.redirectToDownloadSamplePage = redirectToDownloadSamplePage;
        vm.batchCreateTeachers = batchCreateTeachers;

        function init() {
            console.log("Batch create ctrl loaded");
        }

        init();

        function redirectToDownloadSamplePage() {
            $window.open ("https://docs.google.com/spreadsheets/d/1Ncx-TGrX7__jNbeGI3HZKk_rHg8oagvHOOdvqsxfzUA");
        }

        function batchCreateTeachers() {
            vm.batchCreationDone = false;
            if (vm.file == null) {
                toastr.error("File not selected or size limit exceeded.");
                return;
            }
            teacherService.batchCreate(vm.file).then(function (data) {
                vm.batchCreationDone = true;
                toastr.success("Employee batch create request successful");
            }, function (errorMessage) {
                console.error(errorMessage);
                toastr.error("Could not perform batch create request employee : " + errorMessage);
            });
        }


    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.teacher.batchCreateTeachers')
        .controller('HistoryCtrl', ['$scope','scheduledEmployeeCreateService','toastr',HistoryCtrl]);

    /** @ngInject */
    function HistoryCtrl($scope,scheduledEmployeeCreateService,toastr) {

        var vm = this;

        vm.requests = [];

        vm.retry = retry;
        vm.getDisabled = getDisabled;

        function init() {
            $scope.$on('switchedToHistoryTab',getHistory);
            getHistory();
        }

        init();

        function getHistory() {
            scheduledEmployeeCreateService.getAll().then(function (data) {
                vm.requests = data;
                console.log("History fetched");
            })
        }

        function retry(index,id) {
            scheduledEmployeeCreateService.retry(id).then(function () {
                vm.requests[index].status = 1;
            },function (error) {
               toastr.error("Could not create employee ");
            });
        }

        function getDisabled(request) {
            return request.status !== -1;
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.editTeacher')
        .controller('TeacherPictureUploadModalCtrl', ['$filter', '$uibModalInstance', 'API', 'currentPicURL', 'toastr', 'Upload', TeacherPictureUploadModalCtrl]);

    /** @ngInject */
    function TeacherPictureUploadModalCtrl($filter, $uibModalInstance, API, currentPicURL, toastr, Upload) {

        var vm = this;
        vm.defaultImage = null;
        vm.currentPicURL = null;
        vm.isFileSelected = false;
        vm.fileSelected = fileSelected;
        vm.uploadTeacherPicture = uploadTeacherPicture;

        init();

        function init () {
            vm.currentPicURL = currentPicURL ? currentPicURL : $filter('appImage')('theme/no-image.jpg');
        }

        function fileSelected() {
            vm.isFileSelected = true;
        }

        function uploadTeacherPicture(dataUrl, name) {
            vm.isFileSelected = false;
            Upload.upload({
                url: API.student.uploadPicture,
                data: {
                    file: Upload.dataUrltoBlob(dataUrl, name)
                }
            }).then(function (response) {
                if (response.status === 200) {
                    $uibModalInstance.close(response.data);
                    toastr.success("Teacher picture updated.");
                } else {
                    $uibModalInstance.dismiss("Failed to upload teacher picture. " + response.message);
                    console.error("failed to upload teacher picture : " + response.message);
                    toastr.error("Failed to upload teacher picture. " + response.message);
                }

            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to upload teacher picture. " + response.message);
                    console.error("failed to upload teacher picture : " + response.message);
                    toastr.error("Failed to upload teacher picture. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.teacher.editTeacher')
        .controller('TeacherPictureUploadModalCtrl', ['$filter', '$uibModalInstance', 'API', 'currentPicURL', 'toastr', 'Upload', TeacherPictureUploadModalCtrl]);

    /** @ngInject */
    function TeacherPictureUploadModalCtrl($filter, $uibModalInstance, API, currentPicURL, toastr, Upload) {

        var vm = this;
        vm.defaultImage = null;
        vm.currentPicURL = null;
        vm.isFileSelected = false;
        vm.fileSelected = fileSelected;
        vm.uploadTeacherPicture = uploadTeacherPicture;

        init();

        function init () {
            vm.currentPicURL = currentPicURL ? currentPicURL : $filter('appImage')('theme/no-image.jpg');
        }

        function fileSelected() {
            vm.isFileSelected = true;
        }

        function uploadTeacherPicture(dataUrl, name) {
            vm.isFileSelected = false;
            Upload.upload({
                url: API.student.uploadPicture,
                data: {
                    file: Upload.dataUrltoBlob(dataUrl, name)
                }
            }).then(function (response) {
                if (response.status === 200) {
                    $uibModalInstance.close(response.data);
                    toastr.success("Teacher picture updated.");
                } else {
                    $uibModalInstance.dismiss("Failed to upload teacher picture. " + response.message);
                    console.error("failed to upload teacher picture : " + response.message);
                    toastr.error("Failed to upload teacher picture. " + response.message);
                }

            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to upload teacher picture. " + response.message);
                    console.error("failed to upload teacher picture : " + response.message);
                    toastr.error("Failed to upload teacher picture. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.teacher')
        .controller('DeleteTeacherModalCtrl',['teacherService','$uibModalInstance','toastr','teacherToDelete',DeleteTeacherModalCtrl]);

    function DeleteTeacherModalCtrl(teacherService,$uibModalInstance,toastr,teacherToDelete) {
        var vm = this;

        vm.teacherToDelete = null;
        vm.deleteTeacher = deleteTeacher;

        function init() {
            vm.teacherToDelete = teacherToDelete;
        }

        init();

        function deleteTeacher() {
            teacherService.deleteTeacher(vm.teacherToDelete.id).then(function (data) {
                $uibModalInstance.close(data);
            },function (error) {
                toastr.error(error);
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.academics.class')
        .controller('DeleteAssocCtrl', ['assocService','toastr','assoc','$uibModalInstance', DeleteAssocCtrl]);


    function DeleteAssocCtrl (assocService,toastr,assoc,$uibModalInstance) {
        var vm = this;

        vm.assoc = null;
        vm.deleteAssoc = deleteAssoc;

        function init() {
            vm.assoc = assoc;
        }

        init();

        function deleteAssoc() {
            assocService.deleteAssoc(vm.assoc.id).then(function (data) {
                $uibModalInstance.close(data);
            })
        }
    }


})();
angular.module('InovaceClientApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/auth/auth.html','<main class="auth-main" ng-if="$pageFinishedLoading"><div ui-view="pub"></div></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/main/main.html','<head><title>Inovace School Admin Panel</title></head><div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="app" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix"><div class="al-footer-main clearfix"><ul class="al-share clearfix"><li><a target="_blank" href="https://www.facebook.com/inovace360"><i class="socicon socicon-facebook"></i></a></li><li><i class="socicon socicon-twitter"></i></li><li><i class="socicon socicon-google"></i></li><li><i class="socicon socicon-github"></i></li></ul><div class="al-copy"><span>Created with <i style="color:#F60000;" class="ion-heart"></i> by</span> <a href="http://www.inovacetech.com">Inovace Technologies</a></div></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/auth/login/login.html','<head><title>Login - Inovace Attendance Panel</title><style>\n\n        body {\n            font-family: \'Roboto\', sans-serif;\n        }\n        body {\n            background-color: #014865;\n        }\n        .full-panel{\n            margin-top: 5%;\n        }\n        .left-img{\n            background-image:url("../assets/img/left.jpg");\n            background-repeat: no-repeat;\n            background-size: cover;\n            background-position: center;\n            min-height: 660px;\n            box-shadow: 10px 5px 10px rgba(0,0,0,0.30);\n        }\n        .right-img{\n            background-image:url("../assets/img/right.jpg");\n            background-repeat: no-repeat;\n            background-size: cover;\n            background-position: center;\n            min-height: 660px;\n            box-shadow: 3px 5px 10px rgba(0,0,0,0.30);\n\n        }\n        .login-panel{\n            min-height: 660px;\n            background-color:#fff;\n            padding: 20px 30px 0 20px;\n            box-shadow: 10px 5px 10px rgba(0,0,0,0.30);\n        }\n\n        /* Extra small devices (phones, 600px and down) */\n        @media only screen and (max-width: 600px) {\n            .left-img{\n                width: 2%;\n                float: left;\n                border-radius: 10px 0 0 10px;\n            }\n            .login-panel{\n                width: 96%;\n                float:left;\n            }\n            .right-img{\n                width: 2%;\n                float: right;\n                border-radius: 0 10px 10px 0;\n\n            }\n        }\n\n        /* Small devices (portrait tablets and large phones, 600px and up) */\n        @media only screen and (min-width: 600px) {\n\n            .left-img{\n                width: 2%;\n                float: left;\n                border-radius: 10px 0 0 10px;\n            }\n            .login-panel{\n                width: 96%;\n                float:left;\n            }\n            .right-img{\n                width: 2%;\n                float: right;\n                border-radius: 0 10px 10px 0;\n\n            }\n        }\n\n        /* Medium devices (landscape tablets, 768px and up) */\n        @media only screen and (min-width: 768px) {\n            .left-img{\n                width: 2%;\n                float: left;\n                border-radius: 10px 0 0 10px;\n            }\n            .login-panel{\n                width: 96%;\n                float:left;\n            }\n            .right-img{\n                width: 2%;\n                float: right;\n                border-radius: 0 10px 10px 0;\n\n            }\n        }\n\n        /* Large devices (laptops/desktops, 992px and up) */\n        @media only screen and (min-width: 992px) {\n            .left-img{\n                width: 30%;\n                float: left;\n                border-radius: 10px 0 0 10px;\n            }\n            .login-panel{\n                width: 40%;\n                float:left;\n            }\n            .right-img{\n                width: 30%;\n                float: right;\n                border-radius: 0 10px 10px 0;\n\n            }\n        }\n\n        /* Extra large devices (large laptops and desktops, 1200px and up) */\n        @media only screen and (min-width: 1200px) {\n            .left-img{\n                width: 35%;\n                float: left;\n                border-radius: 10px 0 0 10px;\n            }\n            .login-panel{\n                width: 30%;\n                float:left;\n            }\n            .right-img{\n                width: 35%;\n                float: right;\n                border-radius: 0 10px 10px 0;\n\n            }\n        }\n\n\n        .logo-style{\n            width: 166px;\n            height: auto;\n            margin: 0 auto;\n            display: block;\n            margin-bottom: 32px;\n            margin-top: 30px;\n        }\n        .title-place-holder{\n            width: 220px;\n            height: auto;\n            margin: 0 auto;\n            background-color: rgba(1,154,219,0.15);\n            padding: 5px;\n            color: #222;\n            border-radius: 30px;\n            margin-bottom: 32px;\n            text-align: center;\n        }\n        .title-place-holder p{\n            font-size: 18px;\n            font-weight: 600;\n            margin: 0;\n            padding: 2px;\n        }\n        /*from*/\n\n        label {\n            display: inline-block;\n            max-width: 100%;\n            margin-bottom: 5px;\n            font-size: 14px;\n            font-weight: normal;\n        }\n        .form-control {\n            display: block;\n            width: 100%;\n            height: 34px;\n            padding: 6px 0px;\n            font-size: 16px;\n            line-height: 1.42857143;\n            color: #555;\n            background-color: #fff;\n            background-image: none;\n            border: none;\n            border-bottom: 1px solid #ccc;\n            border-radius: 0px;\n            -webkit-box-shadow: none;\n            box-shadow: none;\n            -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow none;\n            -o-transition: border-color ease-in-out .15s, box-shadow none;\n            transition: border-color ease-in-out .15s, box-shadow none;\n        }\n        .form-control:focus {\n            border-color: #66afe9;\n            outline: 0;\n            -webkit-box-shadow: none;\n            box-shadow: none;\n        }\n        .customized-btn{\n            width: 166px;\n            margin: 0 auto;\n            /*margin-top: 32px;*/\n        }\n        .btn {\n            display: inline-block;\n            padding: 6px 12px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: normal;\n            line-height: 1.42857143;\n            text-align: center;\n            white-space: nowrap;\n            vertical-align: middle;\n            -ms-touch-action: manipulation;\n            touch-action: manipulation;\n            cursor: pointer;\n            -webkit-user-select: none;\n            -moz-user-select: none;\n            -ms-user-select: none;\n            user-select: none;\n            background-image: none;\n            border: 1px solid transparent;\n            width: 100%;\n            border-radius: none;\n        }\n        .btn-primary {\n            margin-top: 32px;\n            color: #fff;\n            background-color: #019ADB;\n            /* border-color: #2e6da4; */\n            border-radius: 20px;\n        }\n        .vector-bottom{\n            width: 277px;\n            height: auto;\n            margin: 0 auto;\n            display: block;\n            vertical-align: bottom;\n\n        }\n    </style></head><div class="login-background"><div class="container"><div class="row"><div class="full-panel"><div class="left-img"></div><div class="login-panel"><div class="login_from"><img src="../assets/img/logo.png" class="logo-style"><div class="title-place-holder"><p>SCHOOL LOGIN</p></div><form ng-submit="login()"><div class="form-group"><label for="inputEmail3">Email</label> <input type="email" class="form-control" id="inputEmail3" placeholder="Email" ng-model="loginData.email"></div><div class="form-group"><label for="inputPassword3">Password</label> <input type="password" class="form-control" id="inputPassword3" placeholder="Password" ng-model="loginData.password"></div><div class="customized-btn"><button type="submit" class="btn btn-primary">LOG IN</button></div><img src="../assets/img/vector.png" class="vector-bottom"></form></div></div><div class="right-img"></div></div></div></div></div>');
$templateCache.put('app/pages/main/dashboard/dashboard.html','<style>\n    .chart-title {\n        position: absolute;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 100px;\n        text-align: center;\n        font-size: 11px;\n        word-wrap: break-word;\n    }\n</style><div class="row"><div class="col-lg-8"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'attendanceChart\'| translate}}" ba-panel-class="with-scroll"><div data-ride="carousel" ng-if="vm.dashboardData.length > 0" style="width: 96%; margin-left: 2%;"><div ng-mouseenter="vm.autoplay = false" ng-mouseleave="vm.autoplay=true"><ui-carousel slides="vm.dashboardData" slides-to-show="vm.slidesToShow" slides-to-scroll="vm.slidesToScroll" initial-slide="1" autoplay="vm.autoplay" autoplay-speed="2000" on-init="ctrl.next" dots="vm.showDots" style="text-align: center"><carousel-item><div style="position: relative;"><span class="chart-title">{{item.schoolName}}</span><canvas id="doughnut-{{item.schoolId}}" class="chart chart-doughnut" chart-data="item.data" chart-options="item.options" chart-labels="item.labels" chart-colors="item.colours" height="200" width="200"></canvas></div></carousel-item></ui-carousel><div style="margin-top: 30px; text-align: center; font-size: 16px;" ng-if="vm.dashboardData.length>20">{{vm.showingSlide}} / {{vm.dashboardData.length}}</div><div style="margin-top: 30px; text-align: center"><ul ng-repeat="labelAndColor in vm.labelsAndColors" class="pie-legend-ul"><li class="pie-legend-li"><span class="pie-legend-span" style="background-color: {{labelAndColor.colour}}"></span>{{labelAndColor.label}}</li></ul></div></div></div></div></div><div class="col-lg-12" ng-hide="true"><div ba-panel="" ba-panel-title="{{\'runningSections\' | translate}}" ba-panel-class="with-scroll"><table class="table table-bordered"><thead><th>#</th><th>{{\'class\'| translate}}</th><th>{{\'totalStudents\' | translate}}</th><th>{{\'present\' | translate}}</th><th>{{\'absent\' | translate}}</th><th>{{\'late\' | translate}}</th></thead><tr ng-repeat="data in vm.dashboardData"><td>{{$index+1}}</td><td>{{data.classAndSectionName}}</td><td>{{data.total}}</td><td>{{data.present}}</td><td>{{data.absent}}</td><td>{{data.late}}</td></tr></table></div></div></div><div class="col-lg-4"><div ba-panel="" ba-panel-title="{{\'attendanceFeed\' | translate}}" ba-panel-class="semi-large-panel with-scroll feed-panel"><div class="row text-center" ng-if="vm.feedDataLoaded == false"><div class="bar-loader" ng-if="vm.feedDataLoaded == false"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div class="feed-messages-container" track-width="smallContainerWidth" min-width="360" ng-if="vm.feedDataLoaded == true"><div class="feed-message" ng-repeat="feed in vm.feedData"><div class="message-icon"><img class="photo-icon" ng-src="assets/img/theme/no-photo2.png"></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ feed.name }}</span></div><div class="message-content line-clamp line-clamp-1" style="color:#aaaaaa; font-size: 12px;"><span ng-if="feed.punchType==1">Log type Fingerprint</span> <span ng-if="feed.punchType==2">Log type RFID card</span> {{feed.text}} <span ng-if="feed.isLate" style="color:red;font-size: 10px;float: right">({{feed.lateBy}})</span></div><div class="message-time"><div class="post-time">{{feed.displayTime}}</div><div class="ago-time">{{feed.ago}}</div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/educationOffice/educationOffice.html','<div ba-panel="" ba-panel-title="{{\'EDUCATIONOFFICE\' |translate}}" ba-panel-class="with-scroll"><div class="row" style="margin-bottom: 10px"><div class="col-md-3" ng-if="vm.isAdmin"><button ui-sref="createEducationOffice" class="btn btn-primary btn-block">{{\'addEducationOffice\'|translate}}</button></div></div><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.educationOfficeList.length > 0 && vm.dataLoaded == true"><thead><th>#</th><th>{{\'educationOfficeName\'|translate}}</th><th>{{\'address\'|translate}}</th><th>{{\'district\'|translate}}</th><th>{{\'subDistrict\'|translate}}</th><th>{{\'educationOfficeAdminEmail\'|translate}}</th></thead><tbody><tr ng-repeat="educationOffice in vm.educationOfficeList"><td>{{$index+1}}</td><td ng-if="vm.isAdmin || vm.isEducationOfficeAdmin"><a ui-sref="editEducationOffice({educationOfficeId:educationOffice.id})">{{educationOffice.name}}</a></td><td ng-if="!vm.isAdmin && !vm.isEducationOfficeAdmin">{{educationOffice.name}}</td><td>{{educationOffice.address}}</td><td>{{educationOffice.district}}</td><td>{{educationOffice.subDistrict}}</td><td>{{educationOffice.email}}</td></tr></tbody></table><div class="row text-center" ng-if="vm.educationOfficeList.length == 0"><b>No Data Found</b></div></div></div>');
$templateCache.put('app/pages/main/holidays/holidayTable.partial.html','<div ng-controller="HolidayTableCtrl as vm"><div class="col-md-3"><h3 id="event-editor">{{\'holidayList\'|translate}}</h3></div><div class="col-md-6"></div><div class="col-md-3" style="float: right; padding-right: 0px !important;"><button class="btn btn-primary btn-block" ng-click="vm.openCreateModal()">{{\'addNewHoliday\'|translate}}</button></div><br><br><table class="table table-bordered calendarEdit" style="margin-top: 20px" ng-if="vm.events.length >0"><thead><tr><th class="text-center"><strong translate="">{{\'title\'}}</strong></th><th class="text-center"><strong translate="">{{\'date\'}}</strong></th><th class="text-center"><strong translate="">{{\'actions\'}}</strong></th></tr></thead><tbody><tr ng-repeat="event in vm.events" style="border:0px solid white"><td class="text-center" style="vertical-align: middle!important;">{{event.description}}</td><td class="text-center" style="vertical-align: middle!important;">{{event.holidayDate | date: "dd MMMM yyyy "}}</td><td><div class="col-md-6"><button class="btn btn-primary btn-block" ng-click="vm.openUpdateModal(event,$index)" style="margin: 5px; padding-right: 0px !important;">{{\'update\'|translate}}</button></div><div class="col-md-6"><button class="btn btn-danger btn-block" ng-click="vm.openDeleteModal(event,$index)" style="margin: 5px; padding-right: 0px !important;">{{\'delete\'|translate}}</button></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/holidays/holidays.html','<style>\n\n</style><div ba-panel="" ba-panel-title="{{\'holidaysInCalendar\'|translate}}" ba-panel-class="with-scroll"><div><br><br><h2 class="text-center">{{ vm.calendarTitle }}</h2><br><br><div class="row"><div class="col-md-6 text-center"><div class="btn-group"><button class="btn btn-primary" mwl-date-modifier="" date="vm.viewDate" decrement="vm.calendarView" ng-click="vm.cellIsOpen = false">Previous</button> <button class="btn btn-default" mwl-date-modifier="" date="vm.viewDate" set-to-today="" ng-click="vm.cellIsOpen = false">Today</button> <button class="btn btn-primary" mwl-date-modifier="" date="vm.viewDate" increment="vm.calendarView" ng-click="vm.cellIsOpen = false">Next</button></div></div><br class="visible-xs visible-sm"><div class="col-md-6 text-center"><div class="btn-group"><label class="btn btn-warning" ng-model="vm.calendarView" uib-btn-radio="\'year\'" ng-click="vm.cellIsOpen = false">Year</label> <label class="btn btn-warning" ng-model="vm.calendarView" uib-btn-radio="\'month\'" ng-click="vm.cellIsOpen = false">Month</label> <label class="btn btn-warning" ng-model="vm.calendarView" uib-btn-radio="\'week\'" ng-click="vm.cellIsOpen = false">Week</label> <label class="btn btn-warning" ng-model="vm.calendarView" uib-btn-radio="\'day\'" ng-click="vm.cellIsOpen = false">Day</label></div></div></div><br><br><div class="row"><mwl-calendar events="vm.events" view="vm.calendarView" view-title="vm.calendarTitle" view-date="vm.viewDate" cell-is-open="vm.cellIsOpen" day-view-start="06:00" day-view-end="22:59" day-view-split="30" cell-auto-open-disabled="true" on-timespan-click="vm.timespanClicked(calendarDate, calendarCell)" cell-modifier="vm.cellModifier(calendarCell)" class="col-md-8 col-md-offset-2"></mwl-calendar></div><br><br><br></div><div include-with-scope="app/pages/main/holidays/holidayTable.partial.html"></div></div>');
$templateCache.put('app/pages/main/school/school.html','<div ba-panel="" ba-panel-title="{{\'SCHOOL\' |translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'btn btn-default btn-sm pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-right\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-down\'></i> </span>" ba-panel-class="with-scroll"><div class="row form-inline filter-div" ng-show="vm.showFilters"><div class="form-group col-md-12"><div class="col-md-6"><input class="form-control" type="text" placeholder="{{\'schoolName\'|translate}} / Code / {{\'district\'|translate}} / {{\'subDistrict\'|translate}} / {{\'address\'|translate}} / {{\'EDUCATIONOFFICE\'|translate}}" ng-model="vm.searchString"></div><div class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.getAllSchools(vm.searchString)"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div></div><div class="row" style="margin-bottom: 10px"><div class="col-md-3" ng-if="vm.isAdmin"><button ui-sref="createSchool" class="btn btn-primary btn-block">{{\'addSchool\'|translate}}</button></div></div><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.schoolList.length > 0 && vm.dataLoaded == true"><thead><th>#</th><th>{{\'schoolName\'|translate}}</th><th>EIIN</th><th>Code</th><th>{{\'district\'|translate}}</th><th>{{\'subDistrict\'|translate}}</th><th>{{\'schoolAdminEmail\'|translate}}</th><th>{{\'affiliatedEducationOffice\'|translate}}</th></thead><tbody><tr ng-repeat="school in vm.schoolList"><td>{{$index+1}}</td><td ng-if="!vm.isEducationOfficeAdmin"><a ui-sref="editSchool({schoolId:school.id})">{{school.name}}</a></td><td ng-if="vm.isEducationOfficeAdmin">{{school.name}}</td><td>{{school.eiin}}</td><td>{{school.code}}</td><td>{{school.district}}</td><td>{{school.subDistrict}}</td><td>{{school.email}}</td><td>{{school.educationOfficeName == null ? "N/A" : school.educationOfficeName}}</td></tr></tbody></table><div class="row text-center" ng-if="vm.schoolList.length == 0"><b>No Data Found</b></div></div></div>');
$templateCache.put('app/pages/main/notice/notice.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'createNotice\' |translate}}" ba-panel-class="with-scroll"><div class="row"><div class="col-md-8 form-group"><label translate="">{{\'noticeTitle\'}}</label> <input class="form-control" type="text" ng-model="vm.subject"></div><div class="col-md-4 form-group"><label translate="">{{\'publishDate\'}}</label> <input type="text" ng-model="vm.publishDate" class="form-control" id="publishDate" uib-datepicker-popup="dd MMMM yyyy" is-open="publishDate.opened" datepicker-options="dateOptions" ng-required="true" ng-click="publishDate()"></div><div class="col-md-12 form-group"><label translate="">{{\'noticeDescription\'}}</label> <textarea class="form-control" ng-model="vm.description"></textarea></div><div class="col-md-6 form-group"><label translate="">{{\'noticeImage\'}} <small class="text-greyed">( jpg/png )</small></label><img class="img-rounded" ng-src="{{vm.currentNoticePicURL}}" ng-click="vm.showNoticeImageUploadModal()" style="width: 100%; height: 150px; cursor: pointer;"> <a href="" class="change-userpic" ng-click="vm.showNoticeImageUploadModal()" translate="">{{\'uploadNoticeImage\'}}</a></div><div class="col-md-6 form-group"><label translate="">{{\'noticeFiles\'}} <small class="text-greyed">( doc/xl/pdf )</small></label> <input type="file" ng-model="vm.fileDir"></div></div><div class="row"><div class="col-md-4 pull-right"><button class="btn btn-primary btn-block" ng-if="!vm.editMood" ng-click="vm.createNotice()">Create</button> <button class="btn btn-primary btn-block" ng-if="vm.editMood" ng-click="vm.updateNotice()">Update</button></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'latestNotice\' |translate}}" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div class="row"><div class="col-md-12" style="margin-bottom: 10px;"><span class="label label-info">{{vm.noticeList[0].publishDate | date: "dd MMMM yyyy "}}</span></div><div class="col-md-12"><h4>{{vm.noticeList[0].subject}}</h4></div><div class="col-md-12" style="margin-bottom: 10px;"><img class="img-rounded" ng-src="{{vm.noticeList[0].imgDir}}" style="width: 100%; height: 150px; border:1px solid #eee"></div><div class="col-md-12"><p>{{vm.noticeList[0].description}}</p></div></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Notice List" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.noticeList.length > 0 && vm.dataLoaded == true"><thead><th>#</th><th translate="">{{\'noticeTitle\'}}</th><th translate="">{{\'publishDate\'}}</th><th translate="">{{\'noticeFiles\'}}</th><th class="text-center" translate="">{{\'actions\'}}</th></thead><tbody><tr ng-repeat="notice in vm.noticeList"><td>{{$index+1}}</td><td>{{notice.subject}}</td><td>{{notice.publishDate | date: "dd MMMM yyyy "}}</td><td><a href="{{notice.fileDir}}">File Download Link</a></td><td class="text-center"><i class="ion-android-create tableIcons" style="cursor: pointer; padding: 0px 10px;" title="Edit" ng-click="vm.editNotice(notice)"></i> <i class="ion-trash-b tableIcons" style="cursor: pointer; padding: 0px 10px;" title="Delete" ng-click="vm.openDeleteModal(notice)"></i></td></tr></tbody></table><div class="row text-center" ng-if="vm.noticeList.length == 0"><b>No Data Found</b></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span translate="">{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span translate="">{{ ::item.title}}</span> <b class="fa fa-angle-right" ui-sref-active="fa-angle-down" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><i class="{{ ::subitem.icon }}"></i><span>{{ subitem.title | translate }}</span> <b class="fa" ng-class="{\'fa-angle-down\': subitem.expanded, \'fa-angle-right\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link"><i class="{{ ::subSubitem.icon }}"></i><span translate="">{{ ::subSubitem.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}"><i class="{{ ::subSubitem.icon }}"></i><span translate="">{{::subSubitem.title }}</span></a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link"><i class="{{ ::subitem.icon }}"></i><span translate="">{{ ::subitem.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}"><i class="{{ ::subitem.icon }}"></i><span translate="">{{ ::subitem.title}}</span></a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title" translate="">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li ng-if="!parentPageTitle && activePageTitle!=\'Dashboard\'"><a href="" ui-sref="dashboard">{{\'DASHBOARD\'|translate}}</a></li><li ng-if="parentPageTitle && parentPageTitle!=\'\'"><a ui-sref="{{parentState}}">{{parentTitle |translate}}</a></li><li>{{ activePageTitle |translate }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<head><meta name="viewport" content="width=device-width, initial-scale=1.0"><style>\n        @media screen and (min-width: 0px) and (max-width: 720px) {\n            #employeeName {\n            display: none;\n            }\n        }\n    </style></head><div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a ui-sref="dashboard" class="al-logo clearfix"><span>{{projectName}}</span> Admin</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="user-profile-name" id="employeeName"><a ui-sref="profile({employeeId: {{loggedInUser.id}}})">{{loggedInUser.name}}</a></div><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><div class="al-user-profile-name"><img ng-src="../assets/img/theme/no-photo.png" ng-if="!loggedInUser.employeePicture.employeeFile || !loggedInUser.employeePicture.employeeFile.url"> <img ng-src="{{loggedInUser.employeePicture.employeeFile.url}}" ng-if="loggedInUser.employeePicture.employeeFile.url"></div></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a class="hideMedia" ui-sref="profile({employeeId: {{loggedInUser.id}}})"><i class="fa fa-user"></i>Profile</a></li><li><a ui-sref="logout" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></div><div class="questions-section" id="employeeName"><button ng-if="activeLanguage==\'en\'" class="btn btn-primary btn-xs disabled">English</button> <button ng-if="activeLanguage==\'bn\'" class="btn btn-default btn-xs" ng-click="changeToEnglish()">English</button></div><div class="questions-section" id="employeeName" style="margin-right:0px;"><button ng-if="activeLanguage==\'bn\'" class="btn btn-primary btn-xs disabled">Bangla</button> <button ng-if="activeLanguage==\'en\'" class="btn btn-default btn-xs" ng-click="changeToBangla()">Bangla</button></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">Active</span> <span class="handle"></span> <span class="handle handle-off">Off</span></div></div></label>');
$templateCache.put('app/pages/main/academics/class/class.html','<div class="row"><div class="col-md-6"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><h3 class="panel-title bottom">{{\'createClass\'|translate}}</h3><div class="row"><div class="col-md-6"><input class="form-control" type="text" ng-model="vm.name" placeholder="Class Name"></div><div class="col-md-6"><button class="btn btn-primary btn-block" ng-click="vm.createClass()">Create</button></div></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><h3 class="panel-title bottom">{{\'allClasses\'|translate}}</h3><table class="table table-bordered"><col width="10%"><col width="70%"><col width="20%"><thead><th>#</th><th class="text-center">{{\'name\'|translate}}</th><th class="text-center">{{\'actions\'|translate}}</th></thead><tbody><tr ng-repeat="class in vm.classList"><td>{{$index+1}}</td><td><div class="text-left" style="margin-bottom: 10px"><span editable-text="class.name" e-form="class.textBtnForm" onbeforesave="vm.saveClass(class,$data)">{{ class.name || \'empty\' }}</span></div></td><td class="text-center"><i class="ion-android-create tableIcons" ng-click="class.textBtnForm.$show()"></i> <i class="ion-trash-b tableIcons" ng-click="vm.openDeleteModal(class)"></i></td></tr></tbody></table></div></div></div></div><div class="col-md-6" include-with-scope="app/pages/main/academics/class/configure/configure.html"></div></div>');
$templateCache.put('app/pages/main/directives/project/projectDirective.html','<div ng-if="vm.isAdmin && vm.dataLoaded"><h4>Projects</h4><div isteven-multi-select="" input-model="vm.projectList" output-model="vm.selectedProjectList" button-label="name" item-label="id name" tick-property="ticked" output-properties="id" on-item-click="vm.getIds()" on-select-all="vm.getIds()" on-select-none="vm.clear()" on-reset="vm.clear()"></div></div>');
$templateCache.put('app/pages/main/academics/section/section.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll"><h3 class="panel-title bottom">Create Section</h3><div class="row bottom"><div class="col-md-12"><input class="form-control" type="text" ng-model="vm.name" placeholder="Section Name"></div></div><div class="row"><div class="col-md-8"></div><div class="col-md-4"><button class="btn btn-primary btn-block" ng-click="vm.createSection()">Create</button></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll"><h3 class="panel-title bottom">{{\'allSections\'|translate}}</h3><table class="table table-bordered"><col width="10%"><col width="70%"><col width="20%"><thead><th>#</th><th class="text-center">{{\'name\'|translate}}</th><th class="text-center">{{\'actions\'|translate}}</th></thead><tbody><tr ng-repeat="section in vm.sectionList"><td>{{$index+1}}</td><td><div class="text-left" style="margin-bottom: 10px"><span editable-text="section.name" e-form="section.textBtnForm" onbeforesave="vm.saveSection(section,$data)">{{ section.name || \'empty\' }}</span></div></td><td class="text-center"><i class="ion-android-create tableIcons" ng-click="section.textBtnForm.$show()"></i> <i class="ion-trash-b tableIcons" ng-click="vm.openDeleteModal(section)"></i></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/main/educationOffice/create/createEducationOffice.html','<div ba-panel="" ba-panel-title="{{\'addNewEducationOffice\'|translate}}" ba-panel-class="with-scroll"><form><div class="row"><div class="col-md-6"><div class="form-group"><label for="name">{{\'educationOfficeName\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.name" class="form-control" id="name" placeholder="Name"></div></div><div class="col-md-6"><div class="form-group"><label>Type<span class="text-danger">*</span></label><select class="form-control" ng-model="vm.selectedOfficeHierarchy" ng-options="officeHierarchy.name for officeHierarchy in vm.officeHierarchyList track by officeHierarchy.id"><option value="" disabled="" selected="">Select Type</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="address">{{\'address\'|translate}}<span class="text-danger">*</span></label> <textarea type="text" ng-model="vm.address" class="form-control" id="address" placeholder="Address"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="email">{{\'educationOfficeAdminEmail\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.email" class="form-control" id="email"></div></div><div class="col-md-6"><div class="form-group"><label for="password">{{\'educationOfficeAdminPassword\'|translate}}<span class="text-danger">*</span></label> <input type="password" ng-model="vm.password" class="form-control" id="password"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="districtDropDown">{{\'district\'|translate}}<span class="text-danger">*</span></label><select id="districtDropDown" class="form-control" ng-model="vm.selectedDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District</option></select></div></div><div class="col-md-6"><div class="form-group"><label for="subDistrictDropDown">{{\'subDistrict\'|translate}}<span class="text-danger">*</span></label><select id="subDistrictDropDown" class="form-control" ng-model="vm.selectedSubdistrict" ng-options="subDistrict for subDistrict in vm.subdistrictList track by subDistrict"><option value="" disabled="" selected="">Select Subdistrict</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="officeListDropDown">{{\'superiorEducationOffice\'|translate}}</label><select id="officeListDropDown" class="form-control" ng-model="vm.selectedParentOffice" ng-options="educationOffice.name for educationOffice in vm.educationOfficeList | filter:{district:vm.selectedDistrict} track by educationOffice.id"><option value="" disabled="" selected="">Select Education Office</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="phoneNo">{{\'contactNumber\'|translate}}</label> <input type="text" class="form-control" ng-model="vm.phoneNo" id="phoneNo" placeholder="Phone Number"></div></div><div class="col-md-6"><div class="form-group"><label for="website">{{\'website\'|translate}}</label> <input type="text" class="form-control" ng-model="vm.website" id="website" placeholder="Website"></div></div></div><div class="row"><div class="col-md-3"><button class="btn btn-primary btn-block" ng-click="vm.createEducationOffice()">{{\'create\'|translate}}</button></div></div></form></div>');
$templateCache.put('app/pages/main/educationOffice/edit/editEducationOffice.html','<div ba-panel="" ba-panel-title="{{\'editEducationOffice\'|translate}}" ba-panel-class="with-scroll"><form><div class="row"><div class="col-md-6"><div class="form-group"><label for="name">{{\'educationOfficeName\'|translate}}</label> <input type="text" ng-model="vm.educationOffice.name" class="form-control" id="name" placeholder="Name"></div></div><div class="col-md-6"><div class="form-group"><label translate="">Type</label><select ng-if="vm.isAdmin" class="form-control" ng-model="vm.selectedOfficeHierarchy" ng-options="officeHierarchy.name for officeHierarchy in vm.officeHierarchyList track by officeHierarchy.id"><option value="" disabled="" selected="">Select Type</option></select><input ng-if="!vm.isAdmin" type="text" class="form-control" ng-readonly="true" value="{{vm.educationOffice.officeHierarchyName}}"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="address">{{\'address\'|translate}}</label> <textarea type="text" ng-model="vm.educationOffice.address" class="form-control" id="address" placeholder="Address"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="email">{{\'educationOfficeAdminEmail\'|translate}}</label> <input type="text" ng-model="vm.educationOffice.email" class="form-control" id="email"></div></div><div class="col-md-6"><div class="form-group"><label for="password">{{\'educationOfficeAdminPassword\'|translate}}</label> <input type="password" ng-model="vm.educationOffice.password" class="form-control" id="password"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label translate="">{{\'district\'}}</label><select ng-if="vm.isAdmin" class="form-control" ng-model="vm.educationOffice.district" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District</option></select><input ng-if="!vm.isAdmin" type="text" class="form-control" ng-readonly="true" value="{{vm.educationOffice.district}}"></div></div><div class="col-md-6"><div class="form-group"><label translate="">{{\'subDistrict\'}}</label><select ng-if="vm.isAdmin" class="form-control" ng-model="vm.educationOffice.subDistrict" ng-options="subDistrict for subDistrict in vm.subdistrictList track by subDistrict"><option value="" disabled="" selected="">Select Subdistrict</option></select><input ng-if="!vm.isAdmin" type="text" class="form-control" ng-readonly="true" value="{{vm.educationOffice.subDistrict}}"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="officeListDropDown">{{\'superiorEducationOffice\'|translate}}</label><select ng-if="vm.isAdmin" id="officeListDropDown" class="form-control" ng-model="vm.selectedParentOffice" ng-options="educationOffice.name for educationOffice in vm.educationOfficeList track by educationOffice.id"><option value="" disabled="" selected="">Select Education Office</option></select><input ng-if="!vm.isAdmin" type="text" class="form-control" ng-readonly="true" value="{{vm.educationOffice.parentOfficeName == null ? \'None\' : vm.educationOffice.parentOfficeName}}"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="phoneNo">{{\'contactNumber\'|translate}}</label> <input type="text" class="form-control" ng-model="vm.educationOffice.phoneNo" id="phoneNo" placeholder="Phone Number"></div></div><div class="col-md-6"><div class="form-group"><label for="website">{{\'website\'|translate}}</label> <input type="text" class="form-control" ng-model="vm.educationOffice.website" id="website" placeholder="Website"></div></div></div><div class="row"><div class="col-md-3"><button class="btn btn-primary btn-block" ng-click="vm.updateEducationOffice()">{{\'update\'|translate}}</button></div></div></form></div>');
$templateCache.put('app/pages/main/holidays/holidayModals/createHoliday.modal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><label>Holiday Title</label><br><div class="row"><div class="col-md-6"><input type="text" class="form-control" ng-model="vm.modal.newEvent.description"></div></div><br><br><label>Date</label><br><div class="row"><div class="col-md-6"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd MMMM yyyy" ng-model="vm.modal.newEvent.startDate" is-open="vm.modal.newEvent.isOpenStart" close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openStart()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><br><br><p>Are you sure you want to create the holiday named {{vm.modal.newEvent.description}} ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.saveHoliday(vm.modal.newEvent)">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/holidays/holidayModals/deleteHoliday.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><br><br><p>Are you sure you want to delete the holiday named {{vm.holidayToDelete.description}} ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deleteHoliday(vm.holidayToDelete)">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/holidays/holidayModals/updateHoliday.modal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Update Holiday</span></div><div class="modal-body"><label>Holiday Title</label><br><div class="row"><div class="col-md-6"><input type="text" class="form-control" ng-model="vm.modal.eventToChange.description"></div></div><br><br><label>Date</label><br><div class="row"><div class="col-md-6"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd MMMM yyyy" ng-model="vm.modal.eventToChange.holidayDate" is-open="vm.modal.eventToChange.isOpenStart" close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openStart()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><br><br><p>Are you sure you want to edit the holiday named {{vm.modal.eventToChange.description}} ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateHoliday()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/leave/list/leaveList.html','<div ba-panel="" ba-panel-title="{{\'allLeaveList\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'btn btn-default btn-sm pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-right\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-down\'></i> </span>" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div class="row form-inline filter-div" ng-show="vm.showFilters"><div class="form-group col-md-12"><div class="col-md-4"><input class="form-control" type="text" placeholder="{{\'teachersName\'|translate}}" ng-model="vm.searchString"></div><div class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.getAllTeachers(vm.searchString)"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.leaveList.length > 0 && vm.dataLoaded == true"><thead><th>#</th><th>{{\'teachersName\'|translate}}</th><th>{{\'leaveDescription\'|translate}}</th><th>{{\'startDate\'|translate}}</th><th>{{\'endDate\'|translate}}</th><th>Action</th></thead><tbody><tr ng-repeat="leave in vm.leaveList"><td>{{$index + 1}}</td><td>{{leave.name}}</td><td>{{leave.description}}</td><td>{{leave.startDate | date:\'dd MMMM yyyy\'}}</td><td>{{leave.endDate | date:\'dd MMMM yyyy\'}}</td><td><button ng-click="vm.openDeleteModal(leave.id)" class="btn btn-sm btn-danger btn-block">Delete</button></td></tr></tbody></table><div class="row text-center" ng-if="vm.leaveList.length == 0"><b>No Data Found</b></div></div></div>');
$templateCache.put('app/pages/main/school/create/createSchool.html','<div ba-panel="" ba-panel-title="{{\'addNewSchool\'|translate}}" ba-panel-class="with-scroll"><form><div class="row"><div class="col-md-6"><div class="form-group"><label for="name">{{\'schoolName\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.name" class="form-control" id="name" placeholder="Name"></div></div><div class="col-md-3"><div class="form-group"><label for="eiin">EIIN</label> <input type="text" class="form-control" ng-model="vm.eiin" id="eiin" placeholder="EIIN"></div></div><div class="col-md-3"><div class="form-group"><label for="code">Code</label> <input type="text" class="form-control" ng-model="vm.code" id="code" placeholder="Code"></div></div></div><div class="row"><div class="form-group col-md-6" style="margin-bottom: 20px"><label for="type">Type</label><div id="type" isteven-multi-select="" input-model="vm.typeList" output-model="vm.selectedType" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="col-md-6"><div class="form-group"><label>Reseller</label><select class="form-control" ng-model="vm.selectedReseller" ng-options="reseller.name for reseller in vm.resellerList track by reseller.id"><option value="" disabled="" selected="">Select Reseller</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="address">{{\'address\'|translate}}</label> <textarea type="text" ng-model="vm.address" class="form-control" id="address" placeholder="Address"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="email">{{\'schoolAdminEmail\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.email" class="form-control" id="email"></div></div><div class="col-md-6"><div class="form-group"><label for="password">{{\'schoolAdminPassword\'|translate}}<span class="text-danger">*</span></label> <input type="password" ng-model="vm.password" class="form-control" id="password"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label translate="">{{\'district\'}}</label><select class="form-control" ng-model="vm.selectedDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District</option></select></div></div><div class="col-md-6"><div class="form-group"><label translate="">{{\'subDistrict\'}}</label><select class="form-control" ng-model="vm.selectedSubdistrict" ng-options="subDistrict for subDistrict in vm.subdistrictList track by subDistrict"><option value="" disabled="" selected="">Select Subdistrict</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label translate="">{{\'affiliatedEducationOffice\'}}</label><select class="form-control" ng-model="vm.selectedEducationOffice" ng-options="educationOffice.name for educationOffice in vm.educationOfficeList | filter:{district:vm.selectedDistrict} track by educationOffice.id"><option value="" disabled="" selected="">Select Education Office</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="phoneNo">{{\'contactNumber\'|translate}}</label> <input type="text" class="form-control" ng-model="vm.phoneNo" id="phoneNo" placeholder="Phone Number"></div></div><div class="col-md-6"><div class="form-group"><label for="website">{{\'website\'|translate}}</label> <input type="text" class="form-control" ng-model="vm.website" id="website" placeholder="Website"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="studentCount">{{\'totalStudents\'|translate}}</label> <input type="number" class="form-control" ng-model="vm.studentCount" id="studentCount" placeholder="Student Count"></div></div><div class="col-md-6"><div class="form-group"><label for="teacherCount">{{\'totalTeachers\'|translate}}</label> <input type="number" class="form-control" ng-model="vm.teacherCount" id="teacherCount" placeholder="Teacher Count"></div></div></div><div class="row"><div class="col-md-3"><button class="btn btn-primary btn-block" ng-click="vm.createSchool()">{{\'create\'|translate}}</button></div></div></form></div><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="0"><uib-tab heading="Batch Create" index="0"><div include-with-scope="app/pages/main/school/batchCreate/create/batchCreate.html"></div></uib-tab><uib-tab heading="History" index="1" select="vm.onSwitchToHistoryTab()"><div include-with-scope="app/pages/main/school/batchCreate/history/history.html"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/main/school/edit/editSchool.html','<div ba-panel="" ba-panel-title="{{\'editSchoolInfo\'|translate}}" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><i class="fa fa-cog fa-spin fa-4x fa-fw"></i></div><div ng-show="vm.dataLoaded == true"><div class="row"><div class="col-md-6"><div class="form-group"><label for="name">{{\'schoolName\'|translate}}</label> <input type="text" ng-model="vm.school.name" class="form-control" id="name" placeholder="Name"></div></div><div class="col-md-6"><div class="form-group"><label for="eiin">EIIN</label> <input type="text" class="form-control" ng-model="vm.school.eiin" id="eiin" placeholder="EIIN"></div></div></div><div class="row"><div class="form-group col-md-6" style="margin-bottom: 20px"><label for="type">Type</label><div id="type" isteven-multi-select="" input-model="vm.typeList" output-model="vm.selectedType" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="col-md-6"><div class="form-group"><label for="code">Code</label> <input type="text" class="form-control" ng-model="vm.school.code" id="code" placeholder="Code"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="address">{{\'address\'|translate}}</label> <textarea type="text" ng-model="vm.school.address" class="form-control" id="address" placeholder="Address"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="email">{{\'schoolAdminEmail\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.school.email" class="form-control" id="email" value="vm.school.email"></div></div><div class="col-md-6"><div class="form-group"><label for="password">{{\'schoolAdminPassword\'|translate}}<span class="text-danger">*</span></label> <input type="password" ng-model="vm.school.password" class="form-control" id="password" autocomplete="off"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label translate="">{{\'district\'}}</label><select class="form-control" ng-model="vm.school.district" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District</option></select></div></div><div class="col-md-6"><div class="form-group"><label translate="">{{\'subDistrict\'}}</label><select class="form-control" ng-model="vm.school.subDistrict" ng-options="subDistrict for subDistrict in vm.subdistrictList track by subDistrict"><option value="" disabled="" selected="">Select Subdistrict</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label translate="">{{\'affiliatedEducationOffice\'}}</label><select ng-if="vm.isAdmin" class="form-control" ng-model="vm.selectedEducationOffice" ng-options="educationOffice.name for educationOffice in vm.educationOfficeList track by educationOffice.id"><option value="" disabled="" selected="">Select Education Office</option></select><input ng-if="!vm.isAdmin" type="text" class="form-control" ng-readonly="true" value="{{vm.school.educationOfficeName == null ? \'None\' : vm.school.educationOfficeName}}"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="phoneNo">{{\'contactNumber\'|translate}}</label> <input type="text" class="form-control" ng-model="vm.school.phoneNo" id="phoneNo" placeholder="Phone Number"></div></div><div class="col-md-6"><div class="form-group"><label for="website">{{\'website\'|translate}}</label> <input type="text" class="form-control" ng-model="vm.school.website" id="website" placeholder="Website"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="studentCount">{{\'totalStudents\'|translate}}</label> <input type="number" class="form-control" ng-model="vm.school.studentCount" id="studentCount" placeholder="Student Count"></div></div><div class="col-md-6"><div class="form-group"><label for="teacherCount">{{\'totalTeachers\'|translate}}</label> <input type="number" class="form-control" ng-model="vm.school.teacherCount" id="teacherCount" placeholder="Teacher Count"></div></div></div><div class="row"><div class="col-md-3"><button class="btn btn-primary btn-block" ng-click="vm.editSchool()">{{\'update\'|translate}}</button></div></div></div></div>');
$templateCache.put('app/pages/main/teacher/batchCreate/batchCreateTeachers.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="0"><uib-tab heading="Batch Create" index="0"><div include-with-scope="app/pages/main/teacher/batchCreate/create/batchCreate.html"></div></uib-tab><uib-tab heading="History" index="1" select="vm.onSwitchToHistoryTab()"><div include-with-scope="app/pages/main/teacher/batchCreate/history/history.html"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/main/teacher/create/createTeacher.html','<div ba-panel="" ba-panel-title="{{\'teacherJoining\'|translate}}" ba-panel-class="with-scroll"><form><div class="row"><div class="col-md-2"><h5 class="text-greyed">{{\'teachersPicture\'|translate}}</h5><img class="img-rounded" ng-src="{{vm.photoDir}}" ng-click="vm.showTeacherPictureUploadModal()" style="width: 100%; cursor: pointer; margin-bottom: 10px;"> <a class="change-userpic" style="cursor: pointer;" ng-click="vm.showTeacherPictureUploadModal()" translate="">{{\'uploadTeacherImage\'}}</a></div><div class="col-md-5"><h5 class="text-greyed">{{\'teachersProvidedInformation\'|translate}}</h5><div class="form-group"><label for="name">{{\'teachersName\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.name" class="form-control" id="name"></div><div class="form-group"><label for="email">{{\'teachersEmail\'|translate}}</label> <input type="text" ng-model="vm.email" class="form-control" id="email"></div><div class="form-group"><label for="contact">{{\'contactNumber\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.contact" class="form-control" id="contact"></div><div class="form-group"><label for="presentAddress">{{\'presentAddress\'|translate}}</label> <input type="text" ng-model="vm.presentAddress" class="form-control" id="presentAddress"></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'presentSubDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPresentSubdistrict" ng-options="subdistrict for subdistrict in vm.subdistrictList track by subdistrict"><option value="" disabled="" selected="">Select Subdistrict...</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'presentDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPresentDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District...</option></select></div><div class="form-group"><label for="permanentAddress">{{\'permanentAddress\'|translate}}</label> <input type="text" ng-model="vm.permanentAddress" class="form-control" id="permanentAddress"></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'permanentSubDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPermanentSubdistrict" ng-options="subdistrict for subdistrict in vm.subdistrictList track by subdistrict"><option value="" disabled="" selected="">Select Subdistrict...</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'permanentDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPermanentDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District...</option></select></div></div><div class="col-md-5"><h5 class="text-greyed" translate="">{{\'qualificationsAndExperience\'}}</h5><div class="form-group"><label for="qualifications">{{\'teachersQualification\'|translate}}</label> <input type="text" ng-model="vm.qualifications" class="form-control" id="qualifications"></div><div class="form-group"><label for="experience">{{\'teachersExperience\'|translate}}</label> <input type="text" ng-model="vm.experience" class="form-control" id="experience"></div><h5 class="text-greyed" translate="">{{\'schoolProvidedInformation\'}}</h5><div class="form-group col-md-6" style="padding:0px;"><label for="dateOfJoining">{{\'dateOfJoining\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.dateOfJoining" class="form-control" id="dateOfJoining" uib-datepicker-popup="yyyy-MM-dd" is-open="dateOfJoining.opened" datepicker-options="dateOptions" ng-required="true" ng-click="dateOfJoining()"></div><div class="form-group col-md-6"><label>{{\'designation\'|translate}}</label><select class="form-control" ng-model="vm.selectedDesignation" ng-options="designation.name for designation in vm.designationList track by designation.id"><option value="" disabled="" selected="">Select Designation...</option></select></div><div class="form-group"><label for="mpoIndex">MPO Index</label> <input type="number" ng-model="vm.mpoIndex" class="form-control" id="mpoIndex"></div><div class="form-group"><label for="rfidNo">RFID</label> <input type="text" class="form-control" ng-model="vm.rfidNo" id="rfidNo"></div><div class="form-group"><label for="primaryText">{{\'deviceFirstDisplayText\'|translate}}<span class="text-danger">*</span></label> <input type="text" class="form-control" ng-model="vm.primaryText" id="primaryText"></div><div class="form-group"><label for="secondaryText">{{\'deviceSecondDisplayText\'|translate}}<span class="text-danger">*</span></label> <input type="text" class="form-control" ng-model="vm.secondaryText" id="secondaryText"></div></div></div><div class="row"><div class="col-md-3 col-xs-offset-2"><button class="btn btn-primary btn-block" ng-click="vm.createTeacher()">{{\'create\'|translate}}</button></div></div></form></div>');
$templateCache.put('app/pages/main/teacher/dailyAttendance/teacherDailyAttendance.html','<div ba-panel="" ba-panel-title="{{\'teachersDailyAttendance\' |translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'btn btn-default btn-sm pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-right\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-down\'></i> </span>" ba-panel-class="with-scroll"><a ng-href="{{vm.excelUrl}}" target="_self"><button class="btn btn-sm btn-primary" style="margin-bottom: 5px;">Excel Export</button></a><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div class="row form-inline filter-div" ng-show="vm.showFilters"><div class="form-group col-md-12"><div class="col-md-4"><label ng-if="vm.isEducationOfficeAdmin" for="teacherName">{{\'teachersName\'|translate}}</label> <input id="teacherName" class="form-control" type="text" placeholder="Name" ng-model="vm.teacherName"></div><div class="col-md-4"><label ng-if="vm.isEducationOfficeAdmin" for="filterDate">{{\'dateLabel\'|translate}}</label> <input type="text" ng-model="vm.filterDate" class="form-control" id="filterDate" uib-datepicker-popup="dd MMMM yyyy" is-open="filterDate.opened" datepicker-options="dateOptions" ng-click="filterDate()"></div><div ng-if="vm.isEducationOfficeAdmin" class="col-md-4"><label for="schoolList">{{\'SCHOOL\'|translate}}</label><div id="schoolList" isteven-multi-select="" input-model="vm.schoolListDropDown" output-model="vm.selectedSchoolList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="multiple"></div></div><div ng-if="!vm.isEducationOfficeAdmin" class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.filterAttendances()"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div><div ng-if="vm.isEducationOfficeAdmin" class="form-group col-md-12"><div class="col-md-4" ng-if="vm.userOfficeHierarchy > 1"><label for="clusterList">{{\'subordinateEducationOffice\'|translate}}</label><div id="clusterList" isteven-multi-select="" input-model="vm.subordinateClusters" output-model="vm.selectedSubordinateCluster" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.updateSchoolDropDownList()" on-clear="vm.updateSchoolDropDownList()" on-select-none="vm.updateSchoolDropDownList()" on-reset="vm.updateSchoolDropDownList()"></div></div></div></div><div class="row form-inline filter-div" ng-show="vm.showFilters"><div ng-if="vm.isEducationOfficeAdmin" class="form-group col-md-12"><div class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.filterAttendances()"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.teacherList.length > 0 && vm.dataLoaded == true"><thead><th colspan="4" translate="">{{\'teachersInformation\'}}</th><th colspan="3" class="text-center">{{vm.filterDate | date: "dd MMMM yyyy (EEE)"}}</th></thead><thead><th>#</th><th class="text-left" translate="">{{\'name\'}}</th><th class="text-left" translate="">{{\'schoolName\'}}</th><th class="text-left" translate="">{{\'contactNumber\'}}</th><th class="text-center text-success" translate="">{{\'entryTime\'}}</th><th class="text-center text-danger" translate="">{{\'exitTime\'}}</th><th class="text-center" translate="">{{\'totalHours\'}}</th></thead><tbody><tr ng-repeat="teacher in vm.teacherList"><td>{{$index+1}}</td><td>{{teacher.personName}}</td><td>{{ teacher.schoolName }}</td><td>{{teacher.phoneNo}}</td><td class="text-center">{{teacher.attendance[0].firstLoggedTime}}</td><td class="text-center">{{teacher.attendance[0].lastLoggedTime}}</td><td class="text-center">{{teacher.attendance[0].totalHour}}</td></tr></tbody></table><div class="row text-center" ng-if="vm.teacherList.length == 0"><b>No Data Found</b></div></div></div>');
$templateCache.put('app/pages/main/teacher/edit/editTeacher.html','<div ba-panel="" ba-panel-title="{{\'editTeacherInfo\'|translate}}" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div ng-show="vm.dataLoaded == true"><div class="row"><div class="col-md-2"><h5 class="text-greyed">{{\'teachersPicture\'|translate}}</h5><img class="img-rounded" ng-src="{{vm.teacher.photoDir}}" ng-click="vm.showTeacherPictureUploadModal()" style="width: 100%; cursor: pointer; margin-bottom: 10px;"> <a class="change-userpic" style="cursor: pointer;" ng-click="vm.showTeacherPictureUploadModal()" translate="">{{\'uploadTeacherImage\'}}</a></div><div class="col-md-5"><h5 class="text-greyed">{{\'teachersProvidedInformation\'|translate}}</h5><div class="form-group"><label for="name">{{\'teachersName\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.teacher.name" class="form-control" id="name"></div><div class="form-group"><label for="email">{{\'teachersEmail\'|translate}}</label> <input type="text" ng-model="vm.teacher.email" class="form-control" id="email"></div><div class="form-group"><label for="contact">{{\'contactNumber\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.teacher.phoneNo" class="form-control" id="contact"></div><div class="form-group"><label for="presentAddress">{{\'presentAddress\'|translate}}</label> <input type="text" ng-model="vm.teacher.presentAddress1" class="form-control" id="presentAddress"></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'presentSubDistrict\'}}</label><select class="form-control" ng-model="vm.teacher.presentSubDistrict" ng-options="subdistrict for subdistrict in vm.subdistrictList track by subdistrict"><option value="" disabled="" selected="">Select District...</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'presentDistrict\'}}</label><select class="form-control" ng-model="vm.teacher.presentDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District...</option></select></div><div class="form-group"><label for="permanentAddress">{{\'permanentAddress\'|translate}}</label> <input type="text" ng-model="vm.teacher.permanentAddress1" class="form-control" id="permanentAddress"></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'permanentSubDistrict\'}}</label><select class="form-control" ng-model="vm.teacher.permanentSubDistrict" ng-options="subdistrict for subdistrict in vm.subdistrictList track by subdistrict"><option value="" disabled="" selected="">Select Subdistrict...</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'permanentDistrict\'}}</label><select class="form-control" ng-model="vm.teacher.permanentDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District...</option></select></div></div><div class="col-md-5"><h5 class="text-greyed" translate="">{{\'qualificationsAndExperience\'}}</h5><div class="form-group"><label for="qualifications">{{\'teachersQualification\'|translate}}</label> <input type="text" ng-model="vm.teacher.qualifications" class="form-control" id="qualifications"></div><div class="form-group"><label for="experience">{{\'teachersExperience\'|translate}}</label> <input type="text" ng-model="vm.teacher.experience" class="form-control" id="experience"></div><h5 class="text-greyed" translate="">{{\'schoolProvidedInformation\'}}</h5><div class="form-group col-md-6" style="padding:0px;"><label for="dateOfJoining">{{\'dateOfJoining\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.teacher.dateOfJoining" class="form-control" id="dateOfJoining" uib-datepicker-popup="yyyy-MM-dd" is-open="dateOfJoining.opened" datepicker-options="dateOptions" ng-required="true" ng-click="dateOfJoining()"></div><div class="form-group col-md-6"><label>{{\'designation\'|translate}}<span class="text-danger">*</span></label><select class="form-control" ng-model="vm.teacher.designation" ng-options="designation.name for designation in vm.designationList track by designation.id"><option value="" disabled="" selected="">Select Designation...</option></select></div><div class="form-group"><label for="mpoIndex">MPO Index</label> <input type="number" ng-model="vm.teacher.mpoIndex" class="form-control" id="mpoIndex"></div><div class="form-group"><label for="rfid">RFID</label> <input type="text" class="form-control" ng-model="vm.teacher.rfid" id="rfid"></div><div class="form-group"><label for="primaryText">{{\'deviceFirstDisplayText\'|translate}}<span class="text-danger">*</span></label> <input type="text" class="form-control" ng-model="vm.teacher.primaryDisplayText" id="primaryText"></div><div class="form-group"><label for="secondaryText">{{\'deviceSecondDisplayText\'|translate}}<span class="text-danger">*</span></label> <input type="text" class="form-control" ng-model="vm.teacher.secondaryDisplayText" id="secondaryText"></div></div></div><div class="row"><div class="col-md-3 col-xs-offset-2"><button class="btn btn-primary btn-block" ng-click="vm.editTeacher()">{{\'update\'|translate}}</button></div></div></div></div>');
$templateCache.put('app/pages/main/teacher/list/teacherList.html','<div ba-panel="" ba-panel-title="{{\'allTeachersList\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'btn btn-default btn-sm pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-right\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-down\'></i> </span>" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div class="row form-inline filter-div" ng-show="vm.showFilters"><div class="form-group col-md-12"><div class="col-md-4"><label ng-if="vm.userOfficeHierarchy > 1" for="teacherName">{{\'teachersName\'|translate}}</label> <input id="teacherName" class="form-control" type="text" placeholder="{{\'teachersName\'|translate}}" ng-model="vm.searchString"></div><div class="col-md-4" ng-if="vm.isEducationOfficeAdmin"><label ng-if="vm.userOfficeHierarchy > 1" for="schoolList">{{\'SCHOOL\'|translate}}</label><div id="schoolList" isteven-multi-select="" input-model="vm.schoolListDropDown" output-model="vm.selectedSchoolList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="multiple"></div></div><div class="col-md-4" ng-if="vm.isEducationOfficeAdmin && vm.userOfficeHierarchy > 1"><label for="clusterList">{{\'subordinateEducationOffice\'|translate}}</label><div id="clusterList" isteven-multi-select="" input-model="vm.subordinateClusters" output-model="vm.selectedSubordinateCluster" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.updateSchoolDropDownList()" on-clear="vm.updateSchoolDropDownList()" on-select-none="vm.updateSchoolDropDownList()" on-reset="vm.updateSchoolDropDownList()"></div></div><div ng-if="vm.userOfficeHierarchy < 2" class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.applyFilterAndFetchTeacherList()"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div><div ng-if="vm.userOfficeHierarchy > 1" class="form-group col-md-12"><div class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.applyFilterAndFetchTeacherList()"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.teacherList.length > 0 && vm.dataLoaded == true"><thead><th>#</th><th class="text-center">{{\'picture\'|translate}}</th><th>{{\'teachersName\'|translate}}</th><th>{{\'designation\'|translate}}</th><th ng-if="vm.isEducationOfficeAdmin">{{\'schoolName\'|translate}}</th><th>{{\'contactNumber\'|translate}}</th><th>{{\'deviceFirstDisplayText\'|translate}}</th><th>{{\'deviceSecondDisplayText\'|translate}}</th><th>{{\'status\'|translate}}</th><th ng-if="!vm.isEducationOfficeAdmin">Action</th></thead><tbody><tr ng-repeat="teacher in vm.teacherList"><td>{{$index + 1}}</td><td class="text-center"><img ng-if="teacher.photoDir!=null && teacher.photoDir!=\'\'" class="img-circle" style="width: 40px; height: 40px; margin: 3px;" src="{{teacher.photoDir}}"> <img ng-if="teacher.photoDir==null || teacher.photoDir==\'\'" class="img-circle" style="width: 40px; height: 40px; margin: 3px;" src="{{vm.defaultImg}}"></td><td ng-if="!vm.isEducationOfficeAdmin"><a ui-sref="teacher.editTeacher({teacherId:teacher.id})">{{teacher.name}}</a></td><td ng-if="vm.isEducationOfficeAdmin">{{teacher.name}}</td><td>{{teacher.designation.name}}</td><td ng-if="vm.isEducationOfficeAdmin">{{teacher.schoolName}}</td><td>{{teacher.phoneNo}}</td><td>{{teacher.primaryDisplayText}}</td><td>{{teacher.secondaryDisplayText}}</td><td>{{teacher.status==1? \'Active\':\'Inactive\'}}</td><td ng-if="!vm.isEducationOfficeAdmin"><button ng-click="vm.openDeleteModal(teacher)" class="btn btn-sm btn-danger btn-block">Delete</button></td></tr></tbody></table><div class="row text-center" ng-if="vm.teacherList.length == 0"><b>No Data Found</b></div></div></div>');
$templateCache.put('app/pages/main/teacher/monthlyAttendance/teacherMonthlyAttendance.html','<div ba-panel="" ba-panel-title="{{\'teachersMonthlyAttendance\' |translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'btn btn-default btn-sm pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-right\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-down\'></i> </span>" ba-panel-class="with-scroll"><a ng-href="{{vm.excelUrl}}" target="_self"><button class="btn btn-sm btn-primary" style="margin-bottom: 5px;">Excel Export</button></a><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div class="row form-inline filter-div" ng-show="vm.showFilters"><div class="form-group col-md-12"><div class="col-md-4"><label ng-if="vm.isEducationOfficeAdmin" for="teacherName">{{\'teachersName\'|translate}}</label> <input id="teacherName" class="form-control" type="text" placeholder="{{\'teachersName\'|translate}}" ng-model="vm.teacherName"></div><div class="col-md-4"><label ng-if="vm.isEducationOfficeAdmin" for="filterYearMonth">{{\'monthName\'|translate}}</label> <input type="text" ng-model="vm.filterYearMonth" class="form-control" id="filterYearMonth" uib-datepicker-popup="MMMM yyyy" is-open="filterYearMonth.opened" datepicker-options="{ minMode: \'month\' }" show-button-bar="false" ng-click="filterYearMonth()"></div><div ng-if="vm.isEducationOfficeAdmin" class="col-md-4"><label for="schoolList">{{\'SCHOOL\'|translate}}</label><div id="schoolList" isteven-multi-select="" input-model="vm.schoolListDropDown" output-model="vm.selectedSchoolList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="multiple"></div></div><div ng-if="!vm.isEducationOfficeAdmin" class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.filterAttendances()"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div><div ng-if="vm.isEducationOfficeAdmin" class="form-group col-md-12"><div class="col-md-4" ng-if="vm.userOfficeHierarchy > 1"><label for="clusterList">{{\'subordinateEducationOffice\'|translate}}</label><div id="clusterList" isteven-multi-select="" input-model="vm.subordinateClusters" output-model="vm.selectedSubordinateCluster" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.updateSchoolDropDownList()" on-clear="vm.updateSchoolDropDownList()" on-select-none="vm.updateSchoolDropDownList()" on-reset="vm.updateSchoolDropDownList()"></div></div></div></div><div ng-if="vm.isEducationOfficeAdmin" class="row form-inline filter-div" ng-show="vm.showFilters"><div class="form-group col-md-12"><div class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.filterAttendances()"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.teacherList.length > 0 && vm.dataLoaded == true"><thead><th colspan="4" translate="">{{\'teachersInformation\'}}</th><th colspan="{{vm.monthlyDates.length}}" class="text-center">{{vm.filterFrom | date: "MMMM yyyy"}}</th><th colspan="3" class="text-center" translate="">{{\'summary\'}}</th></thead><thead><th>#</th><th class="text-left" translate="">{{\'name\'}}</th><th class="text-left" translate="">{{\'schoolName\'}}</th><th class="text-left" translate="">{{\'contactNumber\'}}</th><th class="text-center" ng-repeat="d in vm.monthlyDates.slice().reverse()">{{d.split(".")[0] }}</th><th class="text-center text-success" translate="">{{\'present\'}}</th><th class="text-center text-warning" translate="">{{\'late\'}}</th><th class="text-center text-danger" translate="">{{\'absent\'}}</th></thead><tbody><tr ng-repeat="teacher in vm.teacherList"><td>{{$index+1}}</td><td>{{teacher.personName}}</td><td>{{ teacher.schoolName }}</td><td>{{teacher.phoneNo}}</td><td class="text-center" ng-repeat="i in getMissingDate(teacher.attendance.length, vm.monthlyDates.length) track by $index"></td><td class="text-center" ng-repeat="d in teacher.attendance.slice().reverse()"><span ng-if="d.isOffday" class="text-greyed">FRI</span> <span ng-if="!d.isOffday && d.isHoliday" class="text-greyed">HOL</span> <span ng-if="!d.isOffday && !d.isHoliday && d.isLeave" class="text-greyed">LV</span> <span ng-if="!d.isOffday && !d.isHoliday && !d.isLeave && !d.isPresent" class="text-danger">A</span> <span ng-if="d.isPresent && d.isLate" class="text-warning">L</span> <span ng-if="d.isPresent && !d.isLate" class="text-success">P</span></td><td class="text-center">{{teacher[\'summary\'][\'totalPresent\']}}</td><td class="text-center">{{teacher[\'summary\'][\'totalLateEntry\']}}</td><td class="text-center">{{teacher[\'summary\'][\'totalAbsent\']}}</td></tr></tbody></table><div class="row text-center" ng-if="vm.teacherList.length == 0"><b>No Data Found</b></div></div></div>');
$templateCache.put('app/pages/main/student/create/createStudent.html','<div ba-panel="" ba-panel-title="{{\'studentAdmission\'|translate}}" ba-panel-class="with-scroll"><form><div class="row"><div class="col-md-2"><h5 class="text-greyed">{{\'studentsPicture\'|translate}}</h5><img class="img-thumbnail" style="width: 100%; margin-bottom:10px" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9InllcyI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTQwIiBoZWlnaHQ9IjE0MCIgdmlld0JveD0iMCAwIDE0MCAxNDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPjwhLS0KU291cmNlIFVSTDogaG9sZGVyLmpzLzE0MHgxNDAKQ3JlYXRlZCB3aXRoIEhvbGRlci5qcyAyLjYuMC4KTGVhcm4gbW9yZSBhdCBodHRwOi8vaG9sZGVyanMuY29tCihjKSAyMDEyLTIwMTUgSXZhbiBNYWxvcGluc2t5IC0gaHR0cDovL2ltc2t5LmNvCi0tPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PCFbQ0RBVEFbI2hvbGRlcl8xNjhkYzdkNTlkMyB0ZXh0IHsgZmlsbDojQUFBQUFBO2ZvbnQtd2VpZ2h0OmJvbGQ7Zm9udC1mYW1pbHk6QXJpYWwsIEhlbHZldGljYSwgT3BlbiBTYW5zLCBzYW5zLXNlcmlmLCBtb25vc3BhY2U7Zm9udC1zaXplOjEwcHQgfSBdXT48L3N0eWxlPjwvZGVmcz48ZyBpZD0iaG9sZGVyXzE2OGRjN2Q1OWQzIj48cmVjdCB3aWR0aD0iMTQwIiBoZWlnaHQ9IjE0MCIgZmlsbD0iI0VFRUVFRSIvPjxnPjx0ZXh0IHg9IjQ0LjA0MTY2NjAzMDg4Mzc5IiB5PSI3NC41NTk5OTk5NDI3Nzk1NCI+MTQweDE0MDwvdGV4dD48L2c+PC9nPjwvc3ZnPg=="> <a href="" class="change-userpic" ng-click="vm.showProfileImageUploadModal()" translate="">{{\'uploadStudentImage\'}}</a></div><div class="col-md-5"><h5 class="text-greyed">{{\'studentProvidedInformation\'|translate}}</h5><div class="form-group"><label for="name">{{\'studentsName\'|translate}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.name" class="form-control" id="name"></div><div class="form-group col-md-4" style="padding:0px;"><label>{{\'gender\'|translate}}<span class="text-danger">*</span></label><select class="form-control" ng-model="vm.selectedGender" ng-options="gender for gender in vm.genderList track by gender"><option value="" disabled="" selected="">Select Gender</option></select></div><div class="form-group col-md-4" style="padding:0px;"><label>{{\'religion\'|translate}}<span class="text-danger">*</span></label><select class="form-control" ng-model="vm.selectedReligion" ng-options="religion for religion in vm.religionList track by religion"><option value="" disabled="" selected="">Select Religion</option></select></div><div class="form-group col-md-4" style="padding:0px;"><label translate="">{{\'bloodGroup\'}}</label><select class="form-control" ng-model="vm.selectedBloodGroup" ng-options="bloodGroup for bloodGroup in vm.bloodGroupList track by bloodGroup"><option value="" disabled="" selected="">Select Blood Group</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label for="dateOfBirth" translate="">{{\'dateOfBirth\'}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.dateOfBirth" class="form-control" id="dateOfBirth" uib-datepicker-popup="dd MMMM yyyy" is-open="dateOfBirth.opened" datepicker-options="dateOptions" ng-required="true" ng-click="dateOfBirth()"></div><div class="form-group col-md-6" style="padding:0px;"><label for="birthCertNo" translate="">{{\'birthCertificate\'}}</label> <input type="text" ng-model="vm.birthCertNo" class="form-control" id="birthCertNo"></div><div class="form-group"><label for="fatherName" translate="">{{\'fathersName\'}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.fatherName" class="form-control" id="fatherName"></div><div class="form-group"><label for="motherName" translate="">{{\'mothersName\'}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.motherName" class="form-control" id="motherName"></div><div class="form-group"><label for="guardianName" translate="">{{\'guardiansName\'}}</label> <input type="text" ng-model="vm.guardianName" class="form-control" id="guardianName"></div><div class="form-group"><label for="emergencyContact" translate="">{{\'contactNumber\'}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.emergencyContact" class="form-control" id="emergencyContact"></div><div class="form-group"><label for="presentAddress" translate="">{{\'presentAddress\'}}</label> <input type="text" ng-model="vm.presentAddress" class="form-control" id="presentAddress"></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'presentSubDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPresentSubdistrict" ng-options="subdistrict for subdistrict in vm.subdistrictList track by subdistrict"><option value="" disabled="" selected="">Select Subdistrict</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'presentDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPresentDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District</option></select></div><div class="form-group"><label for="permanentAddress" translate="">{{\'permanentAddress\'}}</label> <input type="text" ng-model="vm.permanentAddress" class="form-control" id="permanentAddress"></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'permanentSubDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPermanentSubdistrict" ng-options="subdistrict for subdistrict in vm.subdistrictList track by subdistrict"><option value="" disabled="" selected="">Select Subdistrict</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'permanentDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPermanentDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District</option></select></div></div><div class="col-md-5"><h5 class="text-greyed" translate="">{{\'schoolProvidedInformation\'}}</h5><div class="form-group"><label translate="">{{\'classAllocation\'}}<span class="text-danger">*</span></label><select class="form-control" ng-model="vm.selectedAssoc" ng-options="assoc.name for assoc in vm.assocList track by assoc.id"><option value="" disabled="" selected="">Select Class</option></select></div><div class="form-group"><label for="assocYear" translate="">{{\'year\'}}<span class="text-danger">*</span></label> <input type="text" class="form-control" ng-model="vm.assocYear" id="assocYear"></div><div class="form-group"><label for="rollNo" translate="">{{\'rollNumber\'}}<span class="text-danger">*</span></label> <input type="text" class="form-control" ng-model="vm.rollNo" id="rollNo"></div><div class="form-group"><label for="rfidNo" translate="">{{\'rfid\'}}</label> <input type="text" class="form-control" ng-model="vm.rfidNo" id="rfidNo"></div><div class="form-group"><label for="primaryText">Primary display text</label> <input type="text" class="form-control" ng-model="vm.primaryText" id="primaryText"></div><div class="form-group"><label for="secondaryText">Secondary display text</label> <input type="text" class="form-control" ng-model="vm.secondaryText" id="secondaryText"></div></div></div><div class="row"><div class="col-md-3 col-xs-offset-2"><button class="btn btn-primary btn-block" ng-click="vm.createStudent()">Create</button></div></div></form></div>');
$templateCache.put('app/pages/main/student/dailyAttendance/studentDailyAttendance.html','<div ba-panel="" ba-panel-title="{{\'studentDailyAttendance\' |translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'btn btn-default btn-sm pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-right\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-down\'></i> </span>" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div class="row form-inline filter-div" ng-show="vm.showFilters"><div class="form-group col-md-12"><div class="col-md-4"><select class="form-control" ng-model="vm.selectedClass" ng-options="class.name for class in vm.classList track by class.id"><option value="" disabled="" selected="">Select Class</option></select></div><div class="col-md-4"><select class="form-control" ng-model="vm.selectedSection" ng-options="section.name for section in vm.sectionList track by section.id"><option value="" disabled="" selected="">Select Section</option></select></div><div class="col-md-4"><select class="form-control" ng-model="vm.selectedShift" ng-options="shift.name for shift in vm.shiftList track by shift.id"><option value="" disabled="" selected="">Select Shift</option></select></div></div><div class="form-group col-md-12"><div class="col-md-4"><input class="form-control" type="text" placeholder="Student Name" ng-model="vm.studentName"></div><div class="col-md-4"><input type="text" ng-model="vm.filterDate" class="form-control" id="filterDate" uib-datepicker-popup="dd MMMM yyyy" is-open="filterDate.opened" datepicker-options="dateOptions" ng-required="true" ng-click="filterDate()"></div><div class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.filterAttendances()"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.studentList.length > 0 && vm.dataLoaded == true"><thead><th colspan="6" translate="">{{\'studentsInformation\'}}</th><th colspan="3" class="text-center">{{vm.filterDate | date: "dd MMMM yyyy (EEE)"}}</th></thead><thead><th>#</th><th translate="">{{\'studentsName\'}}</th><th translate="">{{\'rollNumber\'}}</th><th translate="">{{\'class\'}}</th><th translate="">{{\'section\'}}</th><th translate="">{{\'shift\'}}</th><th class="text-center text-success" translate="">{{\'entryTime\'}}</th><th class="text-center text-danger" translate="">{{\'exitTime\'}}</th><th class="text-center" translate="">{{\'totalHours\'}}</th></thead><tbody><tr ng-repeat="student in vm.studentList"><td>{{$index+1}}</td><td>{{student.personName}}</td><td>{{student.rollNo}}</td><td>{{student.className}}</td><td>{{student.sectionName}}</td><td>{{student.shiftName}}</td><td class="text-center">{{student[\'attendance\'][0][\'firstLoggedTime\']}}</td><td class="text-center">{{student[\'attendance\'][0][\'lastLoggedTime\']}}</td><td class="text-center">{{student[\'attendance\'][0][\'totalHour\']}}</td></tr></tbody></table><div class="row text-center" ng-if="vm.studentList.length == 0"><b>No Data Found</b></div></div></div>');
$templateCache.put('app/pages/main/leave/apply/applyLeave.html','<div ba-panel="" ba-panel-title="{{\'addTeachersLeave\'|translate}}" ba-panel-class="with-scroll"><div class="row"><div class="form-group col-sm-6 col-xs-6 col-md-6"><label class="filter-label">{{\'date\'|translate}}</label> <input date-range-picker="" class="form-control date-picker" type="text" ng-model="vm.datePicker.date" options="vm.datePicker.options" style="width: 100%; font-size: 12px; height: 34px; text-align: center;"></div><div class="form-group col-md-6" style="padding:0px;"><label>{{\'selectTeacher\'|translate}}</label><select class="form-control" ng-model="vm.teacher.selectedTeacher" ng-options="teacher.name for teacher in vm.teacherList track by teacher.id"><option value="" disabled="" selected="">{{\'selectTeacher\'|translate}}...</option></select></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="description">{{\'description\'|translate}}</label> <textarea type="text" ng-model="vm.description" class="form-control" id="description"></textarea></div></div></div><div class="row"><div class="col-md-3"><button class="btn btn-primary btn-block" ng-click="vm.applyForLeave()">{{\'addLeave\'|translate}}</button></div></div></div>');
$templateCache.put('app/pages/main/student/edit/editStudent.html','<div ba-panel="" ba-panel-title="{{\'studentsInformation\'|translate}}" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div ng-show="vm.dataLoaded == true"><div class="row"><div class="col-md-2"><h5 class="text-greyed" translate="">{{\'studentsPicture\'}}</h5><img class="img-rounded" ng-src="{{vm.student.photoDir}}" ng-click="vm.showStudentPictureUploadModal()" style="width: 100%; cursor: pointer;"> <a class="change-userpic" ng-click="vm.showStudentPictureUploadModal()">Upload Student Picture</a></div><div class="col-md-5"><h5 class="text-greyed" translate="">{{\'studentProvidedInformation\'}}</h5><div class="form-group"><label for="name" translate="">{{\'studentsName\'}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.student.name" class="form-control" id="name"></div><div class="form-group col-md-4" style="padding:0px;"><label translate="">{{\'gender\'}}<span class="text-danger">*</span></label><select class="form-control" ng-model="vm.selectedGender" ng-options="gender for gender in vm.genderList track by gender"><option value="" disabled="" selected="">Select Gender</option></select></div><div class="form-group col-md-4" style="padding:0px;"><label translate="">{{\'religion\'}}<span class="text-danger">*</span></label><select class="form-control" ng-model="vm.selectedReligion" ng-options="religion for religion in vm.religionList track by religion"><option value="" disabled="" selected="">Select Religion</option></select></div><div class="form-group col-md-4" style="padding:0px;"><label translate="">{{\'bloodGroup\'}}</label><select class="form-control" ng-model="vm.selectedBloodGroup" ng-options="bloodGroup for bloodGroup in vm.bloodGroupList track by bloodGroup"><option value="" disabled="" selected="">Select Blood Group</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label for="dateOfBirth" translate="">{{\'dateOfBirth\'}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.student.dateOfBirth" class="form-control" id="dateOfBirth" uib-datepicker-popup="yyyy-MM-dd" is-open="dateOfBirth.opened" datepicker-options="dateOptions" ng-required="true" ng-click="dateOfBirth()"></div><div class="form-group col-md-6" style="padding:0px;"><label for="birthCertNo" translate="">{{\'birthCertificate\'}}</label> <input type="text" ng-model="vm.student.birthCertNo" class="form-control" id="birthCertNo"></div><div class="form-group"><label for="fatherName" translate="">{{\'fathersName\'}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.student.fatherName" class="form-control" id="fatherName"></div><div class="form-group"><label for="motherName" translate="">{{\'mothersName\'}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.student.motherName" class="form-control" id="motherName"></div><div class="form-group"><label for="guardianName" translate="">{{\'guardiansName\'}}</label> <input type="text" ng-model="vm.student.guardianName" class="form-control" id="guardianName"></div><div class="form-group"><label for="emergencyContact" translate="">{{\'contactNumber\'}}<span class="text-danger">*</span></label> <input type="text" ng-model="vm.student.emergencyContact" class="form-control" id="emergencyContact"></div><div class="form-group"><label for="presentAddress1" translate="">{{\'presentAddress\'}}</label> <input type="text" ng-model="vm.student.presentAddress1" class="form-control" id="presentAddress1"></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'presentSubDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPresentSubdistrict" ng-options="subdistrict for subdistrict in vm.subdistrictList track by subdistrict"><option value="" disabled="" selected="">Select Subdistrict</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'presentDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPresentDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District</option></select></div><div class="form-group"><label for="permanentAddress1" translate="">{{\'permanentAddress\'}}</label> <input type="text" ng-model="vm.student.permanentAddress1" class="form-control" id="permanentAddress1"></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'permanentSubDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPermanentSubdistrict" ng-options="subdistrict for subdistrict in vm.subdistrictList track by subdistrict"><option value="" disabled="" selected="">Select Subdistrict</option></select></div><div class="form-group col-md-6" style="padding:0px;"><label translate="">{{\'permanentDistrict\'}}</label><select class="form-control" ng-model="vm.selectedPermanentDistrict" ng-options="district for district in vm.districtList track by district"><option value="" disabled="" selected="">Select District</option></select></div></div><div class="col-md-5"><h5 class="text-greyed" translate="">{{\'schoolProvidedInformation\'}}</h5><div class="form-group"><label translate="">{{\'classAllocation\'}}<span class="text-danger">*</span></label><select class="form-control" ng-model="vm.selectedAssoc" ng-options="assoc.name for assoc in vm.assocList track by assoc.id"><option value="" disabled="" selected="">Select Class</option></select></div><div class="form-group"><label for="assocYear" translate="">{{\'year\'}}<span class="text-danger">*</span></label> <input type="text" class="form-control" ng-model="vm.student.assocYear" id="assocYear"></div><div class="form-group"><label for="rollNo" translate="">{{\'rollNumber\'}}<span class="text-danger">*</span></label> <input type="text" class="form-control" ng-model="vm.student.rollNo" id="rollNo"></div><div class="form-group"><label for="rfidNo">RFID</label> <input type="text" class="form-control" ng-model="vm.student.rfidNo" id="rfidNo"></div><div class="form-group"><label for="primaryText">Primary display text</label> <input type="text" class="form-control" ng-model="vm.student.primaryText" id="primaryText"></div><div class="form-group"><label for="secondaryText">Secondary display text</label> <input type="text" class="form-control" ng-model="vm.student.secondaryText" id="secondaryText"></div></div></div><div class="row"><div class="col-md-3 col-xs-offset-2"><button class="btn btn-primary btn-block" ng-click="vm.editStudent()">Update</button></div></div></div></div>');
$templateCache.put('app/pages/main/student/list/studentList.html','<div ba-panel="" ba-panel-title="{{\'allStudents\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'btn btn-default btn-sm pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-right\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-down\'></i> </span>" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div class="row form-inline filter-div" ng-show="vm.showFilters"><div class="form-group col-md-12"><div class="col-md-4"><select class="form-control" ng-model="vm.selectedClass" ng-options="class.name for class in vm.classList track by class.id"><option value="" disabled="" selected="">Select Class</option></select></div><div class="col-md-4"><select class="form-control" ng-model="vm.selectedSection" ng-options="section.name for section in vm.sectionList track by section.id"><option value="" disabled="" selected="">Select Section</option></select></div><div class="col-md-4"><select class="form-control" ng-model="vm.selectedShift" ng-options="shift.name for shift in vm.shiftList track by shift.id"><option value="" disabled="" selected="">Select Shift</option></select></div></div><div class="form-group col-md-12"><div class="col-md-4"><input class="form-control" type="text" placeholder="Student Name" ng-model="vm.searchString"></div><div class="col-md-4"><input class="form-control" type="text" placeholder="Roll" ng-model="vm.searchString"></div><div class="col-md-4"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.getPersonByProjectIdPageAndSize(vm.page,vm.size)"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.studentList.length > 0 && vm.dataLoaded == true"><thead><th>#</th><th class="text-center" translate="">{{\'picture\'}}</th><th translate="">{{\'studentsName\'}}</th><th translate="">{{\'rollNumber\'}}</th><th translate="">{{\'class\'}}</th><th translate="">{{\'section\'}}</th><th translate="">{{\'shift\'}}</th></thead><tbody><tr ng-repeat="student in vm.studentList"><td>{{$index+1}}</td><td class="text-center"><img class="img-circle" style="width: 40px; height: 40px; margin: 3px;" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9InllcyI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTQwIiBoZWlnaHQ9IjE0MCIgdmlld0JveD0iMCAwIDE0MCAxNDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPjwhLS0KU291cmNlIFVSTDogaG9sZGVyLmpzLzE0MHgxNDAKQ3JlYXRlZCB3aXRoIEhvbGRlci5qcyAyLjYuMC4KTGVhcm4gbW9yZSBhdCBodHRwOi8vaG9sZGVyanMuY29tCihjKSAyMDEyLTIwMTUgSXZhbiBNYWxvcGluc2t5IC0gaHR0cDovL2ltc2t5LmNvCi0tPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PCFbQ0RBVEFbI2hvbGRlcl8xNjhkYzdkNTlkMyB0ZXh0IHsgZmlsbDojQUFBQUFBO2ZvbnQtd2VpZ2h0OmJvbGQ7Zm9udC1mYW1pbHk6QXJpYWwsIEhlbHZldGljYSwgT3BlbiBTYW5zLCBzYW5zLXNlcmlmLCBtb25vc3BhY2U7Zm9udC1zaXplOjEwcHQgfSBdXT48L3N0eWxlPjwvZGVmcz48ZyBpZD0iaG9sZGVyXzE2OGRjN2Q1OWQzIj48cmVjdCB3aWR0aD0iMTQwIiBoZWlnaHQ9IjE0MCIgZmlsbD0iI0VFRUVFRSIvPjxnPjx0ZXh0IHg9IjQ0LjA0MTY2NjAzMDg4Mzc5IiB5PSI3NC41NTk5OTk5NDI3Nzk1NCI+MTQweDE0MDwvdGV4dD48L2c+PC9nPjwvc3ZnPg=="></td><td><a ui-sref="student.editStudent({studentId:student.id})">{{student.name}}</a></td><td>{{student.rollNo}}</td><td>{{student.className}}</td><td>{{student.sectionName}}</td><td>{{student.shiftName}}</td></tr></tbody></table><div class="row text-center" ng-if="vm.studentList.length == 0"><b>No Data Found</b></div></div></div>');
$templateCache.put('app/pages/main/student/monthlyAttendance/studentMonthlyAttendance.html','<div ba-panel="" ba-panel-title="{{\'studentsMonthlyAttendance\' |translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'btn btn-default btn-sm pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-right\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-down\'></i> </span>" ba-panel-class="with-scroll"><div class="row text-center" ng-if="vm.dataLoaded == false"><div class="bar-loader"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div><div class="bar4"></div><div class="bar5"></div><div class="bar6"></div></div></div><div class="row form-inline filter-div" ng-show="vm.showFilters"><div class="form-group col-md-12"><div class="col-md-4"><select class="form-control" ng-model="vm.selectedClass" ng-options="class.name for class in vm.classList track by class.id"><option value="" disabled="" selected="">Select Class</option></select></div><div class="col-md-4"><select class="form-control" ng-model="vm.selectedSection" ng-options="section.name for section in vm.sectionList track by section.id"><option value="" disabled="" selected="">Select Section</option></select></div><div class="col-md-4"><select class="form-control" ng-model="vm.selectedShift" ng-options="shift.name for shift in vm.shiftList track by shift.id"><option value="" disabled="" selected="">Select Shift</option></select></div></div><div class="form-group col-md-12"><div class="col-md-4"><input class="form-control" type="text" placeholder="Student Name" ng-model="vm.studentName"></div><div class="col-md-4"><input type="text" ng-model="vm.filterYear" class="form-control" id="filterYear" uib-datepicker-popup="yyyy" is-open="filterYear.opened" datepicker-options="dateOptions" ng-required="true" ng-click="filterYear()"></div><div class="col-md-4"><input type="text" ng-model="vm.filterMonth" class="form-control" id="filterMonth" uib-datepicker-popup="MM" is-open="filterMonth.opened" datepicker-options="dateOptions" ng-required="true" ng-click="filterMonth()"></div></div><div class="form-group col-md-12"><div class="col-md-4 col-md-offset-8"><button type="button" class="btn btn-primary btn-with-icon" style="width: 49%;" ng-click="vm.filterAttendances()"><i class="ion-search"></i>Filter</button> <button type="button" class="btn btn-default btn-with-icon pull-right" style="width: 49%;" ng-click="vm.clearFilter()"><i class="ion-close"></i>Clear Filter</button></div></div></div><div ng-if="vm.dataLoaded == true"><table class="table table-bordered" ng-if="vm.studentList.length > 0 && vm.dataLoaded == true"><thead><th colspan="6" translate="">{{\'studentsInformation\'}}</th><th colspan="{{vm.monthlyDates.length}}" class="text-center">{{vm.filterFrom | date: "MMMM yyyy"}}</th><th colspan="3" class="text-center" translate="">{{\'summary\'}}</th></thead><thead><th>#</th><th translate="">{{\'studentsName\'}}</th><th translate="">{{\'rollNumber\'}}</th><th translate="">{{\'class\'}}</th><th translate="">{{\'SECTION\'}}</th><th translate="">{{\'shift\'}}</th><th class="text-center" ng-repeat="d in vm.monthlyDates">{{$index+1}}</th><th class="text-center text-success" translate="">{{\'present\'}}</th><th class="text-center text-warning" translate="">{{\'late\'}}</th><th class="text-center text-danger" translate="">{{\'absent\'}}</th></thead><tbody><tr ng-repeat="student in vm.studentList"><td>{{$index+1}}</td><td>{{student.personName}}</td><td>{{student.rollNo}}</td><td>{{student.className}}</td><td>{{student.sectionName}}</td><td>{{student.shiftName}}</td><td class="text-center" ng-repeat="d in student.attendance.slice().reverse()"><span ng-if="d.isOffday" class="text-greyed">FRI</span> <span ng-if="!d.isOffday && d.isHoliday" class="text-greyed">HOL</span> <span ng-if="!d.isOffday && !d.isHoliday && !d.isPresent" class="text-danger">A</span> <span ng-if="d.isPresent && d.isLate" class="text-warning">L</span> <span ng-if="d.isPresent && !d.isLate" class="text-success">P</span></td><td class="text-center">{{student[\'summary\'][\'totalPresent\']}}</td><td class="text-center">{{student[\'summary\'][\'totalLateEntry\']}}</td><td class="text-center">{{student[\'summary\'][\'totalAbsent\']}}</td></tr></tbody></table><div class="row text-center" ng-if="vm.studentList.length == 0"><b>No Data Found</b></div></div></div>');
$templateCache.put('app/pages/main/notice/delete/delete.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to delete the notice <em class="text-warning">{{vm.notice.subject}}</em> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deleteNotice()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/notice/noticeImageUploadModal/noticeImageUpload.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Upload Notice Picture</h4></div><form name="picUploadForm"><div class="modal-body"><div style="text-align: center"><div ng-show="!vm.isFileSelected" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;"><img ng-src="{{vm.currentNoticePicURL}}" width="100%"></div><div ngf-drop="" ng-model="picFile" ngf-pattern="image/*" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;" ng-show="vm.isFileSelected"><img-crop image="picFile | ngfDataUrl" result-image="croppedDataUrl" ng-init="croppedDataUrl=\'\'" area-type="square"></img-crop></div><button ngf-select="" ng-model="picFile" accept="image/*" class="btn btn-default btn-with-icon" style="margin-top: 10px; margin-bottom: 10px" ngf-change="vm.fileSelected()"><i class="ion-images"></i>Select Image</button><div><img ng-src="{{croppedDataUrl}}"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.uploadNoticePicture(croppedDataUrl, picFile.name)" ng-if="vm.isFileSelected">Upload</button></div></form></div>');
$templateCache.put('app/pages/main/academics/shift/shift.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll"><h3 class="panel-title bottom">Create Shift</h3><div class="row bottom"><div class="col-md-12"><input class="form-control" type="text" ng-model="vm.name" placeholder="Shift Name"></div></div><div class="row bottom"><div class="col-md-6"><div style="margin-left: 110px"><label for="from">{{\'shiftFrom\'|translate}}</label></div><div style="margin-left: 55px" id="from" uib-timepicker="" ng-model="vm.fromTime" hour-step="vm.hstep" minute-step="vm.mstep"></div></div><div class="col-md-6"><div style="margin-left: 55px"><label for="to" translate="">{{\'shiftTo\'|translate}}</label></div><div id="to" uib-timepicker="" ng-model="vm.toTime" hour-step="vm.hstep" minute-step="vm.mstep"></div></div></div><div class="row"><div class="col-md-8"></div><div class="col-md-4"><button class="btn btn-primary btn-block" ng-click="vm.createShift()">Create</button></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll"><h3 class="panel-title bottom">{{\'allShifts\'|translate}}</h3><table class="table table-bordered"><col width="10%"><col width="40%"><col width="15%"><col width="15%"><thead><th>#</th><th class="text-center">{{\'name\'|translate}}</th><th class="text-center">{{\'shiftFrom\'|translate}}</th><th class="text-center">{{\'shiftTo\'|translate}}</th><th class="text-center">{{\'actions\'|translate}}</th></thead><tbody><tr ng-repeat="shift in vm.shiftList"><td>{{$index+1}}</td><td>{{shift.name}}</td><td>{{shift.start | date: \'hh:mm a\'}}</td><td>{{shift.end | date: \'hh:mm a\'}}</td><td class="text-center"><i class="ion-android-create tableIcons" ng-click="vm.openEditModal(shift)"></i> <i class="ion-trash-b tableIcons" ng-click="vm.openDeleteModal(shift)"></i></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/main/academics/class/configure/configure.html','<div class="row" ng-controller="ConfigureClassCtrl as vm"><div class="col-md-12"><div><div ba-panel="" ba-panel-class="with-scroll"><h3 class="panel-title bottom">{{\'configureClass\'|translate}}</h3><select style="margin-bottom: 7px" class="form-control" ng-model="vm.selectedClass" ng-options="class.name for class in vm.classList track by class.id"><option value="" disabled="" selected="">Select Class</option></select><select style="margin-bottom: 7px" class="form-control" ng-model="vm.selectedSection" ng-options="section.name for section in vm.sectionList track by section.id"><option value="" disabled="" selected="">Select Section</option></select><select style="margin-bottom: 7px" class="form-control" ng-model="vm.selectedShift" ng-options="shift.name for shift in vm.shiftList track by shift.id"><option value="" disabled="" selected="">Select Shift</option></select><input class="form-control bottom" type="text" ng-model="vm.name" placeholder="Name"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><button class="btn btn-primary btn-block" ng-click="vm.createCssAssoc()">Create</button></div></div></div></div></div><div class="col-md-12"><div><div ba-panel="" ba-panel-class="with-scroll"><h3 class="panel-title bottom">{{\'configuredClasses\'|translate}}</h3><table class="table table-bordered"><col width="10%"><col width="30%"><col width="20%"><col width="20%"><col width="15%"><col width="5%"><thead><th class="text-left">#</th><th class="text-left">{{\'name\'|translate}}</th><th class="text-left">{{\'class\'|translate}}</th><th class="text-left">{{\'section\'|translate}}</th><th class="text-left">{{\'shift\'|translate}}</th><th class="text-center">{{\'actions\'|translate}}</th></thead><tbody ng-repeat="assoc in vm.assocList"><td class="text-left">{{$index+1}}</td><td class="text-left">{{assoc.name}}</td><td class="text-left">{{assoc.objClass.name}}</td><td class="text-left">{{assoc.section.name}}</td><td class="text-left">{{assoc.shift.name}}</td><td class="text-center"><i class="ion-trash-b tableIcons" ng-click="vm.openDeleteModal(assoc)"></i></td></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/main/academics/class/delete/delete.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to delete <em>{{vm.class.name}}</em> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deleteClass()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/academics/section/delete/delete.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to delete <em>{{vm.section.name}}</em> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deleteClass()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/school/batchCreate/create/batchCreate.html','<style>\n    .red{\n        text-decoration-color: red!important;\n    }\n    .blue{\n        text-decoration-color: blue!important;\n    }\n</style><div ng-controller="BatchSchoolCreateCtrl as vm"><div class="row" style="padding-bottom: 10px;"><div class="col-md-8"><h3 class="with-line">School Creation Guidelines</h3><ul style="line-height: 25px"><li>No gaps are allowed between rows. Rows after gap wont be counted.</li><li><span style="color: red">Uploaded Excel file must be xls or xlsx only</span></li><li>Uploaded Excel file has to maintain the column ordering of the sample excel file</li><li>Can not upload more than 200 schools at a time. Rows after first 200 will be ignored if any.</li></ul><h3 class="with-line">Download Sample</h3><div class="row text-center"><div class="col-md-4"><button class="btn btn-info btn-block" ng-click="vm.redirectToDownloadSamplePage()">Download Sample</button></div></div><h3 class="with-line">Upload File</h3><div class="row"><div class="col-md-8"><input class="align" type="file" ngf-select="" ng-model="vm.file" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.xls,.xlsx\'"></div></div><div class="row" style="margin-bottom: 20px"><div class="col-md-3"><button ng-disabled="vm.file == null" ng-class="vm.file == null ? \'btn btn-greyed btn-block\' : \'btn btn-primary btn-block\'" ng-click="vm.batchCreateSchools()">Upload <span ng-show="!vm.batchCreationDone" class="fa fa-cog fa-spin fa-fw"></span></button></div></div></div><div class="col-md-4"><h3 class="with-line">Reseller List</h3><table class="table table-bordered"><thead><tr><th>Reseller Id</th><th>Reseller Name</th></tr></thead><tbody><tr ng-repeat="reseller in vm.resellerList"><td style="height: 20px;">{{reseller.id}}</td><td style="height: 20px;">{{reseller.name}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/main/school/batchCreate/history/history.html','<style>\n    td{\n        height: 50px;\n    }\n</style><div ng-controller="SchoolCreationHistoryCtrl as vm"><h3 class="with-line">Batch Creation History</h3><table class="table table-bordered" ng-if="vm.requests.length > 0" style="margin-bottom: 20px"><thead><th>Name</th><th>Code</th><th>Address</th><th>Email</th><th>Status</th><th>Action</th></thead><tr ng-repeat="request in vm.requests"><td>{{request.name}}</td><td>{{request.code}}</td><td>{{request.address}}</td><td>{{request.email}}</td><td ng-if="request.status==0" style="color:blueviolet"><strong>Pending</strong></td><td ng-if="request.status==-1" style="color:red"><strong>Failed</strong></td><td ng-if="request.status==1" style="color:green"><strong>Done</strong></td><td class="text-center"><button class="btn btn-info btn-block" ng-disabled="vm.getDisabled(request)" style="margin: 0 auto" ng-click="vm.retry($index,request.id)">Retry</button></td></tr></table><div class="row text-center" style="margin-bottom: 20px" ng-if="vm.requests.length == 0"><i>No Batch Creation History found</i></div></div>');
$templateCache.put('app/pages/main/leave/list/delete/leaveDelete.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><br><br><p>Are you sure you want to delete the leave?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deleteLeave()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/teacher/batchCreate/create/batchCreate.html','<style>\n    .red{\n        text-decoration-color: red!important;\n    }\n    .blue{\n        text-decoration-color: blue!important;\n    }\n</style><div ng-controller="BatchCreateCtrl as vm"><h3 class="with-line">Teacher Creation Guidelines</h3><ul style="line-height: 25px"><li>No gaps are allowed between rows. Rows after gap wont be counted.</li><li><span style="color: red">Uploaded Excel file must be xls or xlsx only</span></li><li>Uploaded Excel file has to maintain the column ordering of the sample excel file</li><li>Can not upload more than 200 employees at a time. Rows after first 200 will be ignored if any.</li><li>Primary and Secondary Display Text can not be more than 10 characters</li></ul><h3 class="with-line">Download Sample</h3><div class="row text-center"><div class="col-md-4"><button class="btn btn-info btn-block" ng-click="vm.redirectToDownloadSamplePage()">Download Sample</button></div></div><h3 class="with-line">Upload File</h3><div class="row"><div class="col-md-8"><input class="align" type="file" ngf-select="" ng-model="vm.file" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.xls,.xlsx\'"></div></div><div class="row" style="margin-bottom: 20px"><div class="col-md-3"><button ng-disabled="vm.file == null" ng-class="vm.file == null ? \'btn btn-greyed btn-block\' : \'btn btn-primary btn-block\'" ng-click="vm.batchCreateTeachers()">Upload <span ng-show="!vm.batchCreationDone" class="fa fa-cog fa-spin fa-fw"></span></button></div></div></div>');
$templateCache.put('app/pages/main/teacher/batchCreate/history/history.html','<style>\n    td{\n        height: 50px;\n    }\n</style><div ng-controller="HistoryCtrl as vm"><h3 class="with-line">Batch Creation History</h3><table class="table table-bordered" ng-if="vm.requests.length > 0" style="margin-bottom: 20px"><thead><th>Name</th><th>Contact</th><th>RFID</th><th>Primary Text</th><th>Secondary Text</th><th>Status</th><th>Action</th></thead><tr ng-repeat="request in vm.requests"><td>{{request.name}}</td><td>{{request.contactNo}}</td><td>{{request.rfid}}</td><td>{{request.primaryText}}</td><td>{{request.secondaryText}}</td><td ng-if="request.status==0" style="color:blueviolet"><strong>Pending</strong></td><td ng-if="request.status==-1" style="color:red"><strong>Failed</strong></td><td ng-if="request.status==1" style="color:green"><strong>Done</strong></td><td class="text-center"><button class="btn btn-info btn-block" ng-disabled="vm.getDisabled(request)" style="margin: 0 auto" ng-click="vm.retry($index,request.id)">Retry</button></td></tr></table><div class="row text-center" style="margin-bottom: 20px" ng-if="vm.requests.length == 0"><i>No Batch Creation History found</i></div></div>');
$templateCache.put('app/pages/main/teacher/create/teacherPictureUploadModal/teacherPictureUpload.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">{{\'uploadTeacherImage\'}}</h4></div><form name="picUploadForm"><div class="modal-body"><div style="text-align: center"><div ng-show="!vm.isFileSelected" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;"><img ng-src="{{vm.currentPicURL}}" width="100%"></div><div ngf-drop="" ng-model="picFile" ngf-pattern="image/*" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;" ng-show="vm.isFileSelected"><img-crop image="picFile | ngfDataUrl" result-image="croppedDataUrl" ng-init="croppedDataUrl=\'\'" area-type="square"></img-crop></div><button ngf-select="" ng-model="picFile" accept="image/*" class="btn btn-default btn-with-icon" style="margin-top: 10px; margin-bottom: 10px" ngf-change="vm.fileSelected()"><i class="ion-images"></i>{{\'selectImage\'|translate}}</button><div><img ng-src="{{croppedDataUrl}}"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.uploadTeacherPicture(croppedDataUrl, picFile.name)" ng-if="vm.isFileSelected">{{\'upload\'|translate}}</button></div></form></div>');
$templateCache.put('app/pages/main/teacher/edit/teacherPictureUploadModal/teacherPictureUpload.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">{{\'uploadTeacherImage\'}}</h4></div><form name="picUploadForm"><div class="modal-body"><div style="text-align: center"><div ng-show="!vm.isFileSelected" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;"><img ng-src="{{vm.currentPicURL}}" width="100%"></div><div ngf-drop="" ng-model="picFile" ngf-pattern="image/*" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;" ng-show="vm.isFileSelected"><img-crop image="picFile | ngfDataUrl" result-image="croppedDataUrl" ng-init="croppedDataUrl=\'\'" area-type="square"></img-crop></div><button ngf-select="" ng-model="picFile" accept="image/*" class="btn btn-default btn-with-icon" style="margin-top: 10px; margin-bottom: 10px" ngf-change="vm.fileSelected()"><i class="ion-images"></i>{{\'selectImage\'|translate}}</button><div><img ng-src="{{croppedDataUrl}}"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.uploadTeacherPicture(croppedDataUrl, picFile.name)" ng-if="vm.isFileSelected">{{\'upload\'|translate}}</button></div></form></div>');
$templateCache.put('app/pages/main/teacher/list/delete/teacherDelete.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><br><br><p>Are you sure you want to delete {{vm.teacherToDelete.name}} ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deleteTeacher()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/student/create/profileImageUploadModal/profileImageUpload.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Upload Notice Picture</h4></div><form name="picUploadForm"><div class="modal-body"><div style="text-align: center"><div ng-show="!vm.isFileSelected" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;"><img ng-src="{{vm.currentProfilePicURL}}" width="100%"></div><div ngf-drop="" ng-model="picFile" ngf-pattern="image/*" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;" ng-show="vm.isFileSelected"><img-crop image="picFile | ngfDataUrl" result-image="croppedDataUrl" ng-init="croppedDataUrl=\'\'" area-type="square"></img-crop></div><button ngf-select="" ng-model="picFile" accept="image/*" class="btn btn-default btn-with-icon" style="margin-top: 10px; margin-bottom: 10px" ngf-change="vm.fileSelected()"><i class="ion-images"></i>Select Image</button><div><img ng-src="{{croppedDataUrl}}"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.uploadProfilePicture(croppedDataUrl, picFile.name)" ng-if="vm.isFileSelected">Upload</button></div></form></div>');
$templateCache.put('app/pages/main/student/edit/studentPictureUploadModal/studentPictureUpload.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Upload Notice Picture</h4></div><form name="picUploadForm"><div class="modal-body"><div style="text-align: center"><div ng-show="!vm.isFileSelected" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;"><img ng-src="{{vm.currentPicURL}}" width="100%"></div><div ngf-drop="" ng-model="picFile" ngf-pattern="image/*" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;" ng-show="vm.isFileSelected"><img-crop image="picFile | ngfDataUrl" result-image="croppedDataUrl" ng-init="croppedDataUrl=\'\'" area-type="square"></img-crop></div><button ngf-select="" ng-model="picFile" accept="image/*" class="btn btn-default btn-with-icon" style="margin-top: 10px; margin-bottom: 10px" ngf-change="vm.fileSelected()"><i class="ion-images"></i>Select Image</button><div><img ng-src="{{croppedDataUrl}}"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.uploadNoticePicture(croppedDataUrl, picFile.name)" ng-if="vm.isFileSelected">Upload</button></div></form></div>');
$templateCache.put('app/pages/main/academics/shift/edit/edit.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit Shift<hr></h4></div><div class="modal-body"><div class="row bottom"><div class="col-md-12"><label for="name">Name</label> <input id="name" class="form-control" type="text" ng-model="vm.shift.name" placeholder="Shift Name"></div></div><div class="row bottom"><div class="col-md-6"><div style="margin-left: 110px"><label for="from">Start</label></div><div style="margin-left: 55px" id="from" uib-timepicker="" ng-model="vm.fromTime" hour-step="vm.hstep" minute-step="vm.mstep"></div></div><div class="col-md-6"><div style="margin-left: 55px"><label for="to">End</label></div><div id="to" uib-timepicker="" ng-model="vm.toTime" hour-step="vm.hstep" minute-step="vm.mstep"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.editShift()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/academics/shift/delete/delete.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to delete <em>{{vm.shift.name}}</em> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deleteShift()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/academics/class/configure/deleteAssoc/deleteAssoc.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to delete configuration <em>{{vm.assoc.name}}</em> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deleteAssoc()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');}]);